import "@mescius/wijmo.styles/wijmo-core.css";
import "primeicons/primeicons.css";
import "splitpanes/dist/splitpanes.css";
import { Aggregate, Aggregate as Aggregate$1, CollectionViewGroup, CollectionViewGroup as CollectionViewGroup$1, Control, DataType, DataType as DataType$1, Event as Event$1, Globalize, GroupDescription, NotifyCollectionChangedAction, NotifyCollectionChangedAction as NotifyCollectionChangedAction$1, NotifyCollectionChangedEventArgs, ObservableArray, ObservableArray as ObservableArray$1, PropertyGroupDescription, PropertyGroupDescription as PropertyGroupDescription$1, SortDescription, SortDescription as SortDescription$1, Tooltip, asNumber, clamp, culture, setLicenseKey } from "@mescius/wijmo";
import { CellRange, CellType, FlexGrid as DatagridInstance, GroupRow, MergeManager, Row } from "@mescius/wijmo.grid";
import { VList as VirtualRepeat } from "virtua/vue";
import { Fragment, Teleport, Transition, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineComponent, getCurrentInstance, h, inject, isMemoSame, isRef, mergeDefaults, mergeModels, mergeProps, nextTick, normalizeClass, normalizeStyle, onBeforeUnmount, onMounted, onScopeDispose, onUnmounted, openBlock, provide, reactive, ref, render, renderList, renderSlot, resolveComponent, resolveDynamicComponent, shallowRef, toDisplayString, toRef, unref, useModel, useSlots, useTemplateRef, vModelCheckbox, vShow, watch, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import { CharacterCasing, ResourceManager, WhiteSpaceHandling, addDays, createGuid, getPropertyByPath, getSimplifiedDateFormat, parseSimplifiedDate, setPropertyByPath, setTimeOfDay, stringFormat, toCamelCase, toPascalCase, twoDigitYearMax } from "@neos/shared";
import { onClickOutside, reactiveComputed, useCurrentElement, useDebounceFn, useElementBounding, useElementSize, useEventBus, useEventListener, useFocus, useIntersectionObserver, useSpeechRecognition, useVModel, useWindowSize } from "@vueuse/core";
import PrimeBadge from "primevue/badge";
import PrimeSelect from "primevue/select";
import PrimeButton from "primevue/button";
import PrimePopover from "primevue/popover";
import PrimeDialog from "primevue/dialog";
import Carousel from "primevue/carousel";
import annotationPlugin from "chartjs-plugin-annotation";
import PrimeChip from "primevue/chip";
import { WjFlexGrid, WjFlexGridCellTemplate, WjFlexGridCellTemplateDefinition, WjFlexGridColumn } from "@mescius/wijmo.vue2.grid";
import { WjFlexGridDetail } from "@mescius/wijmo.vue2.grid.detail";
import { DetailRow } from "@mescius/wijmo.grid.detail";
import { ZIndex } from "@primeuix/utils";
import { saveAs } from "file-saver";
import PrimeContextMenu from "primevue/contextmenu";
import { WjInputColor, WjInputMask, WjInputNumber, WjInputTime, WjListBox } from "@mescius/wijmo.vue2.input";
import { WjGroupPanel } from "@mescius/wijmo.vue2.grid.grouppanel";
import Lottie from "lottie-web/build/player/lottie_light";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import PrimeDivider from "primevue/divider";
import PrimeMenu from "primevue/tieredmenu";
import PrimeSelectButton from "primevue/selectbutton";
import PrimePanel from "primevue/panel";
import DOMPurify from "dompurify";
import PrimeDatePicker, { default as PrimeDatePicker$1 } from "primevue/datepicker";
import PrimePassword from "primevue/password";
import PrimeMultiSelect from "primevue/multiselect";
import PrimeProgressBar from "primevue/progressbar";
import { Pane, Splitpanes } from "splitpanes";
import PrimeTimeline from "primevue/timeline";
import PrimeToast from "primevue/toast";
import { useToast as useToast$1 } from "primevue/usetoast";
import PrimeVue, { usePrimeVue } from "primevue/config";
import ToastService from "primevue/toastservice";
import Tooltip$1 from "primevue/tooltip";
//#region src/composables/useComponentAutomationProperties.ts
var automationMode = false;
function isAutomationMode() {
	return automationMode;
}
function setAutomationMode(value = true) {
	automationMode = value;
}
/**
* Set __neosComponent DOM variable if the application is started in automation mode (url parameters contains automation=true)
*/
function useComponentAutomationProperties(element, name) {
	if (!automationMode) return;
	name ??= getComponentName();
	if (!name) return;
	element ??= useCurrentElement();
	watch(element, (value) => {
		const el = value && getComponentElement(value);
		if (el) el.__neosComponent = name;
	});
}
function getComponentName() {
	const instance = getCurrentInstance();
	if (!instance) return;
	return instance.type.name ?? instance.type.__name;
}
function getComponentElement(element) {
	return element instanceof HTMLElement ? element : element.$el;
}
//#endregion
//#region src/composables/useImages.ts
function provideImages(images) {
	provide("images", images);
	return images;
}
function useImages() {
	return inject("images", {});
}
//#endregion
//#region src/composables/useThemeManager.ts
function provideThemeManager(themeManager) {
	provide("themeManager", themeManager);
	return themeManager;
}
function useThemeManager(throwError = true) {
	const themeManager = inject("themeManager", void 0);
	if (!themeManager && throwError) throw new Error("ThemeManager not provided");
	return themeManager;
}
//#endregion
//#region src/components/Image/standardImages.ts
var countryImages = {
	flagAD: {
		class: "i-twemoji-flag-andorra",
		colored: true
	},
	flagAE: {
		class: "i-twemoji-flag-united-arab-emirates",
		colored: true
	},
	flagAF: {
		class: "i-twemoji-flag-afghanistan",
		colored: true
	},
	flagAI: {
		class: "i-twemoji-flag-anguilla",
		colored: true
	},
	flagAL: {
		class: "i-twemoji-flag-albania",
		colored: true
	},
	flagAM: {
		class: "i-twemoji-flag-armenia",
		colored: true
	},
	flagAO: {
		class: "i-twemoji-flag-angola",
		colored: true
	},
	flagAR: {
		class: "i-twemoji-flag-argentina",
		colored: true
	},
	flagAS: {
		class: "i-twemoji-flag-american-samoa",
		colored: true
	},
	flagAT: {
		class: "i-twemoji-flag-austria",
		colored: true
	},
	flagAU: {
		class: "i-twemoji-flag-australia",
		colored: true
	},
	flagAW: {
		class: "i-twemoji-flag-aruba",
		colored: true
	},
	flagAZ: {
		class: "i-twemoji-flag-azerbaijan",
		colored: true
	},
	flagBB: {
		class: "i-twemoji-flag-barbados",
		colored: true
	},
	flagBD: {
		class: "i-twemoji-flag-bangladesh",
		colored: true
	},
	flagBE: {
		class: "i-twemoji-flag-belgium",
		colored: true
	},
	flagBF: {
		class: "i-twemoji-flag-burkina-faso",
		colored: true
	},
	flagBG: {
		class: "i-twemoji-flag-bulgaria",
		colored: true
	},
	flagBH: {
		class: "i-twemoji-flag-bahrain",
		colored: true
	},
	flagBI: {
		class: "i-twemoji-flag-burundi",
		colored: true
	},
	flagBJ: {
		class: "i-twemoji-flag-benin",
		colored: true
	},
	flagBM: {
		class: "i-twemoji-flag-bermuda",
		colored: true
	},
	flagBN: {
		class: "i-twemoji-flag-brunei",
		colored: true
	},
	flagBO: {
		class: "i-twemoji-flag-bolivia",
		colored: true
	},
	flagBR: {
		class: "i-twemoji-flag-brazil",
		colored: true
	},
	flagBS: {
		class: "i-twemoji-flag-bahamas",
		colored: true
	},
	flagBT: {
		class: "i-twemoji-flag-bhutan",
		colored: true
	},
	flagBW: {
		class: "i-twemoji-flag-botswana",
		colored: true
	},
	flagBY: {
		class: "i-twemoji-flag-belarus",
		colored: true
	},
	flagBZ: {
		class: "i-twemoji-flag-belize",
		colored: true
	},
	flagCA: {
		class: "i-twemoji-flag-canada",
		colored: true
	},
	flagCF: {
		class: "i-twemoji-flag-central-african-republic",
		colored: true
	},
	flagCH: {
		class: "i-twemoji-flag-switzerland",
		colored: true
	},
	flagCK: {
		class: "i-twemoji-flag-cook-islands",
		colored: true
	},
	flagCL: {
		class: "i-twemoji-flag-chile",
		colored: true
	},
	flagCM: {
		class: "i-twemoji-flag-cameroon",
		colored: true
	},
	flagCN: {
		class: "i-twemoji-flag-china",
		colored: true
	},
	flagCO: {
		class: "i-twemoji-flag-colombia",
		colored: true
	},
	flagCR: {
		class: "i-twemoji-flag-costa-rica",
		colored: true
	},
	flagCU: {
		class: "i-twemoji-flag-cuba",
		colored: true
	},
	flagCX: {
		class: "i-twemoji-flag-christmas-island",
		colored: true
	},
	flagCY: {
		class: "i-twemoji-flag-cyprus",
		colored: true
	},
	flagCZ: {
		class: "i-twemoji-flag-czechia",
		colored: true
	},
	flagDE: {
		class: "i-twemoji-flag-germany",
		colored: true
	},
	flagDJ: {
		class: "i-twemoji-flag-djibouti",
		colored: true
	},
	flagDK: {
		class: "i-twemoji-flag-denmark",
		colored: true
	},
	flagDM: {
		class: "i-twemoji-flag-dominica",
		colored: true
	},
	flagDO: {
		class: "i-twemoji-flag-dominican-republic",
		colored: true
	},
	flagDZ: {
		class: "i-twemoji-flag-algeria",
		colored: true
	},
	flagEC: {
		class: "i-twemoji-flag-ecuador",
		colored: true
	},
	flagEE: {
		class: "i-twemoji-flag-estonia",
		colored: true
	},
	flagEG: {
		class: "i-twemoji-flag-egypt",
		colored: true
	},
	flagER: {
		class: "i-twemoji-flag-eritrea",
		colored: true
	},
	flagES: {
		class: "i-twemoji-flag-spain",
		colored: true
	},
	flagET: {
		class: "i-twemoji-flag-ethiopia",
		colored: true
	},
	flagFI: {
		class: "i-twemoji-flag-finland",
		colored: true
	},
	flagFJ: {
		class: "i-twemoji-flag-fiji",
		colored: true
	},
	flagFK: {
		class: "i-twemoji-flag-falkland-islands",
		colored: true
	},
	flagFM: {
		class: "i-twemoji-flag-micronesia",
		colored: true
	},
	flagFO: {
		class: "i-twemoji-flag-faroe-islands",
		colored: true
	},
	flagFR: {
		class: "i-twemoji-flag-france",
		colored: true
	},
	flagGA: {
		class: "i-twemoji-flag-gabon",
		colored: true
	},
	flagGB: {
		class: "i-twemoji-flag-united-kingdom",
		colored: true
	},
	flagGD: {
		class: "i-twemoji-flag-grenada",
		colored: true
	},
	flagGE: {
		class: "i-twemoji-flag-georgia",
		colored: true
	},
	flagGF: {
		class: "i-twemoji-flag-french-guiana",
		colored: true
	},
	flagGG: {
		class: "i-twemoji-flag-guernsey",
		colored: true
	},
	flagGH: {
		class: "i-twemoji-flag-ghana",
		colored: true
	},
	flagGI: {
		class: "i-twemoji-flag-gibraltar",
		colored: true
	},
	flagGL: {
		class: "i-twemoji-flag-greenland",
		colored: true
	},
	flagGM: {
		class: "i-twemoji-flag-gambia",
		colored: true
	},
	flagGN: {
		class: "i-twemoji-flag-guinea",
		colored: true
	},
	flagGP: {
		class: "i-twemoji-flag-guadeloupe",
		colored: true
	},
	flagGQ: {
		class: "i-twemoji-flag-equatorial-guinea",
		colored: true
	},
	flagGR: {
		class: "i-twemoji-flag-greece",
		colored: true
	},
	flagGT: {
		class: "i-twemoji-flag-guatemala",
		colored: true
	},
	flagGU: {
		class: "i-twemoji-flag-guam",
		colored: true
	},
	flagGW: {
		class: "i-twemoji-flag-guinea-bissau",
		colored: true
	},
	flagGY: {
		class: "i-twemoji-flag-guyana",
		colored: true
	},
	flagHN: {
		class: "i-twemoji-flag-honduras",
		colored: true
	},
	flagHR: {
		class: "i-twemoji-flag-croatia",
		colored: true
	},
	flagHT: {
		class: "i-twemoji-flag-haiti",
		colored: true
	},
	flagHU: {
		class: "i-twemoji-flag-hungary",
		colored: true
	},
	flagID: {
		class: "i-twemoji-flag-indonesia",
		colored: true
	},
	flagIE: {
		class: "i-twemoji-flag-ireland",
		colored: true
	},
	flagIL: {
		class: "i-twemoji-flag-israel",
		colored: true
	},
	flagIM: {
		class: "i-twemoji-flag-isle-of-man",
		colored: true
	},
	flagIN: {
		class: "i-twemoji-flag-india",
		colored: true
	},
	flagIO: {
		class: "i-twemoji-flag-british-indian-ocean-territory",
		colored: true
	},
	flagIQ: {
		class: "i-twemoji-flag-iraq",
		colored: true
	},
	flagIR: {
		class: "i-twemoji-flag-iran",
		colored: true
	},
	flagIS: {
		class: "i-twemoji-flag-iceland",
		colored: true
	},
	flagIT: {
		class: "i-twemoji-flag-italy",
		colored: true
	},
	flagJE: {
		class: "i-twemoji-flag-jersey",
		colored: true
	},
	flagJM: {
		class: "i-twemoji-flag-jamaica",
		colored: true
	},
	flagJO: {
		class: "i-twemoji-flag-jordan",
		colored: true
	},
	flagJP: {
		class: "i-twemoji-flag-japan",
		colored: true
	},
	flagKE: {
		class: "i-twemoji-flag-kenya",
		colored: true
	},
	flagKG: {
		class: "i-twemoji-flag-kyrgyzstan",
		colored: true
	},
	flagKH: {
		class: "i-twemoji-flag-cambodia",
		colored: true
	},
	flagKI: {
		class: "i-twemoji-flag-kiribati",
		colored: true
	},
	flagKM: {
		class: "i-twemoji-flag-comoros",
		colored: true
	},
	flagKP: {
		class: "i-twemoji-flag-north-korea",
		colored: true
	},
	flagKW: {
		class: "i-twemoji-flag-kuwait",
		colored: true
	},
	flagKY: {
		class: "i-twemoji-flag-cayman-islands",
		colored: true
	},
	flagKZ: {
		class: "i-twemoji-flag-kazakhstan",
		colored: true
	},
	flagLA: {
		class: "i-twemoji-flag-laos",
		colored: true
	},
	flagLB: {
		class: "i-twemoji-flag-lebanon",
		colored: true
	},
	flagLI: {
		class: "i-twemoji-flag-liechtenstein",
		colored: true
	},
	flagLK: {
		class: "i-twemoji-flag-sri-lanka",
		colored: true
	},
	flagLR: {
		class: "i-twemoji-flag-liberia",
		colored: true
	},
	flagLS: {
		class: "i-twemoji-flag-lesotho",
		colored: true
	},
	flagLT: {
		class: "i-twemoji-flag-lithuania",
		colored: true
	},
	flagLU: {
		class: "i-twemoji-flag-luxembourg",
		colored: true
	},
	flagLV: {
		class: "i-twemoji-flag-latvia",
		colored: true
	},
	flagLY: {
		class: "i-twemoji-flag-libya",
		colored: true
	},
	flagMA: {
		class: "i-twemoji-flag-morocco",
		colored: true
	},
	flagMC: {
		class: "i-twemoji-flag-monaco",
		colored: true
	},
	flagMD: {
		class: "i-twemoji-flag-moldova",
		colored: true
	},
	flagME: {
		class: "i-twemoji-flag-montenegro",
		colored: true
	},
	flagMG: {
		class: "i-twemoji-flag-madagascar",
		colored: true
	},
	flagMH: {
		class: "i-twemoji-flag-marshall-islands",
		colored: true
	},
	flagMK: {
		class: "i-twemoji-flag-north-macedonia",
		colored: true
	},
	flagML: {
		class: "i-twemoji-flag-mali",
		colored: true
	},
	flagMN: {
		class: "i-twemoji-flag-mongolia",
		colored: true
	},
	flagMP: {
		class: "i-twemoji-flag-northern-mariana-islands",
		colored: true
	},
	flagMQ: {
		class: "i-twemoji-flag-martinique",
		colored: true
	},
	flagMR: {
		class: "i-twemoji-flag-mauritania",
		colored: true
	},
	flagMS: {
		class: "i-twemoji-flag-montserrat",
		colored: true
	},
	flagMT: {
		class: "i-twemoji-flag-malta",
		colored: true
	},
	flagMU: {
		class: "i-twemoji-flag-mauritius",
		colored: true
	},
	flagMV: {
		class: "i-twemoji-flag-maldives",
		colored: true
	},
	flagMW: {
		class: "i-twemoji-flag-malawi",
		colored: true
	},
	flagMX: {
		class: "i-twemoji-flag-mexico",
		colored: true
	},
	flagMY: {
		class: "i-twemoji-flag-malaysia",
		colored: true
	},
	flagMZ: {
		class: "i-twemoji-flag-mozambique",
		colored: true
	},
	flagNA: {
		class: "i-twemoji-flag-namibia",
		colored: true
	},
	flagNC: {
		class: "i-twemoji-flag-new-caledonia",
		colored: true
	},
	flagNE: {
		class: "i-twemoji-flag-niger",
		colored: true
	},
	flagNF: {
		class: "i-twemoji-flag-norfolk-island",
		colored: true
	},
	flagNG: {
		class: "i-twemoji-flag-nigeria",
		colored: true
	},
	flagNI: {
		class: "i-twemoji-flag-nicaragua",
		colored: true
	},
	flagNL: {
		class: "i-twemoji-flag-netherlands",
		colored: true
	},
	flagNO: {
		class: "i-twemoji-flag-norway",
		colored: true
	},
	flagNP: {
		class: "i-twemoji-flag-nepal",
		colored: true
	},
	flagNR: {
		class: "i-twemoji-flag-nauru",
		colored: true
	},
	flagNU: {
		class: "i-twemoji-flag-niue",
		colored: true
	},
	flagNZ: {
		class: "i-twemoji-flag-new-zealand",
		colored: true
	},
	flagOM: {
		class: "i-twemoji-flag-oman",
		colored: true
	},
	flagPA: {
		class: "i-twemoji-flag-panama",
		colored: true
	},
	flagPE: {
		class: "i-twemoji-flag-peru",
		colored: true
	},
	flagPF: {
		class: "i-twemoji-flag-french-polynesia",
		colored: true
	},
	flagPG: {
		class: "i-twemoji-flag-papua-new-guinea",
		colored: true
	},
	flagPH: {
		class: "i-twemoji-flag-philippines",
		colored: true
	},
	flagPK: {
		class: "i-twemoji-flag-pakistan",
		colored: true
	},
	flagPL: {
		class: "i-twemoji-flag-poland",
		colored: true
	},
	flagPN: {
		class: "i-twemoji-flag-pitcairn-islands",
		colored: true
	},
	flagPR: {
		class: "i-twemoji-flag-puerto-rico",
		colored: true
	},
	flagPT: {
		class: "i-twemoji-flag-portugal",
		colored: true
	},
	flagPW: {
		class: "i-twemoji-flag-palau",
		colored: true
	},
	flagPY: {
		class: "i-twemoji-flag-paraguay",
		colored: true
	},
	flagQA: {
		class: "i-twemoji-flag-qatar",
		colored: true
	},
	flagRO: {
		class: "i-twemoji-flag-romania",
		colored: true
	},
	flagRS: {
		class: "i-twemoji-flag-serbia",
		colored: true
	},
	flagRU: {
		class: "i-twemoji-flag-russia",
		colored: true
	},
	flagRW: {
		class: "i-twemoji-flag-rwanda",
		colored: true
	},
	flagSA: {
		class: "i-twemoji-flag-saudi-arabia",
		colored: true
	},
	flagSB: {
		class: "i-twemoji-flag-solomon-islands",
		colored: true
	},
	flagSC: {
		class: "i-twemoji-flag-seychelles",
		colored: true
	},
	flagSD: {
		class: "i-twemoji-flag-sudan",
		colored: true
	},
	flagSE: {
		class: "i-twemoji-flag-sweden",
		colored: true
	},
	flagSG: {
		class: "i-twemoji-flag-singapore",
		colored: true
	},
	flagSI: {
		class: "i-twemoji-flag-slovenia",
		colored: true
	},
	flagSK: {
		class: "i-twemoji-flag-slovakia",
		colored: true
	},
	flagSL: {
		class: "i-twemoji-flag-sierra-leone",
		colored: true
	},
	flagSM: {
		class: "i-twemoji-flag-san-marino",
		colored: true
	},
	flagSN: {
		class: "i-twemoji-flag-senegal",
		colored: true
	},
	flagSO: {
		class: "i-twemoji-flag-somalia",
		colored: true
	},
	flagSR: {
		class: "i-twemoji-flag-suriname",
		colored: true
	},
	flagSS: {
		class: "i-twemoji-flag-south-sudan",
		colored: true
	},
	flagSV: {
		class: "i-twemoji-flag-el-salvador",
		colored: true
	},
	flagSX: {
		class: "i-twemoji-flag-sint-maarten",
		colored: true
	},
	flagSY: {
		class: "i-twemoji-flag-syria",
		colored: true
	},
	flagSZ: {
		class: "i-twemoji-flag-eswatini",
		colored: true
	},
	flagTD: {
		class: "i-twemoji-flag-chad",
		colored: true
	},
	flagTG: {
		class: "i-twemoji-flag-togo",
		colored: true
	},
	flagTH: {
		class: "i-twemoji-flag-thailand",
		colored: true
	},
	flagTJ: {
		class: "i-twemoji-flag-tajikistan",
		colored: true
	},
	flagTK: {
		class: "i-twemoji-flag-tokelau",
		colored: true
	},
	flagTL: {
		class: "i-twemoji-flag-timor-leste",
		colored: true
	},
	flagTM: {
		class: "i-twemoji-flag-turkmenistan",
		colored: true
	},
	flagTN: {
		class: "i-twemoji-flag-tunisia",
		colored: true
	},
	flagTO: {
		class: "i-twemoji-flag-tonga",
		colored: true
	},
	flagTR: {
		class: "i-twemoji-flag-turkey",
		colored: true
	},
	flagTV: {
		class: "i-twemoji-flag-tuvalu",
		colored: true
	},
	flagTW: {
		class: "i-twemoji-flag-taiwan",
		colored: true
	},
	flagTZ: {
		class: "i-twemoji-flag-tanzania",
		colored: true
	},
	flagUA: {
		class: "i-twemoji-flag-ukraine",
		colored: true
	},
	flagUG: {
		class: "i-twemoji-flag-uganda",
		colored: true
	},
	flagUS: {
		class: "i-twemoji-flag-united-states",
		colored: true
	},
	flagUY: {
		class: "i-twemoji-flag-uruguay",
		colored: true
	},
	flagUZ: {
		class: "i-twemoji-flag-uzbekistan",
		colored: true
	},
	flagVA: {
		class: "i-twemoji-flag-vatican-city",
		colored: true
	},
	flagVE: {
		class: "i-twemoji-flag-venezuela",
		colored: true
	},
	flagVG: {
		class: "i-twemoji-flag-british-virgin-islands",
		colored: true
	},
	flagVN: {
		class: "i-twemoji-flag-vietnam",
		colored: true
	},
	flagVU: {
		class: "i-twemoji-flag-vanuatu",
		colored: true
	},
	flagWS: {
		class: "i-twemoji-flag-samoa",
		colored: true
	},
	flagXK: {
		class: "i-twemoji-flag-kosovo",
		colored: true
	},
	flagYE: {
		class: "i-twemoji-flag-yemen",
		colored: true
	},
	flagYT: {
		class: "i-twemoji-flag-mayotte",
		colored: true
	},
	flagZA: {
		class: "i-twemoji-flag-south-africa",
		colored: true
	},
	flagZM: {
		class: "i-twemoji-flag-zambia",
		colored: true
	},
	flagZW: {
		class: "i-twemoji-flag-zimbabwe",
		colored: true
	}
};
var dataTypeImages = {
	dataTypeAutoIncrementedInteger: {
		class: "i-mdi-counter",
		colored: false
	},
	dataTypeBoolean: {
		class: "i-mdi-checkbox-outline",
		colored: false
	},
	dataTypeColor: {
		class: "i-mdi-format-color-fill",
		colored: false
	},
	dataTypeDataType: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeDate: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	dataTypeDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeDecimal: {
		class: "i-mdi-decimal",
		colored: false
	},
	dataTypeEnum: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeFile: {
		class: "i-mdi-file-outline",
		colored: false
	},
	dataTypeGuid: {
		class: "i-mdi-identifier",
		colored: false
	},
	dataTypeImage: {
		class: "i-mdi-image-outline",
		colored: false
	},
	dataTypeInteger: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeInvariantDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeLocalizableString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeLong: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeStringArray: {
		class: "i-mdi-code-brackets",
		colored: false
	}
};
var standardImages = {
	add: {
		class: "i-mdi-plus-thick",
		colored: false
	},
	addCondition: {
		class: "i-mdi-playlist-plus",
		colored: false
	},
	addGroup: {
		class: "i-mdi-format-list-group-plus",
		colored: false
	},
	arrowDown: {
		class: "i-mdi-arrow-down-thin",
		colored: false
	},
	arrowLeft: {
		class: "i-mdi-arrow-left",
		colored: false
	},
	arrowRight: {
		class: "i-mdi-arrow-right",
		colored: false
	},
	arrowUp: {
		class: "i-mdi-arrow-up-thin",
		colored: false
	},
	asterisk: {
		class: "i-mdi-asterisk",
		colored: false
	},
	between: {
		class: "i-mdi-format-horizontal-align-center",
		colored: false
	},
	bookmarkOutline: {
		class: "i-mdi-bookmark-outline",
		colored: false
	},
	bulb: {
		class: "i-mdi-lightbulb-outline",
		colored: false
	},
	calendar: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	calendarStart: {
		class: "i-mdi-calendar-start",
		colored: false
	},
	chevronDoubleDown: {
		class: "i-mdi-chevron-double-down",
		colored: false
	},
	chevronDoubleLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	chevronDoubleRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	chevronDoubleUp: {
		class: "i-mdi-chevron-double-up",
		colored: false
	},
	chevronDown: {
		class: "i-mdi-chevron-down",
		colored: false
	},
	chevronLeft: {
		class: "i-mdi-chevron-left",
		colored: false
	},
	chevronRight: {
		class: "i-mdi-chevron-right",
		colored: false
	},
	chevronRightCircle: {
		class: "i-mdi-chevron-right-circle-outline",
		colored: false
	},
	chevronUp: {
		class: "i-mdi-chevron-up",
		colored: false
	},
	circle: {
		class: "i-mdi-checkbox-blank-circle",
		colored: false
	},
	clear: {
		class: "i-mdi-close-circle-outline",
		colored: false
	},
	clearFilter: {
		class: "i-mdi-filter-remove-outline",
		colored: false
	},
	clock: {
		class: "i-mdi-clock-outline",
		colored: false
	},
	clone: {
		class: "i-mdi-content-copy",
		colored: false
	},
	close: {
		class: "i-mdi-close",
		colored: false
	},
	closeTabs: {
		class: "i-mdi-tab-remove",
		colored: false
	},
	cog: {
		class: "i-mdi-cog",
		colored: false
	},
	collapse: {
		class: "i-mdi-arrow-collapse",
		colored: false
	},
	columnPicker: {
		class: "i-mdi-table-column-plus-before",
		colored: false
	},
	contains: {
		class: "i-mdi-format-letter-matches",
		colored: false
	},
	csharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	csv: {
		class: "i-mdi-file-table-outline",
		colored: false
	},
	danger: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	datagridLoadData: {
		class: "i-neos-datagrid-load-data",
		colored: true
	},
	datagridNoData: {
		class: "i-neos-datagrid-no-data",
		colored: true
	},
	dotsHorizontal: {
		class: "i-mdi-dots-horizontal",
		colored: false
	},
	doubleChevronLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	doubleChevronRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	download: {
		class: "i-mdi-download",
		colored: false
	},
	dragHorizontal: {
		class: "i-mdi-drag-horizontal",
		colored: false
	},
	dragVertical: {
		class: "i-mdi-drag-vertical",
		colored: false
	},
	edit: {
		class: "i-mdi-pencil",
		colored: false
	},
	endsWith: {
		class: "i-mdi-format-letter-ends-with",
		colored: false
	},
	equal: {
		class: "i-mdi-equal",
		colored: false
	},
	erase: {
		class: "i-mdi-eraser",
		colored: false
	},
	error: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	excel: {
		class: "i-mdi-microsoft-excel",
		colored: false
	},
	expand: {
		class: "i-mdi-arrow-expand",
		colored: false
	},
	export: {
		class: "i-mdi-download",
		colored: false
	},
	expression: {
		class: "i-mdi-function-variant",
		colored: false
	},
	eye: {
		class: "i-mdi-eye",
		colored: false
	},
	eyeOff: {
		class: "i-mdi-eye-off",
		colored: false
	},
	filter: {
		class: "i-mdi-filter",
		colored: false
	},
	filterCheckOutline: {
		class: "i-mdi-filter-check-outline",
		colored: false
	},
	filterOutline: {
		class: "i-mdi-filter-outline",
		colored: false
	},
	folder: {
		class: "i-mdi-folder",
		colored: false
	},
	fullscreen: {
		class: "i-mdi-fullscreen",
		colored: false
	},
	fullscreenExit: {
		class: "i-mdi-fullscreen-exit",
		colored: false
	},
	generateduitemplate: {
		class: "i-mdi-identifier",
		colored: false
	},
	greater: {
		class: "i-mdi-greater-than",
		colored: false
	},
	greaterOrEqual: {
		class: "i-mdi-greater-than-or-equal",
		colored: false
	},
	groupPanel: {
		class: "i-mdi-format-list-group",
		colored: false
	},
	homeGroup: {
		class: "i-mdi-home-group",
		colored: false
	},
	in: {
		class: "i-mdi-plus-circle-outline",
		colored: false
	},
	info: {
		class: "i-mdi-information-outline",
		colored: false
	},
	isNotNull: {
		class: "i-mdi-alphabetical-variant",
		colored: false
	},
	isNull: {
		class: "i-mdi-alphabetical-variant-off",
		colored: false
	},
	less: {
		class: "i-mdi-less-than",
		colored: false
	},
	lessOrEqual: {
		class: "i-mdi-less-than-or-equal",
		colored: false
	},
	lock: {
		class: "i-mdi-lock-outline",
		colored: false
	},
	logout: {
		class: "i-mdi-logout",
		colored: false
	},
	menu: {
		class: "i-mdi-menu",
		colored: false
	},
	menuDown: {
		class: "i-mdi-menu-down",
		colored: false
	},
	microphone: {
		class: "i-mdi-microphone",
		colored: false
	},
	min: {
		class: "i-mdi-minus",
		colored: false
	},
	notEqual: {
		class: "i-mdi-not-equal-variant ",
		colored: false
	},
	notIn: {
		class: "i-mdi-minus-circle-outline",
		colored: false
	},
	open: {
		class: "i-mdi-open-in-new",
		colored: false
	},
	paperclip: {
		class: "i-mdi-paperclip",
		colored: false
	},
	pinned: {
		class: "i-mdi-pin-outline",
		colored: false
	},
	pdf: {
		class: "i-mdi-file-pdf-box",
		colored: false
	},
	positive: {
		class: "i-mdi-check-circle-outline",
		colored: false
	},
	print: {
		class: "i-mdi-printer",
		colored: false
	},
	refresh: {
		class: "i-mdi-refresh",
		colored: false
	},
	remove: {
		class: "i-mdi-trash-can-outline",
		colored: false
	},
	removeColumn: {
		class: "i-mdi-table-column-remove",
		colored: false
	},
	reset: {
		class: "i-mdi-arrow-u-left-top",
		colored: false
	},
	restart: {
		class: "i-mdi-restart",
		colored: false
	},
	save: {
		class: "i-mdi-content-save-outline",
		colored: false
	},
	search: {
		class: "i-mdi-magnify",
		colored: false
	},
	send: {
		class: "i-mdi-send",
		colored: false
	},
	sparkles: {
		class: "i-neos-sparkles",
		colored: true
	},
	startsWith: {
		class: "i-mdi-format-letter-starts-with ",
		colored: false
	},
	swap: {
		class: "i-mdi-swap-vertical",
		colored: false
	},
	translate: {
		class: "i-mdi-translate",
		colored: false
	},
	typescript: {
		class: "i-mdi-language-typescript",
		colored: false
	},
	uicsharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	uitemplate: {
		class: "i-mdi-xml",
		colored: false
	},
	unsave: {
		class: "i-mdi-content-save-off-outline",
		colored: false
	},
	user: {
		class: "i-mdi-account",
		colored: false
	},
	validate: {
		class: "i-mdi-check",
		colored: false
	},
	warning: {
		class: "i-mdi-alert-outline",
		colored: false
	},
	...countryImages,
	...dataTypeImages
};
//#endregion
//#region src/components/Image/Image.ts?vue&type=script&src=true&lang.ts
var Image_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Image",
	props: {
		name: {
			type: String,
			default: void 0
		},
		size: {
			type: String,
			default: "medium"
		}
	},
	setup(props) {
		const images = useImages();
		const themeManager = useThemeManager(false);
		const image = computed(() => {
			if (!props.name) return;
			const camelCaseName = toCamelCase(props.name);
			const customImage = images[camelCaseName];
			return typeof customImage === "object" ? customImage : standardImages[customImage ?? camelCaseName] ?? standardImages[camelCaseName];
		});
		const classes = computed(() => {
			if (!image.value) return;
			if (image.value.path && image.value.colored) return ["image-bg", `image-${props.size}`];
			return [image.value.class ?? "image-mask", `image-${props.size}`];
		});
		const style = computed(() => {
			if (image.value?.darkVersionPath && themeManager?.currentTheme.colorScheme === "dark") return `--image-url: url('${image.value.darkVersionPath}')`;
			if (image.value?.path) return `--image-url: url('${image.value.path}')`;
		});
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/Image/Image.vue
function _sfc_render$35(_ctx, _cache, $props, $setup, $data, $options) {
	return _ctx.classes ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["image", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, null, 6)) : createCommentVNode("", true);
}
var Image_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Image_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$35], ["__scopeId", "data-v-e4db28c2"]]);
//#endregion
//#region src/components/Avatar/Avatar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$29 = {
	key: 0,
	class: "avatar-label"
};
//#endregion
//#region src/components/Avatar/Avatar.vue
var Avatar_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Avatar",
	props: {
		label: { default: void 0 },
		icon: { default: void 0 },
		size: { default: "medium" },
		shape: { default: "circle" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const array = [`avatar-${props.size}`];
			if (props.shape === "square") array.push("avatar-square");
			return array;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["avatar", classes.value]) }, [__props.label ? (openBlock(), createElementBlock("span", _hoisted_1$29, toDisplayString(__props.label), 1)) : __props.icon ? (openBlock(), createBlock(Image_default, {
				key: 1,
				name: __props.icon,
				class: "avatar-icon",
				size: __props.size
			}, null, 8, ["name", "size"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-c6f12af7"]]);
//#endregion
//#region src/components/Badge/Badge.vue
var Badge_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Badge",
	props: {
		value: { default: void 0 },
		severity: { default: "none" },
		size: { default: "medium" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const classes = [];
			if (props.size != "medium") classes.push(`badge-${props.size}`);
			if (props.value != null && String(props.value).length <= 2) classes.push("p-badge-circle");
			return classes;
		});
		const computedSeverity = computed(() => {
			switch (props.severity) {
				case "none": return null;
				case "positive": return "success";
				case "warning": return "warn";
				default: return props.severity;
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeBadge), {
				value: __props.value,
				severity: computedSeverity.value,
				class: normalizeClass(["badge", classes.value])
			}, null, 8, [
				"value",
				"severity",
				"class"
			]);
		};
	}
}), [["__scopeId", "data-v-53d09dd7"]]);
//#endregion
//#region src/composables/useGlobalResourceManager.ts
function provideGlobalResourceManager(globalResourceManager) {
	provide("globalResourceManager", globalResourceManager);
	return globalResourceManager;
}
function useGlobalResourceManager() {
	const globalResourceManager = inject("globalResourceManager");
	if (!globalResourceManager) throw new Error("GlobalResourceManager not provided");
	return {
		globalResourceManager,
		translate: (key, ...args) => stringFormat(globalResourceManager.get(key), ...args)
	};
}
//#endregion
//#region src/composables/useFocusableElement.ts
var focusableElementProps = {
	autofocus: {
		type: Boolean,
		default: void 0
	},
	focused: {
		type: Boolean,
		default: void 0
	}
};
var focusableElementEmits = ["update:focused"];
function useFocusableElement(element, props, emit) {
	if (props.focused === void 0 && props.autofocus === void 0) return;
	const { focused } = useFocus(element);
	watch(element, (value) => {
		if (value) {
			const autofocus = props.focused || props.autofocus;
			if (autofocus) {
				const el = getComponentElement(value);
				el.setAttribute("autofocus", `${autofocus}`);
				el.focus();
			}
		}
	}, { immediate: true });
	watch(() => props.focused, (value) => {
		if (value !== void 0 && value !== focused.value) focused.value = value;
	});
	watch(focused, (value) => {
		if (value !== props.focused) emit("update:focused", value);
	});
}
//#endregion
//#region src/composables/useInput.ts
var inputProps = {
	label: {
		type: String,
		default: void 0
	},
	labelPosition: {
		type: String,
		default: void 0
	},
	required: {
		type: Boolean,
		default: false
	},
	readonly: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	},
	messageText: {
		type: String,
		default: void 0
	},
	messageSeverity: {
		type: String,
		default: void 0
	},
	messagePosition: {
		type: String,
		default: void 0
	},
	documentation: {
		type: String,
		default: void 0
	},
	placeholder: {
		type: String,
		default: void 0
	},
	tabStop: {
		type: Boolean,
		default: true
	},
	inputDisplayMode: {
		type: String,
		default: "form"
	},
	aiSuggestion: {
		type: Object,
		default: void 0
	},
	...focusableElementProps
};
var inputEmits = [
	"update:modelValue",
	"aiApply",
	"aiCancel",
	...focusableElementEmits
];
function useInput(props, emit) {
	const input = ref(null);
	const id = createGuid();
	const classes = computed(() => ({
		"neos-inline-input": props.labelPosition === "left" || props.labelPosition === "right",
		"neos-inline-right-input": props.labelPosition === "right",
		"neos-datagrid-input": props.inputDisplayMode === "datagrid",
		"neos-input-readonly": props.readonly,
		"neos-input-disabled": props.disabled,
		"neos-input-warning": props.messageSeverity === "warning" && props.messageText !== void 0,
		"neos-input-error": props.messageSeverity === "error" && props.messageText != void 0 || props.messageSeverity === void 0 && props.messageText != void 0
	}));
	const isLabelVisible = computed(() => props.label != null && props.labelPosition !== "hidden");
	const isMessageVisible = computed(() => props.messageText != null && props.messagePosition !== "hidden");
	const tabIndex = computed(() => props.tabStop ? void 0 : -1);
	useComponentAutomationProperties();
	useFocusableElement(input, props, emit);
	return {
		input,
		id,
		classes,
		isLabelVisible,
		isMessageVisible,
		tabIndex
	};
}
function triggerChangeOnActiveInput() {
	const el = document.activeElement;
	if ((el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) && !el.closest(".neos-input-readonly") && !el.closest(".neos-input-disabled")) el.dispatchEvent(new Event("change", { bubbles: true }));
}
//#endregion
//#region src/composables/useInputInvalidValue.ts
function useInputInvalidValue(props, emit) {
	const internalInvalidValue = ref(null);
	return computed({
		get() {
			if (props.invalidValue !== void 0) return props.invalidValue;
			return internalInvalidValue.value;
		},
		set(value) {
			if (props.invalidValue !== void 0) {
				if (props.invalidValue !== value) emit("update:invalidValue", value);
			} else internalInvalidValue.value = value;
		}
	});
}
//#endregion
//#region src/composables/useLocalizator.ts
function provideLocalizator(localizator) {
	provide("localizator", localizator);
	return localizator;
}
function useLocalizator() {
	const localizator = inject("localizator");
	if (!localizator) throw new Error("Localizator not provided");
	return localizator;
}
//#endregion
//#region src/composables/useText.ts
var textPropsDefaults = {
	size: "medium",
	weight: "regular"
};
var smallTextPropsDefaults = {
	size: "small",
	weight: "regular"
};
function useText(props) {
	return {
		classes: computed(() => {
			const value = [];
			if (typeof props.size === "string") value.push(`text-${props.size}`);
			if (props.weight !== "regular") value.push(`text-${props.weight}`);
			return value;
		}),
		styles: computed(() => {
			const value = {};
			if (typeof props.size === "number") value["font-size"] = `${props.size}px`;
			return value;
		})
	};
}
//#endregion
//#region src/composables/useTextMaxLines.ts
function useTextMaxLines(props) {
	return {
		classes: computed(() => props.maxLines ? ["text-with-webkit-box-for-ellipsis"] : []),
		styles: computed(() => props.maxLines ? { "-webkit-line-clamp": props.maxLines } : void 0)
	};
}
//#endregion
//#region src/components/Text/Text.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$28 = ["title"];
//#endregion
//#region src/components/Text/Text.vue
var Text_default = /* @__PURE__ */ defineComponent({
	__name: "Text",
	props: /* @__PURE__ */ mergeDefaults({
		size: {},
		weight: {},
		orientation: {},
		tooltip: {},
		maxLines: {}
	}, {
		...textPropsDefaults,
		orientation: "horizontal",
		tooltip: void 0,
		maxLines: void 0
	}),
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes: baseClasses, styles: baseStyles } = useText(props);
		const { classes: maxLinesClasses, styles: maxLinesStyles } = useTextMaxLines(props);
		const classes = computed(() => {
			const value = [...baseClasses.value, ...maxLinesClasses.value];
			if (props.orientation !== "horizontal") value.push(`text-orientation-${props.orientation}`);
			return value;
		});
		const styles = computed(() => ({
			...baseStyles.value,
			...maxLinesStyles.value
		}));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: normalizeClass(["text", classes.value]),
				title: __props.tooltip,
				style: normalizeStyle(styles.value)
			}, [renderSlot(_ctx.$slots, "default")], 14, _hoisted_1$28);
		};
	}
});
//#endregion
//#region src/components/Button/Button.ts?vue&type=script&src=true&lang.ts
var commonBaseButtonElementProps = {
	tooltip: {
		type: String,
		default: void 0
	},
	contentAlign: {
		type: String,
		default: "start"
	}
};
var Button_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Button",
	components: {
		Text: Text_default,
		Image: Image_default,
		PrimeButton
	},
	props: {
		...focusableElementProps,
		...commonBaseButtonElementProps,
		type: {
			type: String,
			default: "button"
		},
		variant: {
			type: String,
			default: "default"
		},
		size: {
			type: String,
			default: "medium"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: "horizontal"
		},
		loading: {
			type: Boolean,
			default: false
		},
		label: {
			type: [String, Number],
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		badge: {
			type: [String, Number],
			default: void 0
		},
		badgeSeverity: {
			type: String,
			default: "none"
		},
		iconSize: {
			type: String,
			default: void 0
		},
		animated: {
			type: Boolean,
			default: false
		}
	},
	emits: [...focusableElementEmits],
	setup(props, { emit }) {
		const themeManager = useThemeManager(false);
		const root = ref(null);
		const rootStyle = computed(() => `justify-content: ${props.contentAlign}`);
		const labelStyle = computed(() => props.label !== void 0 ? void 0 : "display: none");
		const classes = computed(() => {
			const list = [
				`button-${props.variant}`,
				`button-${props.size}`,
				`neos-${props.direction}-content`
			];
			if (props.badge !== void 0 && !props.label) list.push("p-overlay-badge");
			if (props.animated && props.variant !== "link" && themeManager?.currentTheme.animatedButtons) list.push("button-animated");
			return list;
		});
		const computedBadgeSeverity = computed(() => {
			switch (props.badgeSeverity) {
				case "none": return null;
				case "positive": return "success";
				case "warning": return "warn";
				default: return props.badgeSeverity;
			}
		});
		const link = computed(() => props.variant === "link");
		useComponentAutomationProperties(root);
		useFocusableElement(root, props, emit);
		return {
			root,
			classes,
			rootStyle,
			labelStyle,
			computedBadgeSeverity,
			link
		};
	}
});
//#endregion
//#region src/components/Button/Button.vue
function _sfc_render$34(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_PrimeButton = resolveComponent("PrimeButton");
	return openBlock(), createBlock(_component_PrimeButton, {
		ref: "root",
		class: normalizeClass(["button", _ctx.classes]),
		type: _ctx.type,
		label: _ctx.label?.toString(),
		"aria-label": _ctx.label,
		disabled: _ctx.disabled,
		title: _ctx.tooltip,
		loading: _ctx.loading,
		text: "",
		badge: _ctx.badge?.toString(),
		"badge-severity": _ctx.computedBadgeSeverity,
		link: _ctx.link,
		pt: {
			root: { style: _ctx.rootStyle },
			label: { style: _ctx.labelStyle }
		},
		onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
	}, createSlots({
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 2
	}, [_ctx.icon ? {
		name: "icon",
		fn: withCtx(() => [createVNode(_component_Image, {
			name: _ctx.icon,
			size: _ctx.iconSize ?? _ctx.size
		}, null, 8, ["name", "size"])]),
		key: "0"
	} : void 0]), 1032, [
		"type",
		"class",
		"label",
		"aria-label",
		"disabled",
		"title",
		"loading",
		"badge",
		"badge-severity",
		"link",
		"pt"
	]);
}
var Button_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Button_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$34]]);
//#endregion
//#region src/composables/useButtonContainerSpace.ts
function useButtonContainerSpace(themeManager, props) {
	return computed(() => {
		return (props?.animated ?? themeManager?.currentTheme.animatedButtons) === true ? "none" : void 0;
	});
}
//#endregion
//#region src/utils/tokens.ts
var SpaceValues = {
	none: "0px",
	extrasmall: "0.25rem",
	small: "0.5rem",
	medium: "0.875rem",
	large: "1.125rem",
	extralarge: "1.5rem"
};
var CornerRadiusValues = {
	...SpaceValues,
	full: "50%"
};
var multiSpaceValueValidatorExpression = /^(none|extrasmall|small|medium|large|extralarge)(( (none|extrasmall|small|medium|large|extralarge)){3})?$/;
var AlignValues = {
	start: "flex-start",
	left: "flex-start",
	center: "center",
	end: "flex-end",
	right: "flex-end",
	stretch: "stretch",
	"space-between": "space-between"
};
var VerticalAlignValues = {
	top: "flex-start",
	center: "center",
	bottom: "flex-end",
	stretch: "stretch"
};
var BreakpointValues = {
	small: 640,
	medium: 768,
	large: 1024,
	extralarge: 1280
};
var WeightValues = {
	regular: "var(--text-weight-regular)",
	strong: "var(--text-weight-strong)",
	stronger: "var(--text-weight-stronger)"
};
var LayoutDirectiveProperty = /* @__PURE__ */ function(LayoutDirectiveProperty) {
	LayoutDirectiveProperty["alignSelfHorizontal"] = "align-self-horizontal";
	LayoutDirectiveProperty["alignSelfVertical"] = "align-self-vertical";
	LayoutDirectiveProperty["height"] = "height";
	LayoutDirectiveProperty["margin"] = "margin";
	LayoutDirectiveProperty["maxHeight"] = "max-height";
	LayoutDirectiveProperty["maxWidth"] = "max-width";
	LayoutDirectiveProperty["minHeight"] = "min-height";
	LayoutDirectiveProperty["minWidth"] = "min-width";
	LayoutDirectiveProperty["padding"] = "padding";
	LayoutDirectiveProperty["visibility"] = "visibility";
	LayoutDirectiveProperty["width"] = "width";
	return LayoutDirectiveProperty;
}({});
var AutomationDirectivePropertyValues = {
	id: "neosAutomationId",
	"repeat-index": "neosAutomationRepeatIndex"
};
var StyleDirectivePropertyValues = {
	"border-color": void 0,
	"corner-radius": void 0,
	"font-style": "font-style",
	"font-weight": "font-weight",
	"hover-background": "--neos-hover-background",
	"hover-border-color": "--neos-hover-border-color",
	"hover-color": "--neos-hover-color",
	"hover-font-style": "--neos-hover-font-style",
	"hover-font-weight": "--neos-hover-font-weight",
	"hover-text-decoration": "--neos-hover-text-decoration",
	"overflow-wrap": "overflow-wrap",
	"shadow-color": "box-shadow",
	"text-align": "text-align",
	"text-decoration": "text-decoration",
	background: "background",
	color: "color"
};
var validationMessageSeverities = [
	"error",
	"warning",
	"information"
];
//#endregion
//#region src/components/HorizontalLayout/HorizontalLayout.ts?vue&type=script&src=true&lang.ts
var HorizontalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HorizontalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "left"
		},
		verticalAlign: {
			type: String,
			default: "stretch"
		},
		wrap: {
			type: Boolean,
			default: true
		},
		reverse: {
			type: Boolean,
			default: false
		},
		fullHeight: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const classes = computed(() => {
			const array = [];
			if (!props.wrap) array.push("horizontal-layout-nowrap");
			if (props.fullHeight) array.push("horizontal-layout-full-height");
			if (props.reverse) array.push("horizontal-layout-reverse");
			return array;
		});
		const style = computed(() => ({
			[`--horizontal-space`]: SpaceValues[props.space],
			[`--horizontal-align`]: AlignValues[props.align],
			[`--horizontal-vertical-align`]: VerticalAlignValues[props.verticalAlign]
		}));
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
//#endregion
//#region src/components/HorizontalLayout/HorizontalLayout.vue
function _sfc_render$33(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["horizontal-layout", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 6);
}
var HorizontalLayout_default = /* @__PURE__ */ _plugin_vue_export_helper_default(HorizontalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$33]]);
//#endregion
//#region src/components/ButtonsLayout/ButtonsLayout.vue
var ButtonsLayout_default = /* @__PURE__ */ defineComponent({
	__name: "ButtonsLayout",
	setup(__props) {
		const themeManager = useThemeManager(false);
		const reverse = computed(() => themeManager?.currentTheme.buttonsLayoutReverseOrder === true);
		const align = computed(() => reverse.value ? "start" : "end");
		const buttonContainerSpace = useButtonContainerSpace(themeManager);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: unref(buttonContainerSpace),
				reverse: reverse.value,
				align: align.value
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"space",
				"reverse",
				"align"
			]);
		};
	}
});
//#endregion
//#region src/markdown/parse.ts
var parser;
async function parseMarkdown(source, options) {
	let html = await (await getParser())(source, options);
	if (options.sanitize) html = (await import("dompurify")).default.sanitize(html);
	return html;
}
async function getParser() {
	if (!parser) {
		const { Renderer, parse } = await import("marked");
		const renderer = new Renderer();
		const originalLink = renderer.link;
		renderer.link = function(token) {
			return originalLink.call(this, token).replace("<a", "<a target=\"_blank\"");
		};
		const originalTable = renderer.table;
		renderer.table = function(token) {
			return originalTable.call(this, token).replace("<table", "<table style=\"overflow: auto;display: block;\"");
		};
		parser = (source, options) => parse(source, {
			async: true,
			renderer,
			async walkTokens(token) {
				if (options.highlightCode && token.type === "code" && token.lang && token.lang !== "mermaid") await transformCodeToken(token, options.highlightCode.copyCodeButton);
			}
		});
	}
	return parser;
}
async function transformCodeToken(token, copyCodeButton) {
	const { lang, attrs } = extractLangAndAttrs(token.lang);
	const { codeToHtml, bundledLanguages, bundledThemes } = await import("shiki");
	if (lang in bundledLanguages) {
		const html = await codeToHtml(token.text, {
			lang,
			theme: attrs.theme && attrs.theme in bundledThemes ? attrs.theme : "min-dark"
		});
		Object.assign(token, {
			type: "html",
			text: formatCodeBlock(html, copyCodeButton)
		});
	}
}
function extractLangAndAttrs(value) {
	const [lang, ...rest] = value.split(" ");
	const attrs = {};
	for (const attr of rest) {
		const [key, value] = attr.split("=");
		attrs[key] = value;
	}
	return {
		lang,
		attrs
	};
}
function formatCodeBlock(html, copyCodeButton) {
	let text = `<div class="code-block">`;
	if (copyCodeButton) text += `<button type="button" class="copy-code-button"><div class="image i-mdi-content-copy image-small"></div></button>`;
	text += `${html}</div>`;
	return text;
}
//#endregion
//#region src/markdown/process.ts
var mermaid;
async function processMarkdown(root, options) {
	if (options.highlightCode && options.highlightCode.copyCodeButton) processCopyCodeButtons(root);
	if (options.mermaid) await processMermaid(root);
}
function processCopyCodeButtons(root) {
	for (const button of root.querySelectorAll(".copy-code-button:not([data-processed=\"true\"])")) {
		button.addEventListener("click", () => {
			const text = button.nextElementSibling?.textContent ?? "";
			navigator.clipboard.writeText(text);
		});
		button.setAttribute("data-processed", "true");
	}
}
async function processMermaid(root) {
	const nodes = root.querySelectorAll(".language-Mermaid, .language-mermaid");
	if (nodes.length === 0) return;
	if (!mermaid) {
		mermaid = (await import("mermaid")).default;
		mermaid.initialize({ startOnLoad: false });
	}
	await mermaid.run({
		nodes,
		suppressErrors: true
	});
}
//#endregion
//#region src/components/MarkdownViewer/MarkdownViewer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$27 = ["data-ready", "innerHTML"];
//#endregion
//#region src/components/MarkdownViewer/MarkdownViewer.vue
var MarkdownViewer_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "MarkdownViewer",
	props: {
		source: { default: void 0 },
		sanitize: {
			type: Boolean,
			default: false
		},
		highlightCode: {
			type: Boolean,
			default: false
		},
		copyCodeButton: {
			type: Boolean,
			default: false
		},
		mermaid: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const root = ref();
		const ready = ref(true);
		const html = ref();
		const options = computed(() => ({
			sanitize: props.sanitize,
			highlightCode: props.highlightCode ? { copyCodeButton: props.copyCodeButton } : void 0,
			mermaid: props.mermaid
		}));
		watch([() => props.source, options], parse, { immediate: true });
		watch(() => props.loading, process);
		async function parse() {
			ready.value = false;
			html.value = props.source ? await parseMarkdown(props.source, options.value) : "";
			await process();
		}
		async function process() {
			if (root.value && !props.loading && html.value) {
				ready.value = false;
				await nextTick();
				await processMarkdown(root.value, options.value);
			}
			ready.value = true;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "root",
				ref: root,
				class: "markdown-viewer",
				"data-ready": ready.value,
				innerHTML: html.value
			}, null, 8, _hoisted_1$27);
		};
	}
}), [["__scopeId", "data-v-17f7cecf"]]);
//#endregion
//#region src/utils/dropdown.ts
/**
* Gets a value indicating whether there is an active dropdown.
* lookup-dropdown: Lookup
* p-select-list-container: ComboboxV2
* p-multiselect-list-container: MultiSelect
* wj-dropdown-panel: Wijmo dropdown components
*
* History:
* - NOV 20, 2023: Added .p-select-list-container for ComboboxV2 (task/17552)
*/
var selectors = ".lookup-dropdown, .p-select-list-container, .p-multiselect-list-container, .wj-dropdown-panel, .dropdown-menu";
function isDropdownActive() {
	return !!document.body.querySelector(selectors);
}
function isInDropdown(element) {
	const dropdowns = document.body.querySelectorAll(selectors);
	for (const dropdown of dropdowns) if (dropdown.contains(element)) return true;
	return false;
}
//#endregion
//#region src/components/Popover/popoverEventBus.ts
var hideAllPopoversEventBus = useEventBus("hide-all-popovers");
function hideAllPopovers() {
	hideAllPopoversEventBus.emit();
}
//#endregion
//#region src/components/Popover/Popover.vue
var Popover_default = /* @__PURE__ */ defineComponent({
	__name: "Popover",
	props: { preventHide: {
		type: Boolean,
		default: false
	} },
	emits: ["show", "hide"],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const popover = ref();
		let originalIsTargetClicked;
		onBeforeUnmount(() => {
			if (popover.value.visible) emit("hide");
			hideAllPopoversEventBus.off(onHideAllPopoversEventBus);
		});
		onClickOutside(popover, () => {
			if (popover.value.visible && (isDropdownActive() || props.preventHide)) popover.value.selfClick = true;
		});
		function toggle(event, hideOthers = false) {
			popover.value.toggle(event);
			if (hideOthers) hideAllPopoversEventBus.emit(popover.value);
		}
		function show(event) {
			popover.value.show(event);
		}
		function hide() {
			popover.value.hide();
		}
		function handleShow() {
			if (!originalIsTargetClicked) {
				originalIsTargetClicked = popover.value.isTargetClicked;
				popover.value.isTargetClicked = (event) => originalIsTargetClicked.call(popover.value, event) && !isBeforeAndAfterContent(event);
			}
			const content = popover.value.container.querySelector(".p-popover-content");
			content.style.maxHeight = `calc(100vh - (${popover.value.container.style.top} + 10px))`;
			popover.value.selfClick = true;
			hideAllPopoversEventBus.on(onHideAllPopoversEventBus);
			emit("show");
		}
		function isBeforeAndAfterContent(event) {
			return event.target instanceof HTMLElement && (event.target.closest(".textbox-before-content") || event.target.closest(".textbox-after-content"));
		}
		function handleHide() {
			emit("hide");
			hideAllPopoversEventBus.off(onHideAllPopoversEventBus);
		}
		function onHideAllPopoversEventBus(popoverToKeep) {
			if (popoverToKeep !== popover.value) hide();
		}
		__expose({
			popover,
			toggle,
			show,
			hide
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimePopover), {
				ref_key: "popover",
				ref: popover,
				onShow: handleShow,
				onHide: handleHide
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/PopoverWithTarget/PopoverWithTarget.vue
var PopoverWithTarget_default = /* @__PURE__ */ defineComponent({
	__name: "PopoverWithTarget",
	props: {
		"target": {
			type: Object,
			default: null
		},
		"targetModifiers": {}
	},
	emits: ["update:target"],
	setup(__props) {
		const target = useModel(__props, "target");
		watch([useTemplateRef("popover"), target], ([popover, currentTarget]) => {
			if (popover) if (currentTarget) popover.show({ currentTarget });
			else popover.hide();
		}, { immediate: true });
		function handleHide() {
			target.value = null;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				ref: "popover",
				onHide: handleHide
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/VerticalLayout/VerticalLayout.ts?vue&type=script&src=true&lang.ts
var VerticalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "VerticalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		},
		verticalAlign: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		return { style: computed(() => ({
			[`--vertical-space`]: SpaceValues[props.space],
			[`--vertical-align`]: AlignValues[props.align],
			...props.verticalAlign && { justifyContent: VerticalAlignValues[props.verticalAlign] }
		})) };
	}
});
//#endregion
//#region src/components/VerticalLayout/VerticalLayout.vue
function _sfc_render$32(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "vertical-layout",
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 4);
}
var VerticalLayout_default = /* @__PURE__ */ _plugin_vue_export_helper_default(VerticalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$32]]);
//#endregion
//#region src/components/AiSuggestionIndicator/AiSuggestionIndicator.vue
var AiSuggestionIndicator_default = /* @__PURE__ */ defineComponent({
	__name: "AiSuggestionIndicator",
	props: {
		suggestion: { default: void 0 },
		animated: {
			type: Boolean,
			default: true
		}
	},
	emits: ["apply", "cancel"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const popoverTarget = shallowRef(null);
		const popoverContent = shallowRef(null);
		const indicatorElement = shallowRef(null);
		let closeTimeout = null;
		let primePopoverEl = null;
		function cancelCloseTimeout() {
			if (closeTimeout) {
				clearTimeout(closeTimeout);
				closeTimeout = null;
			}
		}
		function isMouseOverElement(element) {
			return element?.matches(":hover") ?? false;
		}
		function scheduleClose() {
			cancelCloseTimeout();
			closeTimeout = setTimeout(() => {
				if (!isMouseOverElement(indicatorElement.value) && !isMouseOverElement(primePopoverEl)) popoverTarget.value = null;
			}, 200);
		}
		function handlePopoverMouseEnter() {
			cancelCloseTimeout();
		}
		function handlePopoverMouseLeave() {
			scheduleClose();
		}
		watch(popoverContent, (content) => {
			if (primePopoverEl) {
				primePopoverEl.removeEventListener("mouseenter", handlePopoverMouseEnter);
				primePopoverEl.removeEventListener("mouseleave", handlePopoverMouseLeave);
				primePopoverEl = null;
			}
			if (content) setTimeout(() => {
				primePopoverEl = content.$el?.closest(".p-popover");
				if (primePopoverEl) {
					primePopoverEl.addEventListener("mouseenter", handlePopoverMouseEnter);
					primePopoverEl.addEventListener("mouseleave", handlePopoverMouseLeave);
				}
			}, 0);
		});
		function handleIndicatorMouseEnter(event) {
			cancelCloseTimeout();
			if (popoverTarget.value) return;
			popoverTarget.value = event.currentTarget;
		}
		function handleIndicatorMouseLeave() {
			scheduleClose();
		}
		function handleCancel() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("cancel");
		}
		function handleApply() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("apply");
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [props.suggestion ? (openBlock(), createElementBlock("span", {
				key: 0,
				ref_key: "indicatorElement",
				ref: indicatorElement,
				class: normalizeClass(["ai-suggestion-indicator", { "is-animated": props.animated }]),
				onMouseenter: handleIndicatorMouseEnter,
				onMouseleave: handleIndicatorMouseLeave
			}, [createVNode(Image_default, {
				name: "ai",
				size: "extrasmall"
			})], 34)) : createCommentVNode("", true), props.suggestion ? (openBlock(), createBlock(PopoverWithTarget_default, {
				key: 1,
				target: popoverTarget.value,
				"onUpdate:target": _cache[0] || (_cache[0] = ($event) => popoverTarget.value = $event)
			}, {
				default: withCtx(() => [createVNode(VerticalLayout_default, {
					ref_key: "popoverContent",
					ref: popoverContent,
					space: "small",
					class: "ai-suggestion-popover"
				}, {
					default: withCtx(() => [
						createVNode(Text_default, null, {
							default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("AiSuggestion")), 1)]),
							_: 1
						}),
						props.suggestion?.text ? (openBlock(), createBlock(MarkdownViewer_default, {
							key: 0,
							class: "ai-suggestion-markdown",
							source: props.suggestion.text,
							sanitize: true,
							size: "small"
						}, null, 8, ["source"])) : createCommentVNode("", true),
						createVNode(HorizontalLayout_default, {
							align: "right",
							class: "neos-fill-parent-width"
						}, {
							default: withCtx(() => [createVNode(ButtonsLayout_default, null, {
								default: withCtx(() => [createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "check",
									animated: "",
									label: unref(translate)("Apply"),
									onClick: handleApply
								}, null, 8, ["label"]), createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "reset",
									animated: "",
									onClick: handleCancel
								})]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				}, 512)]),
				_: 1
			}, 8, ["target"])) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
//#region src/composables/useModal.ts
function useModal() {
	const isOpen = ref(false);
	function open() {
		isOpen.value = true;
	}
	function close() {
		isOpen.value = false;
	}
	return {
		isOpen,
		open,
		close
	};
}
//#endregion
//#region src/components/Modal/Modal.vue
var Modal_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Modal",
	props: {
		isOpen: { type: Boolean },
		dismissOnClickOutside: {
			type: Boolean,
			default: false
		},
		size: { default: "auto" },
		dismissible: {
			type: Boolean,
			default: false
		},
		position: { default: "center" },
		maximizable: {
			type: Boolean,
			default: true
		},
		focus: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:isOpen", "close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isDisplayed = computed({
			get: () => props.isOpen,
			set: (value) => {
				emit("update:isOpen", value);
				emit("close");
			}
		});
		const sizeClass = computed(() => props.size === "full" ? `modal-full-size` : void 0);
		const headerActionsStyle = computed(() => !props.dismissible && !props.maximizable ? "display: none" : void 0);
		const root = ref();
		useComponentAutomationProperties(root);
		watch(root, (r) => {
			if (!props.focus) r.onAfterEnter = () => void 0;
		});
		function onEscape() {
			if (props.dismissible) isDisplayed.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeDialog), mergeProps({
				ref_key: "root",
				ref: root,
				visible: isDisplayed.value,
				"onUpdate:visible": _cache[0] || (_cache[0] = ($event) => isDisplayed.value = $event)
			}, _ctx.$attrs, {
				modal: "",
				"dismissable-mask": __props.dismissOnClickOutside,
				closable: __props.dismissible,
				"close-on-escape": false,
				class: ["modal", sizeClass.value],
				position: __props.position,
				draggable: false,
				maximizable: __props.maximizable,
				pt: {
					header: { class: "neos-horizontal-content" },
					footer: { class: "neos-horizontal-content" },
					content: { class: "modal-body neos-vertical-content" },
					headerActions: { style: headerActionsStyle.value }
				},
				onKeydown: withKeys(onEscape, ["esc"])
			}), createSlots({
				default: withCtx(() => [renderSlot(_ctx.$slots, "body")]),
				_: 2
			}, [_ctx.$slots.header ? {
				name: "header",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
				key: "0"
			} : void 0, _ctx.$slots.footer ? {
				name: "footer",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
				key: "1"
			} : void 0]), 1040, [
				"visible",
				"dismissable-mask",
				"closable",
				"position",
				"class",
				"maximizable",
				"pt"
			]);
		};
	}
});
//#endregion
//#region src/components/InputDocumentationButton/InputDocumentationButton.ts?vue&type=script&src=true&lang.ts
var InputDocumentationButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDocumentationButton",
	components: {
		Button: Button_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		Text: Text_default
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		const { isOpen, open, close } = useModal();
		return {
			translate,
			isOpen,
			open,
			close
		};
	}
});
//#endregion
//#region src/components/InputDocumentationButton/InputDocumentationButton.vue
function _sfc_render$31(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_Button, {
		variant: "link",
		icon: "info",
		size: "extrasmall",
		class: "input-documentation-button",
		tabindex: "-1",
		onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.open(), ["stop"]))
	}), createVNode(_component_Modal, {
		"is-open": _ctx.isOpen,
		"onUpdate:isOpen": _cache[1] || (_cache[1] = ($event) => _ctx.isOpen = $event),
		class: "input-documentation-modal",
		dismissible: true,
		maximizable: false,
		"dismiss-on-click-outside": true,
		onClose: _cache[2] || (_cache[2] = ($event) => _ctx.close())
	}, {
		header: withCtx(() => [createVNode(_component_HorizontalLayout, { "vertical-align": "center" }, {
			default: withCtx(() => [createVNode(_component_Image, {
				name: "info",
				size: "extralarge",
				class: "input-documentation-modal-icon"
			}), createVNode(_component_Text, {
				size: "extralarge",
				weight: "strong"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
				_: 3
			})]),
			_: 3
		})]),
		body: withCtx(() => [renderSlot(_ctx.$slots, "body", {}, void 0, true)]),
		_: 3
	}, 8, ["is-open"])], 64);
}
var InputDocumentationButton_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputDocumentationButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$31], ["__scopeId", "data-v-089db859"]]);
//#endregion
//#region src/components/InputLabel/InputLabel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$26 = ["for"];
var _hoisted_2$15 = {
	key: 0,
	class: "input-label-required"
};
//#endregion
//#region src/components/InputLabel/InputLabel.vue
var InputLabel_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputLabel",
	props: /* @__PURE__ */ mergeDefaults({
		size: {},
		weight: {},
		label: {},
		required: { type: Boolean },
		documentation: {},
		htmlFor: {},
		aiSuggestion: {}
	}, {
		...smallTextPropsDefaults,
		documentation: void 0,
		htmlFor: void 0,
		aiSuggestion: void 0
	}),
	emits: ["aiApply", "aiCancel"],
	setup(__props) {
		const { classes } = useText(__props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: "extrasmall",
				"vertical-align": "center",
				wrap: false,
				class: "input-label"
			}, {
				default: withCtx(() => [
					createElementVNode("label", {
						for: __props.htmlFor,
						class: normalizeClass(unref(classes))
					}, [
						createTextVNode(toDisplayString(__props.label) + " ", 1),
						createVNode(AiSuggestionIndicator_default, {
							suggestion: __props.aiSuggestion,
							onApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
							onCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
						}, null, 8, ["suggestion"]),
						__props.required ? (openBlock(), createElementBlock("span", _hoisted_2$15, " *")) : createCommentVNode("", true)
					], 10, _hoisted_1$26),
					__props.documentation ? (openBlock(), createBlock(InputDocumentationButton_default, { key: 0 }, {
						header: withCtx(() => [createTextVNode(toDisplayString(__props.label), 1)]),
						body: withCtx(() => [createVNode(MarkdownViewer_default, {
							source: __props.documentation,
							sanitize: true
						}, null, 8, ["source"])]),
						_: 1
					})) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "default", {}, void 0, true)
				]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-cd57ec2c"]]);
//#endregion
//#region src/components/InputMessage/InputMessage.vue
var InputMessage_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputMessage",
	props: {
		text: {},
		severity: {}
	},
	setup(__props) {
		const props = __props;
		const textClass = computed(() => {
			switch (props.severity) {
				case "information": return "input-message-information";
				case "warning": return "input-message-warning";
				default: return "input-message-error";
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Text_default, {
				size: "small",
				"max-lines": 1,
				tooltip: __props.text,
				class: normalizeClass(["input-message", textClass.value])
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(__props.text), 1)]),
				_: 1
			}, 8, ["tooltip", "class"]);
		};
	}
}), [["__scopeId", "data-v-15f4f591"]]);
//#endregion
//#region src/components/ComboboxV2/Combobox.ts?vue&type=script&src=true&lang.ts
var Combobox_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Combobox",
	components: {
		Button: Button_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		PrimeSelect
	},
	props: {
		...inputProps,
		modelValue: {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object
			],
			default: null
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		allowFreeValue: {
			type: Boolean,
			default: false
		},
		values: {
			type: Array,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayTrigger: {
			type: Boolean,
			default: true
		},
		onLazyLoad: {
			type: Function,
			default: void 0
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	emits: [...inputEmits, "update:invalidValue"],
	setup(props, { emit, slots }) {
		const localizator = useLocalizator();
		const { translate } = useGlobalResourceManager();
		const isClearable = computed(() => !props.disabled && !props.readonly && !props.required);
		const showClearButton = computed(() => props.modelValue != null);
		const hasValueSlot = computed(() => !!slots.value || !!slots.option && !props.displayProperty);
		const isDropdownListOpen = ref(false);
		async function handleDropdownListBeforeOpen() {
			if (props.onLazyLoad && comboboxInstance.value) {
				await props.onLazyLoad();
				comboboxInstance.value.alignOverlay();
			}
		}
		function handleDropdownListOpen() {
			isDropdownListOpen.value = true;
		}
		function handleDropdownListClose() {
			isDropdownListOpen.value = false;
		}
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const comboboxInstance = ref();
		let originalOnKeyDown;
		watch(comboboxInstance, (instance) => {
			input.value = instance?.$refs.focusInput;
			if (instance != null) {
				originalOnKeyDown = instance.onKeyDown;
				instance.onKeyDown = (e) => handleKeyDownOnInstance(e);
			}
			if (props.inputDisplayMode === "datagrid" && !isDropdownListOpen.value && !props.readonly && !props.disabled) setTimeout(() => input.value?.focus(), 0);
		}, { immediate: true });
		const invalidValue = useInputInvalidValue(props, emit);
		const modelValueEx = computed({
			get: () => props.modelValue,
			set: (v) => {
				if (v !== props.modelValue) emit("update:modelValue", v);
			}
		});
		const optionLabel = computed(() => props.displayProperty ? formatOptionItem : void 0);
		function handleClearButtonClick(event) {
			modelValueEx.value = null;
			event.stopPropagation();
		}
		function searchOptionByValue(value) {
			if (props.values == null) return;
			if (props.valueProperty == null) return props.values.find((o) => o == value);
			return props.values.find((o) => o[props.valueProperty] == value);
		}
		function emitIfInvalid(value) {
			if (value == null || props.values == null) {
				invalidValue.value = null;
				return;
			}
			if (searchOptionByValue(value) == null) invalidValue.value = value;
			else invalidValue.value = null;
		}
		watch([() => props.modelValue, () => props.values], () => {
			emitIfInvalid(props.modelValue);
		}, { immediate: true });
		function handleKeyDownOnInstance(event) {
			if ((event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter") && !event.altKey && props.inputDisplayMode === "datagrid" && !isDropdownListOpen.value) return;
			originalOnKeyDown.call(comboboxInstance.value, event);
		}
		function handleMousedownOnOpenPanel(event) {
			if (props.inputDisplayMode === "datagrid") event.preventDefault();
		}
		function formatCustomCaptionProperty(caption) {
			if (caption == null) return;
			if (typeof caption !== "object" || caption instanceof Date) return caption.toString();
			return localizator.translate(caption);
		}
		function formatOptionItem(option) {
			if (props.displayProperty == null) return formatCustomCaptionProperty(option);
			return formatCustomCaptionProperty(option[props.displayProperty]);
		}
		function formatInputValue(value, placeholder) {
			const option = searchOptionByValue(value);
			if (option != null) return formatOptionItem(option);
			if (invalidValue.value != null) return invalidValue.value;
			return placeholder;
		}
		return {
			translate,
			comboboxInstance,
			modelValueEx,
			id,
			classes,
			dropdownStyle: computed(() => props.displayTrigger ? void 0 : "display: none"),
			isClearable,
			showClearButton,
			isLabelVisible,
			isMessageVisible,
			hasValueSlot,
			tabIndex,
			optionLabel,
			formatOptionItem,
			formatInputValue,
			searchOptionByValue,
			handleClearButtonClick,
			handleDropdownListBeforeOpen,
			handleDropdownListOpen,
			handleDropdownListClose,
			handleMousedownOnOpenPanel
		};
	}
});
//#endregion
//#region src/components/ComboboxV2/Combobox.vue
var _hoisted_1$25 = {
	key: 0,
	class: "combobox-before-content"
};
var _hoisted_2$14 = { class: "combobox-value neos-vertical-content" };
var _hoisted_3$5 = {
	key: 1,
	class: "combobox-after-content"
};
function _sfc_render$30(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Button = resolveComponent("Button");
	const _component_PrimeSelect = resolveComponent("PrimeSelect");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["combobox neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_PrimeSelect, {
		id: _ctx.id,
		ref: "comboboxInstance",
		modelValue: _ctx.modelValueEx,
		"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.modelValueEx = $event),
		class: "neos-input-content",
		options: _ctx.values,
		"option-value": _ctx.valueProperty,
		"option-label": _ctx.optionLabel,
		disabled: _ctx.disabled || _ctx.readonly,
		editable: _ctx.allowFreeValue,
		pt: {
			option: {
				class: "neos-vertical-content",
				onMousedown: _ctx.handleMousedownOnOpenPanel
			},
			dropdown: { style: _ctx.dropdownStyle }
		},
		loading: _ctx.loading,
		tabindex: _ctx.tabIndex,
		placeholder: _ctx.placeholder,
		onBeforeShow: _ctx.handleDropdownListBeforeOpen,
		onShow: _ctx.handleDropdownListOpen,
		onHide: _ctx.handleDropdownListClose
	}, createSlots({
		value: withCtx(({ value, placeholder }) => [
			_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_1$25, [renderSlot(_ctx.$slots, "before")])) : createCommentVNode("", true),
			createElementVNode("div", _hoisted_2$14, [_ctx.hasValueSlot && _ctx.searchOptionByValue(value) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.$slots.value ? renderSlot(_ctx.$slots, "value", {
				key: 0,
				option: _ctx.searchOptionByValue(value)
			}) : renderSlot(_ctx.$slots, "option", {
				key: 1,
				option: _ctx.searchOptionByValue(value)
			})], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(toDisplayString(_ctx.formatInputValue(value, placeholder)), 1)], 64))]),
			_ctx.$slots.default || _ctx.isClearable ? (openBlock(), createElementBlock("div", _hoisted_3$5, [renderSlot(_ctx.$slots, "default"), _ctx.isClearable ? withDirectives((openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-clear-button",
				size: "small",
				variant: "ghost",
				icon: "erase",
				tabindex: "-1",
				onClick: _ctx.handleClearButtonClick
			}, null, 8, ["onClick"])), [[vShow, _ctx.showClearButton]]) : createCommentVNode("", true)])) : createCommentVNode("", true)
		]),
		_: 2
	}, [_ctx.$slots.option ? {
		name: "option",
		fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
		key: "0"
	} : void 0, _ctx.loading ? {
		name: "empty",
		fn: withCtx(() => [createElementVNode("span", null, toDisplayString(_ctx.translate("Loading")), 1)]),
		key: "1"
	} : void 0]), 1032, [
		"id",
		"modelValue",
		"options",
		"option-value",
		"option-label",
		"disabled",
		"editable",
		"pt",
		"loading",
		"tabindex",
		"placeholder",
		"onBeforeShow",
		"onShow",
		"onHide"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var Combobox_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Combobox_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$30]]);
//#endregion
//#region src/components/BooleanCombobox/BooleanCombobox.vue
var BooleanCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "BooleanCombobox",
	props: {
		...inputProps,
		modelValue: {
			type: Boolean,
			default: void 0
		},
		trueDisplay: {
			type: String,
			default: "Yes"
		},
		falseDisplay: {
			type: String,
			default: "No"
		},
		nullDisplay: {
			type: String,
			default: "Undefined"
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		const values = [
			{
				caption: translate(props.trueDisplay),
				value: true
			},
			{
				caption: translate(props.falseDisplay),
				value: false
			},
			{
				caption: translate(props.nullDisplay),
				value: null
			}
		];
		function handleChange(value) {
			emit("update:modelValue", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Combobox_default, {
				focused: unref(focused),
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => isRef(focused) ? focused.value = $event : null),
				"model-value": __props.modelValue,
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				readonly: _ctx.readonly,
				required: _ctx.required,
				"input-display-mode": _ctx.inputDisplayMode,
				"tab-stop": _ctx.tabStop,
				values,
				"value-property": "value",
				"display-property": "caption",
				"onUpdate:modelValue": handleChange
			}, null, 8, [
				"focused",
				"model-value",
				"label",
				"label-position",
				"readonly",
				"required",
				"input-display-mode",
				"tab-stop"
			]);
		};
	}
});
//#endregion
//#region src/components/Card/Card.ts?vue&type=script&src=true&lang.ts
var Card_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Card",
	components: { VerticalLayout: VerticalLayout_default },
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		}
	},
	setup() {
		useComponentAutomationProperties();
	}
});
//#endregion
//#region src/components/Card/Card.vue
function _sfc_render$29(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		space: _ctx.space,
		align: _ctx.align,
		class: "card"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 8, ["space", "align"]);
}
var Card_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Card_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$29], ["__scopeId", "data-v-a6c80180"]]);
//#endregion
//#region src/components/Carousel/Carousel.vue
var Carousel_default = /* @__PURE__ */ defineComponent({
	__name: "Carousel",
	props: {
		source: {},
		pageSize: { default: 1 },
		scrollStep: { default: 1 },
		autoScrollInterval: { default: 0 },
		circular: { type: Boolean },
		navigationArrows: {
			type: Boolean,
			default: true
		},
		paginationIndicators: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Carousel), {
				value: __props.source,
				"num-visible": __props.pageSize,
				"num-scroll": __props.scrollStep,
				"autoplay-interval": __props.autoScrollInterval,
				circular: __props.circular,
				"show-navigators": __props.navigationArrows,
				"show-indicators": __props.paginationIndicators
			}, {
				item: withCtx((slotProps) => [renderSlot(_ctx.$slots, "item", { context: slotProps.data })]),
				_: 3
			}, 8, [
				"value",
				"num-visible",
				"num-scroll",
				"autoplay-interval",
				"circular",
				"show-navigators",
				"show-indicators"
			]);
		};
	}
});
//#endregion
//#region src/components/Chart/Chart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$24 = { class: "chart" };
var _hoisted_2$13 = { ref: "canvas" };
//#endregion
//#region src/components/Chart/Chart.vue
var Chart_default = /* @__PURE__ */ defineComponent({
	__name: "Chart",
	props: {
		type: {},
		data: {},
		options: { default: () => ({}) }
	},
	setup(__props) {
		const props = __props;
		const canvasElement = useTemplateRef("canvas");
		const chart = shallowRef();
		onMounted(() => {
			init();
		});
		onBeforeUnmount(() => {
			destroy();
		});
		watch([
			() => props.type,
			() => props.data,
			() => props.options
		], () => {
			init();
		});
		async function init() {
			const { Chart } = await import("chart.js/auto");
			Chart.register(annotationPlugin);
			destroy();
			chart.value = new Chart(canvasElement.value, {
				type: props.type,
				data: props.data,
				options: props.options
			});
		}
		function destroy() {
			if (chart.value) {
				chart.value.destroy();
				chart.value = void 0;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$24, [createElementVNode("canvas", _hoisted_2$13, null, 512)]);
		};
	}
});
//#endregion
//#region src/components/Checkbox/Checkbox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$23 = { class: "checkbox-content neos-input-content" };
var _hoisted_2$12 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
//#endregion
//#region src/components/Checkbox/Checkbox.vue
var Checkbox_default = /* @__PURE__ */ defineComponent({
	__name: "Checkbox",
	props: /* @__PURE__ */ mergeModels({
		...inputProps,
		labelPosition: {
			type: String,
			default: "right"
		}
	}, {
		"modelValue": {
			type: Boolean,
			default: false
		},
		"modelModifiers": {}
	}),
	emits: /* @__PURE__ */ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["neos-input checkbox", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				class: "checkbox-content-input-label",
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", _hoisted_1$23, [withDirectives(createElementVNode("input", {
				id: unref(id),
				ref: (el) => input.value = el,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => modelValue.value = $event),
				type: "checkbox",
				checked: modelValue.value,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex)
			}, null, 8, _hoisted_2$12), [[vModelCheckbox, modelValue.value]]), renderSlot(_ctx.$slots, "default")])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/Chip/Chip.ts?vue&type=script&src=true&lang.ts
var Chip_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Chip",
	components: { PrimeChip }
});
//#endregion
//#region src/components/Chip/Chip.vue
function _sfc_render$28(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_PrimeChip = resolveComponent("PrimeChip");
	return openBlock(), createBlock(_component_PrimeChip, null, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 3
	});
}
var Chip_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Chip_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$28]]);
//#endregion
//#region src/composables/useDatagridAddRow.ts
var AddRow = class extends Row {
	constructor(..._args) {
		super(..._args);
		this.isAddRow = true;
	}
};
/**
* Gets the functionalities of the add row of the data grid.
*/
function useDatagridAddRow(emit) {
	async function addRowAdding(grid) {
		if (grid.editableCollectionView) {
			grid.finishEditing();
			return !!await new Promise((resolve) => {
				emit("addRowAdding", resolve);
			});
		}
		return false;
	}
	async function addRowCommitting(grid) {
		if (grid.editableCollectionView && grid.editableCollectionView.currentAddItem) {
			const currentRow = grid.rows[grid.selection.row];
			if (currentRow) {
				grid.finishEditing();
				const cancelable = grid.editableCollectionView.currentAddItem !== currentRow.dataItem;
				const committed = await new Promise((resolve) => {
					emit("addRowCommitting", cancelable, resolve);
				});
				if (committed) addAddRow(grid);
				return committed;
			}
		}
		return false;
	}
	return {
		buildAddRow,
		addRowAdding,
		addRowCommitting
	};
}
/**
* Adds the add row.
*/
function addAddRow(grid) {
	if (!grid.rows.some((r) => r instanceof AddRow)) {
		grid.rows.push(new AddRow());
		return true;
	}
	return false;
}
/**
* Removes the add row.
*/
function removeAddRow(grid) {
	const index = grid.rows.findIndex((r) => r instanceof AddRow);
	if (index !== -1) {
		grid.rows.splice(index, 1);
		return true;
	}
	return false;
}
/**
* Builds the add row.
*/
function buildAddRow(grid, addRow = true) {
	let built = false;
	if (grid.editableCollectionView) {
		if (!addRow || grid.editableCollectionView.isAddingNew) built ||= removeAddRow(grid);
		if (addRow && !grid.editableCollectionView.isAddingNew) built ||= addAddRow(grid);
	}
	return built;
}
//#endregion
//#region src/composables/useDatagridCheckboxCell.ts
function isIndeterminateCheckboxCell(column, value) {
	return column.isExpressionCode && typeof value === "string" && value.startsWith("=");
}
function getCheckboxCellValue(value) {
	if (value === true || value === "true") return true;
	if (value === false || value === "false") return false;
}
function changeCheckboxCellValue(columns, hit, readOnly) {
	const col = hit.getColumn();
	const column = columns.get(col.name);
	const row = hit.getRow();
	if (!column || readOnly(col, row.dataItem)) return;
	const newValue = getNewCheckboxCellValue(column, row.dataItem[column.name]);
	if (newValue !== void 0) row.dataItem[column.name] = newValue;
}
function getNewCheckboxCellValue(column, value) {
	if (!column.isExpressionCode) return !value;
	if (value === "true") return "false";
	if (value === "false") return "true";
}
//#endregion
//#region src/composables/useDatagridDragDrop.ts
var dragScrollEdgeThreshold = 48;
var dragScrollStep = 24;
var undefinedHit$1 = {
	hit: void 0,
	row: void 0
};
var _dragRow;
var _dragRowElement;
var _dropRowElement;
function useDatagridDragDrop(props, grid) {
	const rowDragDrop = computed(() => !!props.rowDrop);
	function handleDragstart(event) {
		const { hit, row } = getHit(event);
		if (!row) {
			_dragRow = void 0;
			return;
		}
		_dragRow = row;
		_dragRowElement = getRowElement(hit);
		_dragRowElement.setAttribute("data-drag", "true");
		if (event.dataTransfer) {
			event.dataTransfer.effectAllowed = "move";
			event.dataTransfer.setDragImage(_dragRowElement, 0, 0);
		}
	}
	function handleDragover(event) {
		if (!_dragRow) return;
		updateAutoScroll(event);
		const { hit, row } = getHit(event);
		if (!row || row.dataIndex === _dragRow.dataIndex) {
			resetDropRow();
			return;
		}
		if (hit.target.parentElement === _dropRowElement) {
			event.preventDefault();
			return;
		}
		if (!props.rowDragover || props.rowDragover({
			item: row.dataItem,
			newIndex: row.dataIndex
		})) {
			event.preventDefault();
			resetDropRow();
			_dropRowElement = getRowElement(hit);
			_dropRowElement.setAttribute("data-drop", row.dataIndex > _dragRow.dataIndex ? "bottom" : "top");
		}
	}
	function handleDrop(event) {
		if (!_dragRow || !props.rowDrop) return;
		const draggedRow = _dragRow;
		_dragRow = void 0;
		const { row } = getHit(event);
		if (!row) return;
		props.rowDrop({
			item: draggedRow.dataItem,
			newIndex: row.dataIndex
		});
	}
	function handleDragend() {
		resetDragRow();
		resetDropRow();
	}
	function getHit(event) {
		if (grid.value && event.target instanceof HTMLElement && event.target.closest(".row-drag-col")) {
			const hit = grid.value.hitTest(event);
			if (hit.cellType === CellType.Cell && hit.getColumn().name === "$$row-drag") {
				const row = hit.getRow();
				if (row.dataItem) return {
					hit,
					row
				};
			}
		}
		return undefinedHit$1;
	}
	function getRowElement(hit) {
		return hit.target.parentElement;
	}
	function updateAutoScroll(event) {
		const scrollRoot = getScrollRoot();
		if (!scrollRoot) return;
		const maxScrollTop = scrollRoot.scrollHeight - scrollRoot.clientHeight;
		if (maxScrollTop <= 0) return;
		const scrollRootRect = scrollRoot.getBoundingClientRect();
		if (event.clientY <= scrollRootRect.top + dragScrollEdgeThreshold) {
			scrollRoot.scrollTop = Math.max(0, scrollRoot.scrollTop - dragScrollStep);
			return;
		}
		if (event.clientY >= scrollRootRect.bottom - dragScrollEdgeThreshold) scrollRoot.scrollTop = Math.min(maxScrollTop, scrollRoot.scrollTop + dragScrollStep);
	}
	function getScrollRoot() {
		return grid.value?._root;
	}
	function resetDragRow() {
		_dragRow = void 0;
		if (_dragRowElement) {
			_dragRowElement.removeAttribute("data-drag");
			_dragRowElement = void 0;
		}
	}
	function resetDropRow() {
		if (_dropRowElement) {
			_dropRowElement.removeAttribute("data-drop");
			_dropRowElement = void 0;
		}
	}
	onScopeDispose(() => {
		resetDragRow();
		resetDropRow();
	});
	return {
		rowDragDrop,
		handleDragstart,
		handleDragover,
		handleDragend,
		handleDrop
	};
}
//#endregion
//#region src/utils/datagridUtils.ts
function isAddRow(row) {
	return row instanceof AddRow;
}
function isDetailRow(row) {
	return row instanceof DetailRow;
}
function isGroupRow(row) {
	return row instanceof GroupRow;
}
function isSingleColumnRow(row) {
	return isDetailRow(row) || isGroupRow(row);
}
function isSystemRow(row) {
	return isAddRow(row) || isSingleColumnRow(row);
}
function isEditingCell(grid, row, col) {
	if (!grid.editRange) return false;
	if (col === void 0) return grid.editRange.containsRow(row);
	return grid.editRange.contains(row, col);
}
function hitTestContainsColumn(hit, col) {
	if (hit.mergedRange) return hit.mergedRange.containsColumn(col);
	return hit.col === col;
}
function adjustColumnIndexForMergedRange(gridPanel, rowIndex, colIndex, backward) {
	const mergedRange = gridPanel.grid.getMergedRange(gridPanel, rowIndex, colIndex);
	if (mergedRange) return backward ? mergedRange.col : mergedRange.col2;
	return colIndex;
}
//#endregion
//#region src/composables/useDatagridMergeManager.ts
function useDatagridMergeManager(props, grid, systemColumnCount, columnsMap) {
	watch([grid, () => props.colspan], ([grid, colspan]) => {
		if (grid) {
			if (colspan) grid.mergeManager = new CustomMergeManager(colspan, systemColumnCount, columnsMap);
			else if (grid.mergeManager instanceof CustomMergeManager) grid.mergeManager = new MergeManager();
		}
	});
}
var CustomMergeManager = class extends MergeManager {
	constructor(colspan, systemColumnCount, columnsMap) {
		super();
		this.colspan = colspan;
		this.systemColumnCount = systemColumnCount;
		this.columnsMap = columnsMap;
	}
	getMergedRange(p, r, c) {
		if (p.cellType !== CellType.Cell) return null;
		if (c < this.systemColumnCount.value) return null;
		const column = p.columns[c];
		if (!column?.name) return null;
		const row = p.rows[r];
		if (!row || isSystemRow(row)) return null;
		const item = row?.dataItem;
		if (!item) return null;
		const colspan = this.getColspan(item, column);
		const range = colspan === -1 ? this.getFullRowRange(p, r) : this.getPartialRowRange(p, r, c, item, colspan);
		if (range.col === range.col2) return null;
		return range;
	}
	getFullRowRange(p, r) {
		return new CellRange(r, this.systemColumnCount.value, r, p.columns.length - 1);
	}
	getPartialRowRange(p, r, c, item, colspan) {
		let c1 = c;
		for (let i = c - 1; i >= this.systemColumnCount.value; i--) {
			const colspan = this.getColspan(item, p.columns[i]);
			if (i + colspan >= c) c1 = i;
		}
		return new CellRange(r, c1, r, c + colspan);
	}
	getColspan(item, column) {
		return this.colspan({
			item,
			column: this.columnsMap.value.get(column.name)
		});
	}
};
//#endregion
//#region src/composables/useDatagridRowActions.ts
var undefinedHit = {
	hit: void 0,
	row: void 0,
	item: void 0
};
function getHit(grid, event) {
	const hit = grid.hitTest(event);
	if (hit.cellType === CellType.Cell) {
		const row = hit.getRow();
		if (row?.dataItem && !isSystemRow(row)) return {
			hit,
			row,
			item: row.dataItem
		};
	}
	return undefinedHit;
}
function useDatagridRowActions(props, grid) {
	const rowActionsElement = shallowRef();
	const currentRow = shallowRef();
	const rowActionsItem = computed(() => currentRow.value?.item);
	watch(grid, (newGrid, oldGrid) => {
		if (oldGrid) {
			oldGrid.beginningEdit.removeHandler(handleBeginningEdit);
			oldGrid._root.removeEventListener("scroll", handleScroll);
			oldGrid._root.removeEventListener("mouseleave", handleMouseleave);
			oldGrid._root.removeEventListener("mousemove", handleMousemouse);
		}
		if (newGrid) {
			newGrid.beginningEdit.addHandler(handleBeginningEdit);
			newGrid._root.addEventListener("scroll", handleScroll);
			newGrid._root.addEventListener("mouseleave", handleMouseleave);
			newGrid._root.addEventListener("mousemove", handleMousemouse);
		}
	}, { immediate: true });
	async function handleMousemouse(event) {
		if (!grid.value || !rowActionsElement.value) return;
		if (currentRow.value && currentRow.value.target === event.target) return;
		const { hit, row, item } = getHit(grid.value, event);
		if (!hit || isEditingCell(grid.value, hit.row)) {
			resetCurrentRow();
			return;
		}
		if (currentRow.value && currentRow.value.item === item) return;
		currentRow.value = {
			item,
			rowIndex: hit.row,
			target: event.target
		};
		rowActionsElement.value.removeAttribute("style");
		await nextTick();
		if (rowActionsElement.value.parentElement !== grid.value._root) grid.value._root.append(rowActionsElement.value);
		const cell = grid.value.cells.getCellElement(hit.row, hit.col);
		const height = row.height ?? grid.value.rows.defaultSize;
		const top = Number(cell.style.top.substring(0, cell.style.top.length - 2));
		rowActionsElement.value.style.display = "flex";
		rowActionsElement.value.style.height = `${height - 4}px`;
		rowActionsElement.value.style.top = `${grid.value.columnHeaders.rows.minSize + top + 2}px`;
		rowActionsElement.value.style.left = `${Math.min(grid.value.cells.hostElement.offsetWidth, grid.value._root.clientWidth + grid.value._root.scrollLeft) - rowActionsElement.value.clientWidth - 4}px`;
	}
	function handleMouseleave() {
		if (!isDropdownActive()) resetCurrentRow();
	}
	function handleBeginningEdit() {
		resetCurrentRow();
	}
	function handleScroll() {
		resetCurrentRow();
	}
	function resetCurrentRow() {
		currentRow.value = void 0;
		if (rowActionsElement.value) rowActionsElement.value.style.display = "none";
	}
	function isInRowActions(target) {
		return rowActionsElement.value?.contains(target) ?? false;
	}
	return {
		rowActionsItem,
		rowActionsElement,
		isInRowActions
	};
}
//#endregion
//#region src/composables/useDatagridRowDetail.ts
function useDatagridRowDetail(props) {
	const rowDetailComponent = ref();
	function isRowDetailVisible(row) {
		return rowDetailComponent.value?.control.isDetailVisible(row) ?? false;
	}
	function getRowDetailColumnIcon(row) {
		return isRowDetailVisible(row) ? "chevronDown" : "chevronRight";
	}
	function toggleRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (isRowDetailVisible(row)) rowDetailComponent.value.control.hideDetail(row);
		else rowDetailComponent.value.control.showDetail(row, props.rowDetailVisibilityMode === "single");
		return true;
	}
	function expandRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (!isRowDetailVisible(row)) {
			rowDetailComponent.value.control.showDetail(row, false);
			return true;
		}
		return false;
	}
	function expandRowDetailsOnLoad(rows, currentRowIndex) {
		if (!props.rowDetailExpandedByDefault) return false;
		if (props.rowDetailVisibilityMode === "single") {
			const currentRow = rows[currentRowIndex];
			if (currentRow) return expandRowDetail(currentRow);
			return false;
		}
		for (const row of rows) if (!isSystemRow(row)) expandRowDetail(row);
		return true;
	}
	function expandRowDetailOnAdd(row) {
		if (!props.rowDetailExpandedByDefault) return false;
		return expandRowDetail(row);
	}
	return {
		rowDetailComponent,
		getRowDetailColumnIcon,
		toggleRowDetail,
		expandRowDetailsOnLoad,
		expandRowDetailOnAdd
	};
}
//#endregion
//#region src/composables/useDatagridValidation.ts
var validationTooltips = {
	error: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-error"
	}),
	warning: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-warning"
	}),
	information: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-information"
	})
};
validationTooltips.error.popup.addHandler(popupHandler);
validationTooltips.warning.popup.addHandler(popupHandler);
validationTooltips.information.popup.addHandler(popupHandler);
function popupHandler(sender, args) {
	ZIndex.set("tooltip", args.tip);
	Control._POPUP_ZINDEX = Number(args.tip.style.zIndex);
	ZIndex.clear(args.tip);
}
function useDatagridValidation() {
	function setCellValidationMessage(cell, message) {
		if (message) {
			cell.classList.add(`${message.severity}-cell`);
			validationTooltips[message.severity].setTooltip(cell, message.text);
		} else for (const severity of validationMessageSeverities) {
			cell.classList.remove(`${severity}-cell`);
			validationTooltips[severity].setTooltip(cell, null);
		}
	}
	onUnmounted(() => {
		for (const tooltip of Object.values(validationTooltips)) tooltip.dispose();
	});
	return { setCellValidationMessage };
}
//#endregion
//#region src/exporting/utils.ts
function createTempCellElement(grid) {
	const element = document.createElement("div");
	element.style.visibility = "hidden";
	grid.cells.hostElement.append(element);
	element.dispose = () => {
		grid.cellFactory.disposeCell(element);
		element.remove();
	};
	return element;
}
function getDisplayTemplateText(grid, row, col, tempCellElement) {
	function getTempCellTextContent(el) {
		grid.cellFactory.updateCell(grid.cells, row, col, el);
		return el.innerText;
	}
	if (tempCellElement) return getTempCellTextContent(tempCellElement);
	const element = createTempCellElement(grid);
	const text = getTempCellTextContent(element);
	element.dispose();
	return text;
}
//#endregion
//#region src/utils/DatagridCollectionView.ts
var DatagridCollectionView = class {
	constructor() {
		this.sourceCollection = [];
		this.items = [];
		this.canFilter = true;
		this.canGroup = true;
		this.canSort = true;
		this.currentPosition = -1;
		this.isEditingItem = false;
		this.filter = () => true;
		this.groupDescriptions = new ObservableArray$1();
		this.groups = [];
		this.sortDescriptions = new ObservableArray$1();
		this.collectionChanged = new Event$1();
		this.currentChanged = new Event$1();
		this.currentChanging = new Event$1();
	}
	get isEmpty() {
		return this.sourceCollection.length === 0;
	}
	get canAddNew() {
		return true;
	}
	get canCancelEdit() {
		return true;
	}
	get canRemove() {
		return true;
	}
	get currentItem() {}
	get currentAddItem() {}
	get isAddingNew() {
		return false;
	}
	contains() {
		return true;
	}
	moveCurrentTo() {
		return true;
	}
	moveCurrentToFirst() {
		return true;
	}
	moveCurrentToLast() {
		return true;
	}
	moveCurrentToNext() {
		return true;
	}
	moveCurrentToPosition() {
		return true;
	}
	moveCurrentToPrevious() {
		return true;
	}
	refresh() {}
	beginUpdate() {}
	endUpdate() {}
	deferUpdate() {}
	addNew() {}
	commitNew() {}
	cancelNew() {}
	editItem() {}
	commitEdit() {}
	cancelEdit() {}
	remove() {}
	removeAt() {}
	implementsInterface(interfaceName) {
		return interfaceName === "INotifyCollectionChanged" || interfaceName === "ICollectionView" || interfaceName === "IEditableCollectionView";
	}
};
//#endregion
//#region src/utils/style.ts
/**
* Takes an abstracted single or multiple space value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiSpaceValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, SpaceValues);
}
/**
* Takes an abstracted single or multiple radius value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiRadiusValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, CornerRadiusValues);
}
/**
* Converts Neos content align values to PrimeVue divider align values.
* - We use culturally invariant vocabulary (e.g. 'start' | 'end').
* - Whereas PrimeVue uses occidental vocabulary (e.g. 'left' | 'right').
*/
function convertInvariantTextAlignToOccidentalTextAlign(align) {
	switch (align) {
		case "center": return "center";
		case "end": return "right";
		default: return "left";
	}
}
function convertTextAlignToAlignItems(align, explicitDefaultValue) {
	switch (align) {
		case "center": return "center";
		case "end": return "flex-end";
		case "start": return explicitDefaultValue ? "flex-start" : "";
		default: return "";
	}
}
/**
* (PRIVATE)
* Takes an abstracted single or multiple sizing value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getPredefinedSizingValue(abstractedValue, allowedSpacingValues) {
	const spaceAbstractValues = abstractedValue.replaceAll("'", "").split(" ").map((r) => allowedSpacingValues[r]);
	if (spaceAbstractValues.length > 0 && spaceAbstractValues.filter((s) => s === void 0).length === 0) return spaceAbstractValues.join(" ");
	return "";
}
/**
* Returns the value if it is a supported color name/value,
* or the value of the CSS variable with that name (`var(--thatParamValue)`).
*/
function getColorValue(value) {
	return value !== "background" && CSS.supports("color", value) ? value : `var(--${value})`;
}
//#endregion
//#region src/exporting/csv.ts
async function exportToCsvFile(grid, columns, systemColumnCount) {
	const csv = await getClipString(grid, columns, new CellRange(0, systemColumnCount, grid.rows.length - 1, grid.columns.length - 1));
	saveAs(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }), "export.csv");
}
/**
* The following code is coming from https://www.grapecity.com/forums/wijmo/subtotal-aggregated-column-identififcation.
* The original "getClipString" method uses raw values and not the displayed values.
**/
/* istanbul ignore next -- @preserve */
async function getClipString(grid, columns, rng) {
	const tempCellElement = createTempCellElement(grid);
	let text = `${getHeaderString(grid, rng, tempCellElement)}\n`;
	for (let r = rng.topRow; r <= rng.bottomRow; r++) {
		if (grid.rows[r] instanceof AddRow) continue;
		text += `${await getRowString(grid, columns, rng, tempCellElement, r)}\n`;
	}
	tempCellElement.dispose();
	return text;
}
/* istanbul ignore next -- @preserve */
function getHeaderString(grid, rng, tempCellElement) {
	let text = "";
	const row = grid.columnHeaders.rows.length - 1;
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		if (!grid.columns[c].isVisible) continue;
		if (!firstCell) text += ",";
		firstCell = false;
		grid.cellFactory.updateCell(grid.columnHeaders, row, c, tempCellElement);
		text += tempCellElement.querySelector(".column-caption")?.innerText?.replaceAll(",", "");
	}
	return text;
}
/* istanbul ignore next -- @preserve */
async function getRowString(grid, columns, rng, tempCellElement, r) {
	let text = "";
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		const col = grid.columns[c];
		if (!col.isVisible) continue;
		if (firstCell) firstCell = false;
		else text += ",";
		const column = columns.get(col.name);
		if (column) {
			if (column.displayTemplate) text += escapeValue(getDisplayTemplateText(grid, r, c, tempCellElement));
			else if (column.displayText) {
				const item = grid.rows[r].dataItem;
				const value = getPropertyByPath(item, column.name);
				text += escapeValue(await column.displayText(value, item));
			}
		}
	}
	return text;
}
function escapeValue(value) {
	return value.includes(",") || value.includes("\n") || value.includes("\"") ? `"${value.replaceAll("\"", "\"\"")}"` : value;
}
//#endregion
//#region src/exporting/xlsx.ts
async function exportToXlsxFile(grid, columns) {
	const { FlexGridXlsxConverter } = await import("@mescius/wijmo.grid.xlsx");
	const tempCellElement = createTempCellElement(grid);
	FlexGridXlsxConverter.saveAsync(grid, {
		includeStyles: false,
		includeColumns(col) {
			if (grid.collectionView.groupDescriptions.length > 0) {
				if (col.name === "$$row-indicator") return true;
				if (grid.collectionView.groupDescriptions.some((d) => d instanceof PropertyGroupDescription$1 && d.propertyName === col.name)) return false;
			}
			return columns.get(col.name)?.visible === true;
		},
		formatItem(args) {
			if (args.panel === grid.columnHeaders) formatColumnHeader(args, columns);
			else if (args.panel === grid.cells) formatCell(args, grid, columns, tempCellElement);
		}
	}, "export.xlsx");
	tempCellElement.dispose();
}
function formatColumnHeader(args, columns) {
	const col = args.getColumn();
	if (col.name === "$$row-indicator") args.xlsxCell.value = void 0;
	else {
		const column = columns.get(col.name);
		if (column) updateCellAlignment(args.xlsxCell.style, column.align);
	}
}
function formatCell(args, grid, columns, tempCellElement) {
	const item = args.getRow().dataItem;
	if (!item) {
		args.xlsxCell.value = void 0;
		return;
	}
	if (item instanceof CollectionViewGroup$1) formatGroupRowCell(args, grid, columns, item);
	else formatRowCell(args, grid, columns, tempCellElement, item);
}
function formatRowCell(args, grid, columns, tempCellElement, item) {
	const columnName = args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	args.xlsxCell.isDate = false;
	args.xlsxCell.isNumber = false;
	if (column.displayTemplate) args.xlsxCell.value = getDisplayTemplateText(grid, args.row, args.col, tempCellElement);
	else if (column.displayTextSync) {
		const value = getPropertyByPath(item, columnName);
		args.xlsxCell.value = column.displayTextSync(value, item);
	}
	updateCellAlignment(args.xlsxCell.style, column.align);
}
function formatGroupRowCell(args, grid, columns, item) {
	const groupDescription = item.groupDescription;
	const isFirstColumn = grid.columns.firstVisibleIndex === args.col;
	const columnName = isFirstColumn ? groupDescription.propertyName : args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	if (isFirstColumn && column.displayTextSync) args.xlsxCell.value = column.displayTextSync(item.name, item);
	updateCellAlignment(args.xlsxCell.style, isFirstColumn ? "start" : column.align);
}
function updateCellAlignment(style, align) {
	style.wordWrap = true;
	style.vAlign = 1;
	if (align === "end") style.hAlign = 3;
	else if (align === "center") style.hAlign = 2;
	else style.hAlign = 1;
}
//#endregion
//#region src/components/ContextMenuItem/ContextMenuItem.vue
var ContextMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenuItem",
	props: {
		item: {},
		props: {},
		hasSubmenu: {},
		size: {}
	},
	setup(__props) {
		const props = __props;
		const action = computed(() => props.props.action);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, mergeProps({
					"vertical-align": "center",
					wrap: false
				}, action.value), {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "context-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "context-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}, 16), __props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
					key: 0,
					name: "chevronRight",
					size: __props.size
				}, null, 8, ["size"])) : createCommentVNode("", true)]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/ContextMenu/ContextMenu.vue
var ContextMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const menu = ref();
		const pt = computed(() => ({ item: (options) => ({
			class: "context-menu-item",
			...options.context.item.attributes
		}) }));
		function toggle(event) {
			menu.value.toggle(event);
		}
		function show(event) {
			menu.value.show(event);
		}
		function hide() {
			menu.value.hide();
		}
		__expose({
			menu,
			toggle,
			show,
			hide
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeContextMenu), {
				ref_key: "menu",
				ref: menu,
				model: __props.items,
				popup: "",
				pt: pt.value
			}, {
				item: withCtx(({ item, props, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					props
				}, () => [createVNode(ContextMenuItem_default, {
					item,
					props,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"props",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 8, ["model", "pt"]);
		};
	}
});
//#endregion
//#region src/composables/useSpeech.ts
function useSpeech(props, culture, handleChange) {
	const speech = useSpeechRecognition({ lang: culture });
	/**
	* Indicates whether speech recognition is supported in the current browser and the speech button should be displayed.
	*/
	const displaySpeechButton = computed(() => props.speech && speech.isSupported.value);
	/**
	* Indicates whether the speech recognition is currently listening.
	*/
	const isListeningToSpeech = computed(() => speech.isListening.value);
	/**
	* Variant to apply to the speech button.
	*/
	const speechButtonVariant = computed(() => speech.isListening.value ? "ghost-primary" : "ghost");
	/**
	* The text that corresponds to the speech recognition result.
	*/
	const currentSpeech = ref(null);
	onMounted(() => {
		if (props.speech === "immediate") handleSpeechButtonClick();
	});
	watch([speech.result, speech.isFinal], ([result, isFinal]) => {
		currentSpeech.value = result;
		if (isFinal) {
			persistSpeech();
			speech.isListening.value = false;
		}
	});
	/**
	* Handles the click event of the speech button.
	* If speech recognition is already listening, it persists the current speech.
	*/
	function handleSpeechButtonClick() {
		if (speech.isListening.value) persistSpeech();
		speech.isListening.value = !speech.isListening.value;
	}
	function persistSpeech() {
		if (handleChange && currentSpeech.value !== null) handleChange(currentSpeech.value);
		currentSpeech.value = null;
	}
	return {
		currentSpeech,
		displaySpeechButton,
		handleSpeechButtonClick,
		isListeningToSpeech,
		speechButtonVariant
	};
}
/**
* Indicates whether the browser supports speech recognition.
* @returns true wen the browser supports speech recognition; otherwise false.
*/
function isSpeechSupported() {
	const w = window;
	return (w.SpeechRecognition ?? w.webkitSpeechRecognition) !== void 0;
}
//#endregion
//#region src/composables/useStringInput.ts
function useStringInput() {
	function normalizeWhiteSpaceInput(whiteSpaceHandling, inputText) {
		switch (whiteSpaceHandling) {
			case WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace:
			case WhiteSpaceHandling.noLeadingWhiteSpace: return inputText.trimStart();
			case WhiteSpaceHandling.noTrailingWhiteSpace: return inputText.trimEnd();
			case WhiteSpaceHandling.noWhiteSpace: return inputText.replaceAll(/\s/g, "");
		}
		return inputText;
	}
	function normalizeWhiteSpaceToEmit(whiteSpaceHandling, inputText) {
		if (whiteSpaceHandling === WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace) return inputText.trim();
		return inputText;
	}
	return {
		normalizeWhiteSpaceInput,
		normalizeWhiteSpaceToEmit
	};
}
//#endregion
//#region src/utils/focus.ts
function isTouchDevice() {
	return navigator.maxTouchPoints > 0;
}
function focusExceptOnTouchDevice(element) {
	if (element && !isTouchDevice()) element.focus();
}
//#endregion
//#region src/components/Textbox/Textbox.ts?vue&type=script&src=true&lang.ts
var datagridMinRows = 1;
var datagridMaxRows = 10;
var Textbox_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Textbox",
	components: {
		Button: Button_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		Image: Image_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: 10
		},
		tooltip: {
			type: String,
			default: void 0
		},
		clear: {
			type: Boolean,
			default: false
		},
		speech: {
			type: [Boolean, String],
			default: false
		},
		characterCasing: {
			type: String,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		}
	},
	emits: [
		...inputEmits,
		"input",
		"listeningToSpeech",
		"keydown"
	],
	setup(props, { emit, slots }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const { currentSpeech, displaySpeechButton, handleSpeechButtonClick, isListeningToSpeech, speechButtonVariant } = useSpeech(props, useLocalizator().currentCulture, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const displayDefaultSlotContainer = computed(() => slots.default !== void 0 || props.clear || displaySpeechButton.value);
		const localValue = ref(props.modelValue ?? "");
		const isInputEmpty = ref(localValue.value.length === 0);
		watch(() => props.modelValue, (newVal) => {
			localValue.value = newVal ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		});
		watch(currentSpeech, (speech) => {
			if (speech != null) {
				localValue.value = speech;
				isInputEmpty.value = localValue.value.length === 0;
			}
		});
		const hasSuggestionPlaceholder = computed(() => isInputEmpty.value && props.aiSuggestion?.suggestedValue != null);
		const suggestionPlaceholderText = computed(() => String(props.aiSuggestion.suggestedValue));
		const placeholderText = computed(() => {
			if (hasSuggestionPlaceholder.value) return;
			return props.placeholder ?? (isListeningToSpeech.value ? translate("ListeningToSpeech") : void 0);
		});
		const text = computed(() => localValue.value);
		const textareaRows = ref();
		const { normalizeWhiteSpaceInput, normalizeWhiteSpaceToEmit } = useStringInput();
		watch(() => props.rows, () => {
			if (props.inputDisplayMode === "form" && props.multiLines) textareaRows.value = props.rows;
		});
		watch(isListeningToSpeech, (value) => emit("listeningToSpeech", value));
		onMounted(() => {
			if (props.multiLines) if (props.inputDisplayMode === "datagrid") if (props.modelValue) textareaRows.value = Math.min(Math.max(props.modelValue.split(`\n`).length, datagridMinRows), datagridMaxRows);
			else textareaRows.value = datagridMinRows;
			else textareaRows.value = props.rows;
		});
		function handleFocus(event) {
			event.target.select();
		}
		function handleBeforeAfterContentFocusin() {
			focusExceptOnTouchDevice(input.value);
		}
		function handleChange(event) {
			if (props.updateMode === "default") {
				const element = event.target;
				emitNewValue(element.value);
			}
		}
		function handleInput(event) {
			const element = event.target;
			isInputEmpty.value = !element.value;
			if (element.value) {
				let value = element.value;
				switch (props.characterCasing) {
					case CharacterCasing.upperCasing:
						value = element.value.toUpperCase();
						break;
					case CharacterCasing.lowerCasing:
						value = element.value.toLocaleLowerCase();
						break;
				}
				value = normalizeWhiteSpaceInput(props.whiteSpaceHandling, value);
				if (value !== element.value) {
					const { selectionStart, selectionEnd } = element;
					element.value = value;
					element.setSelectionRange(selectionStart, selectionEnd);
				}
			}
			localValue.value = element.value;
			if (props.updateMode === "immediate") emitNewValue(element.value);
			emit("input", event);
		}
		function handleKeyDown(event) {
			if (hasSuggestionPlaceholder.value) {
				if (event.key === "Tab" && !event.shiftKey && !event.ctrlKey && !event.altKey) {
					event.preventDefault();
					event.stopPropagation();
					emit("aiApply");
					return;
				}
				if (event.key === "Escape") {
					event.preventDefault();
					event.stopPropagation();
					emit("aiCancel");
					return;
				}
			}
			if (props.inputDisplayMode === "datagrid" && props.multiLines) keyDown(event);
			emit("keydown", event);
		}
		function handleClearButtonClick() {
			emitNewValue(null);
			isInputEmpty.value = true;
			localValue.value = "";
		}
		function emitNewValue(value) {
			value = value !== "" ? value : null;
			const oldValue = props.modelValue;
			if (value) {
				switch (props.characterCasing) {
					case CharacterCasing.camelCasing:
						value = toCamelCase(value, true);
						break;
					case CharacterCasing.pascalCasing:
						value = toPascalCase(value);
						break;
				}
				value = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, value);
			}
			if (value != oldValue) emit("update:modelValue", value);
			if (value && (input.value instanceof HTMLInputElement || input.value instanceof HTMLTextAreaElement) && shouldResetInputValue(value, oldValue)) input.value.value = value;
			localValue.value = value ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		}
		function keyDown(event) {
			switch (event.key) {
				case "Enter":
					if (event.altKey && !event.ctrlKey && !event.shiftKey) {
						const textarea = event.target;
						let cursorPos = textarea.selectionEnd;
						let value = textarea.value;
						value = `${value.substring(0, cursorPos)}\n${value.substring(cursorPos)}`;
						textarea.value = value;
						cursorPos += 1;
						textarea.setSelectionRange(cursorPos, cursorPos);
						if (cursorPos === value.length) textarea.scrollTop = textarea.scrollHeight;
						event.stopPropagation();
					}
					break;
				case "ArrowUp":
				case "ArrowDown":
					if (!event.altKey && !event.ctrlKey && !event.shiftKey) event.stopPropagation();
					break;
			}
		}
		function shouldResetInputValue(newValue, oldValue) {
			return props.inputDisplayMode === "form" && newValue === oldValue;
		}
		return {
			aiSuggestion: computed(() => props.aiSuggestion),
			classes,
			displayDefaultSlotContainer,
			displaySpeechButton,
			handleBeforeAfterContentFocusin,
			handleChange,
			handleClearButtonClick,
			handleFocus,
			handleInput,
			handleKeyDown,
			handleSpeechButtonClick,
			hasSuggestionPlaceholder,
			id,
			input,
			isLabelVisible,
			isMessageVisible,
			placeholderText,
			speechButtonVariant,
			suggestionPlaceholderText,
			tabIndex,
			text,
			textareaRows
		};
	}
});
//#endregion
//#region src/components/Textbox/Textbox.vue
var _hoisted_1$22 = ["title"];
var _hoisted_2$11 = {
	key: 1,
	class: "textbox-suggestion-placeholder"
};
var _hoisted_3$4 = { class: "textbox-suggestion-text" };
var _hoisted_4$3 = [
	"id",
	"value",
	"disabled",
	"rows",
	"maxlength",
	"readonly",
	"tabindex",
	"placeholder"
];
var _hoisted_5$3 = [
	"id",
	"value",
	"tabindex",
	"placeholder",
	"maxlength",
	"disabled",
	"readonly"
];
function _sfc_render$27(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["textbox neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", {
		class: "textbox-content neos-input-content",
		title: _ctx.tooltip ?? void 0
	}, [
		_ctx.$slots.before ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: "textbox-before-content",
			onFocusin: _cache[2] || (_cache[2] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [renderSlot(_ctx.$slots, "before", {}, void 0, true)], 32)) : createCommentVNode("", true),
		_ctx.hasSuggestionPlaceholder ? (openBlock(), createElementBlock("div", _hoisted_2$11, [createVNode(_component_Image, {
			class: "textbox-suggestion-icon",
			name: "ai"
		}), createElementVNode("span", _hoisted_3$4, toDisplayString(_ctx.suggestionPlaceholderText), 1)])) : createCommentVNode("", true),
		_ctx.multiLines ? (openBlock(), createElementBlock("textarea", {
			key: 2,
			id: _ctx.id,
			ref: "input",
			value: _ctx.text,
			disabled: _ctx.disabled,
			rows: _ctx.textareaRows,
			maxlength: _ctx.maxLength,
			readonly: _ctx.readonly,
			class: "textbox-textarea",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[3] || (_cache[3] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[4] || (_cache[4] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}, "        ", 40, _hoisted_4$3)) : (openBlock(), createElementBlock("input", {
			key: 3,
			id: _ctx.id,
			ref: "input",
			type: "text",
			value: _ctx.text,
			class: "textbox-input",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			maxlength: _ctx.maxLength,
			disabled: _ctx.disabled,
			readonly: _ctx.readonly,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[6] || (_cache[6] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[7] || (_cache[7] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onFocus: _cache[8] || (_cache[8] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
			onKeydown: _cache[9] || (_cache[9] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}, null, 40, _hoisted_5$3)),
		_ctx.displayDefaultSlotContainer ? (openBlock(), createElementBlock("div", {
			key: 4,
			class: "textbox-after-content",
			onFocusin: _cache[12] || (_cache[12] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [
			renderSlot(_ctx.$slots, "default", {}, void 0, true),
			_ctx.displaySpeechButton ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-speech-button",
				size: "small",
				variant: _ctx.speechButtonVariant,
				icon: "microphone",
				tabindex: "-1",
				onClick: _cache[10] || (_cache[10] = ($event) => _ctx.handleSpeechButtonClick())
			}, null, 8, ["variant"])) : createCommentVNode("", true),
			_ctx.clear ? withDirectives((openBlock(), createBlock(_component_Button, {
				key: 1,
				class: "input-clear-button",
				size: "small",
				variant: "ghost",
				icon: "erase",
				tabindex: "-1",
				onClick: _cache[11] || (_cache[11] = ($event) => _ctx.handleClearButtonClick())
			}, null, 512)), [[vShow, _ctx.modelValue]]) : createCommentVNode("", true)
		], 32)) : createCommentVNode("", true)
	], 8, _hoisted_1$22)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var Textbox_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Textbox_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$27], ["__scopeId", "data-v-53a0603f"]]);
//#endregion
//#region src/components/DatagridColumnPicker/DatagridColumnPicker.ts?vue&type=script&src=true&lang.ts
var DatagridColumnPicker_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridColumnPicker",
	components: {
		Button: Button_default,
		Popover: Popover_default,
		Textbox: Textbox_default,
		VerticalLayout: VerticalLayout_default,
		WjListBox
	},
	props: {
		grid: {
			type: Object,
			required: true
		},
		columns: {
			type: Object,
			required: true
		}
	},
	emits: ["columnsChanged"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const popover = ref();
		const filter = ref();
		const pickerColumns = ref([]);
		watch(filter, () => pickerColumns.value = getColumns());
		function show(event) {
			pickerColumns.value = getColumns();
			popover.value.show(event);
		}
		function hide() {
			popover.value.hide();
		}
		function getColumns() {
			const cols = [];
			for (const column of props.grid.columns) {
				const col = column.name && props.columns.get(column.name);
				if (!col) continue;
				const caption = col.pickerCaption ?? col.caption;
				if (caption && col.movable !== false && (!filter.value || caption.toLowerCase().includes(filter.value.toLowerCase()))) cols.push({
					name: col.name,
					caption,
					visible: column.visible,
					visibleIndex: column.visibleIndex
				});
			}
			return cols.sort((a, b) => {
				if (a.visible && !b.visible) return -1;
				if (!a.visible && b.visible) return 1;
				if (a.visible && b.visible) return a.visibleIndex - b.visibleIndex;
				return a.caption.localeCompare(b.caption);
			});
		}
		function handleCheckedItemsChanged(listBox) {
			let changed = false;
			for (const column of props.grid.columns) if (pickerColumns.value.some((c) => c.name === column.name)) {
				const newVisible = listBox.checkedItems.some((c) => c.name === column.name);
				if (column.visible !== newVisible) {
					column.visible = newVisible;
					changed = true;
				}
			}
			if (changed) emit("columnsChanged", props.grid);
		}
		function handleFormatItem(listBox, args) {
			args.item.setAttribute("data-property", args.data.name);
		}
		return {
			translate,
			popover,
			pickerColumns,
			filter,
			show,
			hide,
			handleCheckedItemsChanged,
			handleFormatItem
		};
	}
});
//#endregion
//#region src/components/DatagridColumnPicker/DatagridColumnPicker.vue
function _sfc_render$26(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Textbox = resolveComponent("Textbox");
	const _component_WjListBox = resolveComponent("WjListBox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_Popover = resolveComponent("Popover");
	return openBlock(), createBlock(_component_Popover, {
		ref: "popover",
		class: "datagrid-column-picker"
	}, {
		default: withCtx(() => [createVNode(_component_VerticalLayout, { space: "small" }, {
			default: withCtx(() => [createVNode(_component_Textbox, {
				modelValue: _ctx.filter,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filter = $event),
				placeholder: _ctx.translate("Search"),
				"update-mode": "immediate"
			}, null, 8, ["modelValue", "placeholder"]), createVNode(_component_WjListBox, {
				"items-source": _ctx.pickerColumns,
				"display-member-path": "caption",
				"checked-member-path": "visible",
				"checked-items-changed": _ctx.handleCheckedItemsChanged,
				"format-item": _ctx.handleFormatItem,
				class: "datagrid-column-picker-list-box"
			}, null, 8, [
				"items-source",
				"checked-items-changed",
				"format-item"
			])]),
			_: 1
		})]),
		_: 1
	}, 512);
}
//#endregion
//#region src/components/DatagridContextMenu/DatagridContextMenu.ts?vue&type=script&src=true&lang.ts
var DatagridContextMenu_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridContextMenu",
	components: {
		DatagridColumnPicker: /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridColumnPicker_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$26], ["__scopeId", "data-v-7d1b0d37"]]),
		ContextMenu: ContextMenu_default
	},
	props: {
		grid: {
			type: Object,
			required: true
		},
		columns: {
			type: Object,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		systemColumnCount: {
			type: Number,
			required: true
		},
		groupable: {
			type: Boolean,
			required: true
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:groupPanelVisible", "columnsChanged"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const contextMenu = ref();
		const columnPickerEl = ref();
		const contextMenuItems = ref([]);
		async function toggle(event) {
			const hit = hitTest(event);
			if (hit) {
				contextMenuItems.value = getMenuItems(hit);
				if (contextMenuItems.value.length > 0) {
					await nextTick();
					event.preventDefault();
					columnPickerEl.value.hide();
					contextMenu.value.show(event);
				}
			}
		}
		function hitTest(event) {
			const hit = props.grid.hitTest(event);
			return hit.cellType === CellType.ColumnHeader || hit.cellType === CellType.Cell ? hit : void 0;
		}
		function getMenuItems(hit) {
			if (hit.cellType === CellType.Cell) return getCellMenuItems(hit);
			return getColumnHeaderMenuItems(hit);
		}
		function getCellMenuItems(hit) {
			if (!props.getRowContextMenuItems) return [];
			const item = hit.getRow()?.dataItem;
			if (!item || item instanceof CollectionViewGroup$1) return [];
			return props.getRowContextMenuItems(item, () => contextMenu.value.hide());
		}
		function getColumnHeaderMenuItems(hit) {
			const column = hit.getColumn();
			const col = props.columns.get(column.name);
			const items = [];
			if (props.groupable) {
				if (col) items.push({
					label: translate("GroupByColumn"),
					icon: "addGroup",
					attributes: { "data-command": "GROUP_BY_COLUMN" },
					disabled: !col.groupable,
					command() {
						contextMenu.value.hide();
						hit.grid.collectionView.groupDescriptions.push(new PropertyGroupDescription$1(column.name));
						column.visible = false;
						emit("update:groupPanelVisible", true);
					}
				});
				items.push({
					label: props.groupPanelVisible ? translate("HideGroupPanel") : translate("ShowGroupPanel"),
					icon: "groupPanel",
					attributes: { "data-command": "TOGGLE_GROUP_PANEL" },
					command() {
						contextMenu.value.hide();
						emit("update:groupPanelVisible", !props.groupPanelVisible);
					}
				});
			}
			if (props.exportable) {
				if (items.length > 0) items.push({ separator: true });
				items.push({
					label: translate("ExportDisplayedDataToCsvFile"),
					icon: "csv",
					disabled: hit.grid.collectionView.groupDescriptions.length > 0,
					attributes: { "data-command": "EXPORT_TO_CSV" },
					command() {
						contextMenu.value.hide();
						exportToCsvFile(hit.grid, props.columns, props.systemColumnCount);
					}
				}, {
					label: translate("ExportDisplayedDataToXlsxFile"),
					icon: "excel",
					attributes: { "data-command": "EXPORT_TO_XLSX" },
					command() {
						contextMenu.value.hide();
						exportToXlsxFile(hit.grid, props.columns);
					}
				});
			}
			if (props.columnPicker) {
				if (items.length > 0) items.push({ separator: true });
				if (col) items.push({
					label: translate("HideColumn"),
					icon: "removeColumn",
					attributes: { "data-command": "HIDE_COLUMN" },
					command() {
						contextMenu.value.hide();
						hit.grid.finishEditing();
						column.visible = false;
						emitColumnsChanged(hit.grid);
					}
				});
				items.push({
					label: translate("ChooseColumns"),
					icon: "columnPicker",
					attributes: { "data-command": "SHOW_COLUMN_PICKER" },
					async command() {
						columnPickerEl.value.show({ currentTarget: props.grid._eCHdr });
					}
				});
			}
			return items;
		}
		function emitColumnsChanged(grid) {
			emit("columnsChanged", grid);
		}
		return {
			translate,
			contextMenu,
			contextMenuItems,
			columnPickerEl,
			toggle,
			emitColumnsChanged
		};
	}
});
//#endregion
//#region src/components/DatagridContextMenu/DatagridContextMenu.vue
function _sfc_render$25(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ContextMenu = resolveComponent("ContextMenu");
	const _component_DatagridColumnPicker = resolveComponent("DatagridColumnPicker");
	return _ctx.contextMenuItems.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_ContextMenu, {
		ref: "contextMenu",
		items: _ctx.contextMenuItems,
		class: "datagrid-context-menu",
		size: "small"
	}, null, 8, ["items"]), createVNode(_component_DatagridColumnPicker, {
		ref: "columnPickerEl",
		grid: _ctx.grid,
		columns: _ctx.columns,
		onColumnsChanged: _ctx.emitColumnsChanged
	}, null, 8, [
		"grid",
		"columns",
		"onColumnsChanged"
	])], 64)) : createCommentVNode("", true);
}
var DatagridContextMenu_default = /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridContextMenu_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$25]]);
//#endregion
//#region src/components/DatagridGroupPanel/DatagridGroupPanel.ts?vue&type=script&src=true&lang.ts
var DatagridGroupPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridGroupPanel",
	components: { WjGroupPanel },
	props: {
		grid: {
			type: Object,
			default: void 0
		},
		draggingColumn: {
			type: Object,
			default: void 0
		}
	},
	emits: ["sort"],
	setup(props, { emit }) {
		const root = ref();
		const { translate } = useGlobalResourceManager();
		watch([root, () => props.grid], () => {
			if (root.value && props.grid) {
				root.value.control.grid = props.grid;
				root.value.control._updateSort = function(event, marker) {
					const index = this._getElementIndex(marker);
					const groupDescription = this._gds[index];
					emit("sort", event, this._g.getColumn(groupDescription.propertyName));
				};
			}
		});
		function handleInitialization(panel) {
			panel.hostElement.addEventListener("drop", (e) => {
				if (props.draggingColumn && !props.draggingColumn.groupable) e.stopImmediatePropagation();
			}, true);
		}
		return {
			root,
			translate,
			handleInitialization
		};
	}
});
//#endregion
//#region src/components/DatagridGroupPanel/DatagridGroupPanel.vue
function _sfc_render$24(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_WjGroupPanel = resolveComponent("WjGroupPanel");
	return openBlock(), createBlock(_component_WjGroupPanel, {
		ref: "root",
		placeholder: _ctx.translate("GroupPanelPlaceholder"),
		initialized: _ctx.handleInitialization,
		class: "datagrid-group-panel"
	}, null, 8, ["placeholder", "initialized"]);
}
var DatagridGroupPanel_default = /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridGroupPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$24]]);
//#endregion
//#region src/components/LottieImage/LottieImage.vue
var LottieImage_default = /* @__PURE__ */ defineComponent({
	__name: "LottieImage",
	props: {
		name: {},
		dataPromise: {},
		loop: {
			type: [Boolean, Number],
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const images = useImages();
		const image = computed(() => images[props.name]);
		const root = ref();
		let animation = void 0;
		watch(root, async () => {
			if (!animation && root.value) {
				const value = root.value;
				animation = Lottie.loadAnimation({
					container: value,
					animationData: (await props.dataPromise()).default,
					loop: props.loop
				});
				intersectionObserver.observe(value);
			} else intersectionObserver.disconnect();
		});
		onBeforeUnmount(() => {
			animation?.destroy();
			intersectionObserver.disconnect();
		});
		const intersectionObserver = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && animation) animation.play();
			else if (animation) animation.pause();
		});
		return (_ctx, _cache) => {
			return image.value ? (openBlock(), createBlock(Image_default, {
				key: 0,
				name: __props.name
			}, null, 8, ["name"])) : (openBlock(), createElementBlock("div", {
				key: 1,
				ref_key: "root",
				ref: root
			}, null, 512));
		};
	}
});
//#endregion
//#region src/components/DatagridNoDataOverlay/DatagridNoDataOverlay.ts?vue&type=script&src=true&lang.ts
var DatagridNoDataOverlay_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridNoDataOverlay",
	components: {
		Image: Image_default,
		LottieImage: LottieImage_default,
		Text: Text_default,
		VerticalLayout: VerticalLayout_default
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		return { translate };
	}
});
//#endregion
//#region src/components/DatagridNoDataOverlay/DatagridNoDataOverlay.vue
var _hoisted_1$21 = { class: "datagrid-no-data-overlay-action" };
function _sfc_render$23(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_LottieImage = resolveComponent("LottieImage");
	const _component_Text = resolveComponent("Text");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, { class: "datagrid-no-data-overlay" }, {
		default: withCtx(() => [createVNode(_component_VerticalLayout, {
			align: "center",
			space: "large"
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, () => [
				createVNode(_component_LottieImage, {
					name: "datagridNoData",
					"data-promise": () => import("./DatagridNoData-BqiVLs76.js"),
					class: "datagrid-no-data-image"
				}),
				createVNode(_component_Text, { size: "large" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translate("NoDataFound")), 1)]),
					_: 1
				}),
				createElementVNode("div", _hoisted_1$21, [renderSlot(_ctx.$slots, "action", {}, void 0, true)])
			], true)]),
			_: 3
		})]),
		_: 3
	});
}
var DatagridNoDataOverlay_default = /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridNoDataOverlay_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$23], ["__scopeId", "data-v-ec1ce91b"]]);
//#endregion
//#region src/components/DatagridSummaryCell/DatagridSummaryCell.ts?vue&type=script&src=true&lang.ts
var DatagridSummaryCell_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridSummaryCell",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default
	},
	props: {
		types: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		value: {
			type: Number,
			required: true
		},
		format: {
			type: String,
			default: void 0
		},
		align: {
			type: String,
			default: "left"
		},
		tag: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		const currentType = computed(() => props.types[props.type]);
		return {
			typeTag: computed(() => props.tag ? currentType.value?.tag : void 0),
			typeCaption: computed(() => currentType.value?.caption ?? void 0),
			formattedValue: computed(() => props.format ? Globalize.format(props.value, props.format) : props.value)
		};
	}
});
//#endregion
//#region src/components/DatagridSummaryCell/DatagridSummaryCell.vue
var _hoisted_1$20 = {
	key: 0,
	class: "tag"
};
function _sfc_render$22(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		align: _ctx.align,
		space: "extrasmall",
		"vertical-align": "center",
		wrap: false,
		class: "datagrid-summary-cell neos-fill-parent-width",
		"data-type": _ctx.type,
		title: _ctx.typeCaption
	}, {
		default: withCtx(() => [_ctx.typeTag ? (openBlock(), createElementBlock("span", _hoisted_1$20, toDisplayString(_ctx.typeTag), 1)) : createCommentVNode("", true), createVNode(_component_Text, {
			size: "small",
			weight: "strong",
			class: "value"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formattedValue), 1)]),
			_: 1
		})]),
		_: 1
	}, 8, [
		"align",
		"data-type",
		"title"
	]);
}
var DatagridSummaryCell_default = /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridSummaryCell_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$22], ["__scopeId", "data-v-ea7512a0"]]);
//#endregion
//#region src/components/DotLoader/DotLoader.vue
var DotLoader_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DotLoader",
	props: { size: { default: "medium" } },
	setup(__props) {
		const props = __props;
		const loaderClasses = computed(() => [`dot-loader-${props.size}`]);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["dot-loader", loaderClasses.value]) }, [..._cache[0] || (_cache[0] = [
				createElementVNode("div", { class: "dot-loader-dot-1" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-2" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-3" }, null, -1)
			])], 2);
		};
	}
}), [["__scopeId", "data-v-85a86eeb"]]);
//#endregion
//#region src/components/LoadingOverlay/LoadingOverlay.ts?vue&type=script&src=true&lang.ts
var LoadingOverlay_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "LoadingOverlay",
	components: {
		DotLoader: DotLoader_default,
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		message: {
			type: String,
			default: void 0
		},
		focusTrap: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const root = ref();
		let modalCount = 0;
		let returnFocusElement = null;
		const { activate, deactivate } = useFocusTrap(root, {
			allowOutsideClick: true,
			fallbackFocus: document.createElement("div"),
			setReturnFocus: () => {
				if (returnFocusElement) {
					const el = returnFocusElement;
					returnFocusElement = null;
					return el;
				}
				return false;
			}
		});
		watch(() => props.message, () => {
			if (props.focusTrap && props.message) {
				modalCount = document.querySelectorAll(".modal").length;
				returnFocusElement = document.activeElement;
			}
		});
		watch([() => props.focusTrap, root], ([focusTrap, el]) => {
			if (focusTrap && el) activate();
			else {
				if (document.querySelectorAll(".modal").length > modalCount) returnFocusElement = null;
				deactivate();
			}
		}, {
			immediate: true,
			flush: "post"
		});
		return { root };
	}
});
//#endregion
//#region src/components/LoadingOverlay/LoadingOverlay.vue
function _sfc_render$21(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DotLoader = resolveComponent("DotLoader");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(Transition, { name: "loading-overlay" }, {
		default: withCtx(() => [_ctx.message ? (openBlock(), createBlock(_component_VerticalLayout, {
			key: 0,
			ref: "root",
			align: "center",
			class: "loading-overlay"
		}, {
			default: withCtx(() => [createVNode(_component_HorizontalLayout, {
				space: "extrasmall",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(_component_DotLoader), createVNode(_component_Text, { tabindex: "0" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.message), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 512)) : createCommentVNode("", true)]),
		_: 1
	});
}
var LoadingOverlay_default = /* @__PURE__ */ _plugin_vue_export_helper_default(LoadingOverlay_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$21], ["__scopeId", "data-v-7bcfd36a"]]);
//#endregion
//#region src/components/Datagrid/Datagrid.ts?vue&type=script&src=true&lang.ts
/**
* Restore columns aggregate.
*/
function restoreColumnsAggregate(grid, columnsMap) {
	for (const column of grid.columns) {
		const col = columnsMap.get(column.name);
		if (col && col.groupSummaryType !== void 0 && grid.collectionView && !grid.collectionView.groupDescriptions.some((gd) => gd.propertyName === column.name)) column.aggregate = Aggregate$1.Sum;
		else column.aggregate = Aggregate$1.None;
	}
}
/**
* Restore group rows state.
*/
function restoreGroupRowsState(grid) {
	grid.restoringGroupRowsState = true;
	for (const row of grid.rows) if (isGroupRow(row)) {
		Object.defineProperty(row, "hasChildren", { value: true });
		row.isCollapsed = row.dataItem.isCollapsed;
	}
	grid.restoringGroupRowsState = false;
}
/**
* Gets the visible columns.
*/
function getVisibleColumns(grid) {
	return grid.columns.filter((c) => c.isVisible);
}
/**
* Autosizes the grid columns.
*/
function autoSizeGridColumns(grid, columnsMap, firstRender) {
	let totalWidth = 8;
	const columns = getVisibleColumns(grid);
	for (let index = 0; index < columns.length; index++) {
		const column = columns[index];
		const neosColumn = column.name && columnsMap.get(column.name);
		if (!neosColumn || neosColumn.width != null) {
			totalWidth += column.renderWidth;
			continue;
		}
		grid.autoSizeColumn(column.index, false);
		if (index === columns.length - 1) {
			let width = column.renderWidth;
			if (neosColumn.minInitialWidth && neosColumn.minInitialWidth > width) width = neosColumn.minInitialWidth;
			if (totalWidth + width <= grid._root.clientWidth) column.width = firstRender ? "*" : grid._root.clientWidth - totalWidth;
			else if (width > column.renderWidth) column.width = width;
		} else if (neosColumn.minInitialWidth && neosColumn.minInitialWidth > column.renderWidth) column.width = neosColumn.minInitialWidth;
		totalWidth += column.renderWidth;
	}
}
/**
* Autosizes the grid rows.
*/
function autoSizeGridRows(grid, autoRowHeight) {
	if (autoRowHeight) grid.autoRowHeights = true;
	return autoRowHeight;
}
/**
* Hides grouping columns.
*/
function hideGroupingColumns(grid) {
	for (const groupDescription of grid.collectionView.groupDescriptions) {
		const propertyName = groupDescription.propertyName;
		const column = grid.columns.getColumn(propertyName);
		if (column) column.visible = false;
	}
}
/**
* Converts the boolean to the visibility value.
*/
function convertBooleanToVisibility(visible) {
	return visible ? void 0 : "hidden";
}
/**
* Gets the selection mode by mouse event.
*/
function getSelectionModeByMouseEvent(event) {
	if (event.shiftKey && !event.ctrlKey) return "range";
	if (event.ctrlKey && !event.shiftKey) return "multi";
	if (event.button === 2) return "single-select-only";
	return "single";
}
function convertColumnWidth(width) {
	if (width == null) return width;
	if (typeof width === "number") return width;
	if (typeof width !== "string") return width;
	const trimmedWidth = width.trim();
	if (trimmedWidth.endsWith("*")) return width;
	const parsedWidth = Number(trimmedWidth);
	return Number.isNaN(parsedWidth) ? width : parsedWidth;
}
function canNavigateWithArrowKey(event) {
	return !event.altKey && !isDropdownActive();
}
function handleKeyNavigation(event) {
	event.preventDefault();
	event.stopImmediatePropagation();
}
var Datagrid_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Datagrid",
	components: {
		DatagridContextMenu: DatagridContextMenu_default,
		DatagridGroupPanel: DatagridGroupPanel_default,
		DatagridNoDataOverlay: DatagridNoDataOverlay_default,
		DatagridSummaryCell: DatagridSummaryCell_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		InputDocumentationButton: InputDocumentationButton_default,
		LoadingOverlay: LoadingOverlay_default,
		MarkdownViewer: MarkdownViewer_default,
		VerticalLayout: VerticalLayout_default,
		WjFlexGrid,
		WjFlexGridCellTemplate,
		WjFlexGridColumn,
		WjFlexGridDetail
	},
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		source: {
			type: Object,
			required: true
		},
		editable: {
			type: Boolean,
			default: false
		},
		addRow: {
			type: Boolean,
			default: false
		},
		groupable: {
			type: Boolean,
			default: false
		},
		selectionColumn: {
			type: Boolean,
			default: true
		},
		selectionColumnHeader: {
			type: Boolean,
			default: true
		},
		onSelectionColumnHeaderCheck: {
			type: Function,
			default: void 0
		},
		selectionBinding: {
			type: String,
			default: void 0
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		noDataOverlay: {
			type: Boolean,
			default: true
		},
		rowHeight: {
			type: Number,
			default: 56
		},
		autoRowHeight: {
			type: Boolean,
			default: false
		},
		infiniteScrolling: {
			type: Boolean,
			default: false
		},
		enterKeyActsAsTab: {
			type: Boolean,
			default: false
		},
		summaries: {
			type: Object,
			default: void 0
		},
		booleanDisplayMode: {
			type: String,
			default: "checkbox"
		},
		resizeColumnsOnFirstLoad: {
			type: Boolean,
			default: false
		},
		resizeColumnsOnRefresh: {
			type: Boolean,
			default: false
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		},
		summaryTag: {
			type: Boolean,
			default: true
		},
		rowDetailVisibilityMode: {
			type: String,
			default: "single"
		},
		rowDetailExpandedByDefault: {
			type: Boolean,
			default: false
		},
		rowDragover: {
			type: Function,
			default: void 0
		},
		rowDrop: {
			type: Function,
			default: void 0
		},
		colspan: {
			type: Function,
			default: void 0
		}
	},
	emits: [
		"update:groupPanelVisible",
		"rowClick",
		"rowDoubleClick",
		"rowSelect",
		"formatCell",
		"validateCell",
		"positionChanging",
		"addRowAdding",
		"addRowCommitting",
		"loadRows",
		"toggleGroup",
		"columnsChanged"
	],
	setup(props, { emit, slots }) {
		const { translate } = useGlobalResourceManager();
		const columnsMap = computed(() => new Map(props.columns.map((c) => [c.name, c])));
		const hasColumnHeaderContextMenu = computed(() => props.groupable || props.columnPicker || props.exportable);
		const headerSelectorValue = ref(false);
		const isGroupPanelVisible = useVModel(props, "groupPanelVisible", emit, { passive: true });
		/**
		* Grid.
		*/
		const _grid = shallowRef();
		/**
		* Gets the system column count.
		*/
		const systemColumnCount = computed(() => {
			let count = 0;
			if (rowDragDrop.value) count++;
			if (slots["row-detail"]) count++;
			if (slots["row-indicator"]) count++;
			if (props.selectionColumn) count++;
			return count;
		});
		/**
		* Value indicating whether the ready state of the grid.
		*/
		const readyState = ref();
		/**
		* Value indicating whether the grid is visible.
		*/
		const isVisible = computed(() => readyState.value === "visible");
		/**
		* Value indicating whether the grid is empty.
		*/
		const isEmpty = ref(false);
		/**
		* Value indicating whether the no data overlay is visible.
		*/
		const isNoDataOverlayVisible = ref(false);
		/**
		* Overlay message
		*/
		const loadingMessage = translate("LoadingData");
		const loadingOverlayMessage = computed(() => props.loading ? loadingMessage : void 0);
		/**
		* Value indicating whether the "stay in edit mode" is active.
		*/
		let stayInEditMode = false;
		/**
		* Last selected row index.
		*/
		let lastSelectedRowIndex = 0;
		/**
		* Value indicating whether the columns should be resized on next refresh.
		*/
		let resizeColumnsOnNextRefresh = props.resizeColumnsOnFirstLoad;
		/**
		* Value indicating whether the row details should be expanded on next refresh.
		*/
		let expandRowDetailsOnLoadOnNextRefresh = props.rowDetailExpandedByDefault;
		/**
		* Dragging column.
		*/
		const draggingColumn = ref();
		/**
		* Context menu instance.
		*/
		const contextMenu = ref();
		/**
		* Display column sort index.
		*/
		const displayColumnSortIndex = ref(false);
		const { setCellValidationMessage } = useDatagridValidation();
		const { buildAddRow, addRowAdding, addRowCommitting } = useDatagridAddRow(emit);
		const { rowDetailComponent, getRowDetailColumnIcon, toggleRowDetail, expandRowDetailsOnLoad, expandRowDetailOnAdd } = useDatagridRowDetail(props);
		const { rowDragDrop, handleDragstart, handleDragover, handleDragend, handleDrop } = useDatagridDragDrop(props, _grid);
		const { rowActionsItem, rowActionsElement, isInRowActions } = useDatagridRowActions(props, _grid);
		useDatagridMergeManager(props, _grid, systemColumnCount, columnsMap);
		watch(() => props.summaries, () => _grid.value && buildSummaryRow(_grid.value));
		watch(() => props.addRow, () => _grid.value && buildAddRow(_grid.value, props.addRow));
		watch(() => props.rowHeight, () => _grid.value && setRowHeight(_grid.value));
		function handleInitialization(grid) {
			_grid.value = grid;
			grid._cvCollectionChanged = handleCollectionChanged;
			grid.columnHeaders.rows.minSize = 40;
			grid.rows.onCollectionChanged = handleRowsCollectionChanged;
			const originalGetDesiredWidth = grid["_getDesiredWidth"];
			grid["_getDesiredWidth"] = function(p, r, c, e) {
				const width = originalGetDesiredWidth.call(this, p, r, c, e);
				e.innerHTML = "";
				return width;
			};
			setRowHeight(grid);
			setFrozenColumns(grid);
			grid._wantsInput = isDropdownActive;
			grid.select(-1, -1);
			buildSummaryRow(grid);
		}
		function setRowHeight(grid) {
			grid.rows.defaultSize = props.rowHeight;
			if (!slots["row-detail"]) {
				grid.rows.minSize = props.rowHeight;
				if (!props.autoRowHeight) grid.rows.maxSize = props.rowHeight;
			}
		}
		function setFrozenColumns(grid) {
			const frozenColumns = props.columns.filter((c) => c.frozen);
			if (frozenColumns.length > 0) grid.frozenColumns = frozenColumns.length + systemColumnCount.value;
			else grid.frozenColumns = 0;
		}
		function resetColumns() {
			if (_grid.value) {
				setFrozenColumns(_grid.value);
				autoSizeGridColumns(_grid.value, columnsMap.value, false);
			}
		}
		function refresh() {
			if (_grid.value) _grid.value.invalidate(false);
		}
		/**
		* Handles the collection changed to update the rows.
		*/
		function handleCollectionChanged(sender, args) {
			switch (args.action) {
				case NotifyCollectionChangedAction$1.Change:
					handleChangeCollectionChanged(this, args);
					break;
				case NotifyCollectionChangedAction$1.Add: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const newRow = new Row(args.item);
					this.rows.insert(args.index, newRow);
					expandRowDetailOnAdd(newRow);
					break;
				}
				case NotifyCollectionChangedAction$1.Remove: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const index = this.rows.findIndex((r) => r.dataItem === args.item);
					if (index !== -1) this.rows.removeAt(index);
					break;
				}
				default:
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					expandRowDetailsOnLoadOnNextRefresh ||= props.rowDetailExpandedByDefault;
					this._bindGrid(false);
					break;
			}
		}
		function handleSuggestionChange(grid, args, column) {
			if (!args.isSuggestionChange) return false;
			const rowIndex = args.index;
			const colIndex = column.index;
			if (grid.currentEditingCell?.col === column && grid.currentEditingCell.row === grid.rows[rowIndex]) return true;
			if (rowIndex !== void 0 && rowIndex >= 0 && colIndex >= 0) grid.refreshRange(new CellRange(rowIndex, colIndex, rowIndex, colIndex));
			return true;
		}
		function handleChangeCollectionChanged(grid, args) {
			if (props.selectionBinding && args.col === props.selectionBinding) {
				grid.invalidate(false);
				return;
			}
			const column = grid.columns.find((c) => c.name === args.col);
			if (!column?.isVisible) return;
			resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
			if (handleSuggestionChange(grid, args, column)) return;
			if (grid.currentEditingCell) {
				if (grid.currentEditingCell.col === column && grid.currentEditingCell.row === grid.rows[args.index]) {
					grid.currentEditingCell.value = args.value;
					return;
				}
				grid.stayInEditModeWhileInvalidating = true;
			}
			grid.invalidate(false);
		}
		function handleLoadedRows(grid) {
			if (!_grid.value) handleInitialization(grid);
			if (grid.collectionView) {
				restoreColumnsAggregate(grid, columnsMap.value);
				restoreGroupRowsState(grid);
			}
		}
		/**
		* Handles the refreshing event.
		*/
		function handleRefreshing(grid) {
			if (!readyState.value && grid.hostElement.clientHeight > 0) {
				let deferVisible = false;
				isGroupPanelVisible.value ??= grid.collectionView.groupDescriptions.length > 0;
				isNoDataOverlayVisible.value = props.noDataOverlay && grid.hostElement.clientHeight >= 340;
				autoSizeGridColumns(grid, columnsMap.value, true);
				deferVisible ||= autoSizeGridRows(grid, props.autoRowHeight);
				hideGroupingColumns(grid);
				buildAddRow(grid, props.addRow);
				readyState.value = deferVisible ? "initialized" : "visible";
			} else if (readyState.value === "initialized") readyState.value = "visible";
			else if (resizeColumnsOnNextRefresh && grid.rows.some((r) => !isSystemRow(r))) {
				autoSizeGridColumns(grid, columnsMap.value, false);
				resizeColumnsOnNextRefresh = false;
			}
			loadRowsIfInfiniteScrollingAndNoScroll(grid);
			displayColumnSortIndex.value = grid.collectionView.sortDescriptions.length > 1;
		}
		/**
		* Handles the refreshed event.
		*/
		function handleRefreshed(grid) {
			if (isVisible.value && grid.collectionView instanceof DatagridCollectionView) {
				if (grid.collectionView.lastAddedItem) {
					if (grid.collectionView.lastAddedItem !== grid.collectionView.currentAddItem) selectLastAddedItem(grid, grid.collectionView.lastAddedItem);
					grid.collectionView.lastAddedItem = void 0;
				} else if (grid.collectionView.currentItem) selectCurrentItem(grid);
			}
		}
		/**
		* Selects the first editable cell of the row of the last added item.
		*/
		function selectLastAddedItem(grid, lastAddedItem) {
			const colIndex = getFirstEditableColIndex(grid, lastAddedItem);
			selectCell(grid, grid.rows.findIndex((r) => r.dataItem === lastAddedItem), colIndex);
		}
		/**
		* Selects the current item.
		*/
		function selectCurrentItem(grid) {
			let currentRowIndex = grid.selection.row;
			const currentRow = grid.rows[currentRowIndex];
			if (isDetailRow(currentRow)) currentRowIndex--;
			const rowIndex = grid.rows.findIndex((r) => r.dataItem === grid.collectionView.currentItem);
			if (rowIndex !== currentRowIndex) grid.select(rowIndex, grid.selection.col);
			if (expandRowDetailsOnLoadOnNextRefresh) {
				expandRowDetailsOnLoadOnNextRefresh = false;
				expandRowDetailsOnLoad(grid.rows, rowIndex);
			}
		}
		/**
		* Handles the rows collection changed event to refresh the grid.
		*/
		function handleRowsCollectionChanged() {
			this._dirty = true;
			isEmpty.value = this.length === 0;
			if (isVisible.value && !buildAddRow(this.grid, props.addRow)) this.grid.invalidate(true);
		}
		function handleItemsSourceChanged(grid) {
			if (grid.itemsSource) {
				grid.collectionView.collectionChanged.addHandler(updateHeaderSelectorValue);
				updateHeaderSelectorValue();
			}
		}
		/**
		* Updates the value of the header selector.
		*/
		function updateHeaderSelectorValue() {
			if (_grid.value && props.selectionBinding && _grid.value.collectionView && _grid.value.collectionView.items.length > 0) {
				let headerSelectorValueChecked = true;
				for (const item of _grid.value.collectionView.items) if (!item[props.selectionBinding]) {
					headerSelectorValueChecked = false;
					break;
				}
				headerSelectorValue.value = headerSelectorValueChecked;
			}
		}
		/**
		* Handles the mousedown event.
		*/
		async function handleMousedown(event) {
			if (!_grid.value) return;
			if (event.target instanceof HTMLElement && event.target.getAttribute("wj-part") === "root") {
				event.preventDefault();
				return;
			}
			const hit = _grid.value.hitTest(event);
			if (props.selectionColumn && props.selectionBinding !== void 0 && hit.col === systemColumnCount.value - 1) handleMousedownOnSelectionCell(event, hit, props.selectionBinding);
			else if (hit.cellType === CellType.Cell) await handleMousedownOnCell(_grid.value, event, hit);
		}
		async function handleMousedownOnSelectionCell(event, hit, selectionBinding) {
			if (props.selectionColumnHeader && props.onSelectionColumnHeaderCheck && hit.cellType === CellType.ColumnHeader) {
				event.preventDefault();
				const newValue = !headerSelectorValue.value;
				if (await props.onSelectionColumnHeaderCheck(newValue)) headerSelectorValue.value = newValue;
				return;
			}
			const row = hit.getRow();
			if (hit.cellType === CellType.Cell && row.dataItem) {
				event.preventDefault();
				emitRowSelect(row.dataItem, !row.dataItem[selectionBinding]);
			}
		}
		async function handleMousedownOnCell(grid, event, hit) {
			const row = hit.getRow();
			if (isGroupRow(row)) {
				event.stopImmediatePropagation();
				handleMousedownOnGroupRowCell(grid, event, hit, row);
				return;
			}
			if (row.dataItem !== grid.collectionView.currentItem) {
				event.stopImmediatePropagation();
				document.activeElement.blur();
				if (!await positionChanging(grid, hit.row)) return;
				selectCellAndRow();
			} else if (!hitTestContainsColumn(hit, grid.selection.col)) {
				event.stopImmediatePropagation();
				selectCellAndRow();
			} else selectRow(grid, hit.row);
			if (event.target instanceof HTMLElement && event.target.classList.contains("checkbox-cell")) changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
			if (hit.getColumn().name == "$$row-detail") toggleRowDetail(row);
			else emit("rowClick", row.dataItem);
			function selectCellAndRow() {
				grid._mouseHdl._selDown = grid.selection;
				selectCell(grid, hit.row, hit.col, event.button === 0);
				selectRow(grid, hit.row, getSelectionModeByMouseEvent(event));
			}
		}
		function handleMousedownOnGroupRowCell(grid, event, hit, row) {
			grid._mouseHdl._selDown = grid.selection;
			if (event.target instanceof HTMLElement && event.target.closest(".wj-elem-collapse")) row.isCollapsed = !row.isCollapsed;
			grid.select(hit.row, hit.col);
		}
		/**
		* Gets a value indicating whether the hit is on the row indicator column header.
		*/
		function isRowIndicatorColumnHeader(hit) {
			return hit.col === 0 && (rowDragDrop.value || slots["row-detail"] || slots["row-indicator"]);
		}
		/**
		* Changes the position.
		*/
		function positionChanging(grid, rowIndex) {
			let row = grid.rows[rowIndex];
			if (isDetailRow(row)) {
				if (rowIndex === grid.selection.row + 1) return Promise.resolve(true);
				row = grid.rows[rowIndex - 1];
			} else if (rowIndex === grid.selection.row - 1 && isDetailRow(grid.rows[grid.selection.row])) return Promise.resolve(true);
			if (isAddRow(row)) return addRowAdding(grid);
			return new Promise((resolve) => {
				const index = grid.collectionView.sourceCollection.indexOf(row.dataItem);
				emit("positionChanging", index, (canceled) => {
					if (!_grid.value) {
						resolve(false);
						return;
					}
					grid.focus();
					if (!canceled || index === -1) resolve(true);
					else resolve(false);
				});
			});
		}
		/**
		* Handles the click event.
		*/
		function handleClick(event) {
			if (!_grid.value) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType === CellType.ColumnHeader) handleClickOnColumnHeader(event, hit);
		}
		function handleClickOnColumnHeader(event, hit) {
			if (event.button !== 0) return;
			if (isRowIndicatorColumnHeader(hit)) {
				if (hasColumnHeaderContextMenu.value) toggleContextMenu(event);
			} else if (event.target instanceof HTMLElement && event.target.closest("[data-column]")) sortColumn(event, hit.getColumn());
		}
		function sortColumn(event, column) {
			if (!_grid.value || !column.name || !column.allowSorting) return;
			const currentSort = _grid.value.collectionView.sortDescriptions.find((s) => s.property === column.name);
			const sorts = event.ctrlKey ? _grid.value.collectionView.sortDescriptions.filter((s) => s.property !== column.name) : [];
			if (currentSort) {
				if (currentSort.ascending) sorts.push(new SortDescription$1(column.name, false));
			} else sorts.push(new SortDescription$1(column.name, true));
			_grid.value.collectionView.sortDescriptions.splice(0, _grid.value.collectionView.sortDescriptions.length, ...sorts);
		}
		function isSystemColumn(column) {
			return column.name?.startsWith("$$") || column.name === props.selectionBinding;
		}
		/**
		* Handles the double click event.
		*/
		function handleDoubleClick(event) {
			if (!_grid.value || isInRowActions(event.target)) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType === CellType.Cell && !isSystemColumn(hit.getColumn())) {
				const row = hit.getRow();
				if (!isSystemRow(row)) emit("rowDoubleClick", event, row.dataItem);
			}
		}
		/**
		* Handles the keydown event.
		*/
		function handleKeydown(event) {
			if (!_grid.value || _grid.value.rows.length === 0) return;
			if (event.defaultPrevented) return;
			const hit = _grid.value.hitTest(event.target);
			if (hit.cellType === CellType.Cell) {
				if (event.ctrlKey && event.key === "s") _grid.value.finishEditing(false);
				if (event.target instanceof HTMLElement && event.target.querySelector(".checkbox-cell") && event.key === " ") changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
			}
			handleKeyboardNavigation(_grid.value, event);
		}
		/**
		* Handles the navigation by keyboard.
		*/
		async function handleKeyboardNavigation(grid, event) {
			switch (event.key) {
				case "ArrowUp":
					await handleArrowUp(grid, event);
					break;
				case "ArrowDown":
					await handleArrowDown(grid, event);
					break;
				case "Enter":
					if (props.enterKeyActsAsTab) await handleTabKeyNavigation(grid, event);
					else await handleEnterNavigation(grid, event);
					break;
				case "Tab":
					await handleTabKeyNavigation(grid, event);
					break;
			}
		}
		async function handleTabKeyNavigation(grid, event) {
			const currentEditDelegatesToComponent = grid.currentEditDelegatesToComponent;
			grid.finishEditing();
			if (currentEditDelegatesToComponent) await new Promise((resolve) => {
				setTimeout(resolve);
			});
			await handleTabNavigation(grid, event);
		}
		/**
		* Handles the arrow up navigation.
		*/
		async function handleArrowUp(grid, event) {
			if (canNavigateWithArrowKey(event)) {
				const rowIndex = findPreviousVisibleRowIndex(grid, grid.selection.row);
				if (rowIndex !== void 0) {
					handleKeyNavigation(event);
					if (await positionChanging(grid, rowIndex)) {
						selectCell(grid, rowIndex, grid.selection.col);
						selectRow(grid, rowIndex, event.shiftKey ? "range" : "single");
					}
				}
			}
		}
		/**
		* Handles the arrow down navigation.
		*/
		async function handleArrowDown(grid, event) {
			if (canNavigateWithArrowKey(event)) {
				const rowIndex = await findNextVisibleRowIndex(grid, grid.selection.row);
				if (rowIndex !== void 0) {
					handleKeyNavigation(event);
					if (await positionChanging(grid, rowIndex)) {
						selectCell(grid, rowIndex, grid.selection.col);
						selectRow(grid, rowIndex, event.shiftKey ? "range" : "single");
					}
				}
			}
		}
		/**
		* Handles the enter navigation.
		*/
		async function handleEnterNavigation(grid, event) {
			if (isDropdownActive()) return;
			const rowIndex = event.shiftKey ? findPreviousVisibleRowIndex(grid, grid.selection.row) : await findNextVisibleRowIndex(grid, grid.selection.row);
			if (rowIndex !== void 0) {
				handleKeyNavigation(event);
				if (await positionChanging(grid, rowIndex)) {
					selectCell(grid, rowIndex, event.shiftKey ? grid.selection.col : getNextColumnIndexOnEnterNavigation(grid));
					selectRow(grid, rowIndex);
				}
			}
		}
		/**
		* Handles the tab navigation.
		*/
		async function handleTabNavigation(grid, event, rowIndex = grid.selection.row, colIndex = grid.selection.col, columns = getVisibleColumns(grid), lastColumnIndex = columns.length - 1) {
			colIndex = adjustColumnIndexForMergedRange(grid.cells, rowIndex, colIndex, event.shiftKey);
			let changePosition = false;
			const singleColumnRow = isSingleColumnRow(grid.rows[rowIndex]);
			if (event.shiftKey) if (colIndex > systemColumnCount.value && !singleColumnRow) colIndex--;
			else {
				const previousRow = findPreviousVisibleRowIndex(grid, rowIndex);
				if (previousRow === void 0) return;
				rowIndex = previousRow;
				colIndex = lastColumnIndex;
				changePosition = true;
			}
			else if (colIndex < systemColumnCount.value && !singleColumnRow) colIndex = systemColumnCount.value;
			else if (colIndex < lastColumnIndex && !singleColumnRow) colIndex++;
			else {
				const nextRow = await findNextVisibleRowIndex(grid, rowIndex);
				if (nextRow === void 0) return;
				rowIndex = nextRow;
				colIndex = systemColumnCount.value;
				changePosition = true;
			}
			function select() {
				const column = columns[colIndex];
				const row = grid.rows[rowIndex];
				if (!column || !row) return;
				if (isCellTabbable(column, row.dataItem)) {
					handleKeyNavigation(event);
					selectCell(grid, rowIndex, colIndex);
				} else handleTabNavigation(grid, event, rowIndex, colIndex, columns, lastColumnIndex);
			}
			if (changePosition) {
				handleKeyNavigation(event);
				if (await positionChanging(grid, rowIndex)) {
					select();
					selectRow(grid, rowIndex);
				}
			} else select();
		}
		async function findNextVisibleRowIndex(grid, index) {
			for (let i = index + 1; i < grid.rows.length; i++) if (grid.rows[i].isVisible) return i;
			if (props.addRow && await addRowCommitting(grid)) return index + 1;
		}
		function findPreviousVisibleRowIndex(grid, index) {
			for (let i = index - 1; i > -1; i--) if (grid.rows[i].isVisible) return i;
		}
		/**
		* Gets the index of the next column on enter navigation.
		* If the grid is editable, has the add row and the current row is the last row,
		* The next column will the first editable column of the next row. If there is no editable column, it will be the first column.
		* Otherwise, it the current column.
		*/
		function getNextColumnIndexOnEnterNavigation(grid) {
			if (props.editable && props.addRow && grid.selection.row === grid.rows.length - 2) {
				const item = grid.rows[grid.selection.row + 1].dataItem;
				return getFirstEditableColIndex(grid, item);
			}
			return grid.selection.col;
		}
		function getFirstEditableColIndex(grid, item) {
			for (let index = systemColumnCount.value; index < grid.columns.length; index++) {
				const column = grid.columns[index];
				if (column.isVisible && !isReadOnlyColumn(column, item, true)) return index;
			}
			return systemColumnCount.value;
		}
		/**
		* Gets a value indicating whether the cell can be focused using the Tab key.
		*/
		function isCellTabbable(col, item) {
			const column = getDatagridColumn(col);
			if (props.editable && column.readOnly && column.readOnly(item)) return false;
			return !column.tabStop || column.tabStop(item);
		}
		async function selectCell(grid, rowIndex, colIndex, quickEditing = true) {
			grid.stayInEditModeWhileInvalidating = false;
			grid.select(rowIndex, colIndex);
			startEditing(grid, rowIndex, colIndex, quickEditing);
		}
		async function startEditing(grid, rowIndex, colIndex, quickEditing = true) {
			if (props.addRow) await addRowCommitting(grid);
			if (quickEditing) {
				const row = grid.rows[rowIndex];
				const col = grid.columns[colIndex];
				if (row && !isReadOnlyColumn(col, row.dataItem, false)) setTimeout(() => grid.startEditing(false), 50);
			}
		}
		function selectRow(grid, rowIndex, mode = "single") {
			if (!props.selectionBinding) return;
			if (!props.selectionColumn && mode !== "single") mode = "single";
			let row = grid.rows[rowIndex];
			if (isDetailRow(row)) row = grid.rows[rowIndex - 1];
			const selectedItem = row.dataItem;
			const selected = !selectedItem[props.selectionBinding];
			if (mode === "single-select-only" && selected) mode = "single";
			if (mode === "range") {
				for (const row of grid.rows) if (row.index >= lastSelectedRowIndex && row.index < rowIndex || row.index > rowIndex && row.index <= lastSelectedRowIndex) emitRowSelect(row.dataItem, selected);
			}
			lastSelectedRowIndex = rowIndex;
			emitRowSelect(selectedItem, selected || mode !== "multi");
			if (mode === "single") {
				for (const row of grid.rows) if (row.index !== rowIndex && row.dataItem) emitRowSelect(row.dataItem, false);
			}
		}
		/**
		* Emits an row-select event to update the selection state of the item.
		*/
		async function emitRowSelect(item, selected) {
			if (props.selectionBinding && selected !== item[props.selectionBinding]) emit("rowSelect", item, selected);
		}
		/**
		* Handles the beginning edit event.
		*/
		function handleBeginningEdit(grid, args) {
			const col = args.getColumn();
			const item = args.getRow().dataItem;
			args.cancel = isReadOnlyColumn(col, item, false);
		}
		function isReadOnlyColumn(col, item, ignoreSlot) {
			if (props.editable && item) {
				const column = getDatagridColumn(col);
				if (column && !isIndeterminateCheckboxCell(column, getCellValue(column.name, item)) && (ignoreSlot || slots[`${col.name}-edit`])) return column.readOnly !== void 0 && column.readOnly(item);
			}
			return true;
		}
		/**
		* Handles the cell edit ending event.
		*/
		async function handleCellEditEnding(grid, args) {
			args._rng.col2 = args._rng.col;
			if (grid.currentEditDelegatesToComponent) args.cancel = true;
			if (grid.stayInEditModeWhileInvalidating) {
				args.stayInEditMode = true;
				grid.stayInEditModeWhileInvalidating = false;
				return;
			}
			if (!args.cancel) {
				if (grid.hostElement.contains(document.activeElement)) triggerChangeOnActiveInput();
				if (stayInEditMode) args.stayInEditMode = true;
			}
			grid.currentEditingCell = void 0;
			grid.currentEditDelegatesToComponent = false;
		}
		function handleFormatItem(grid, args) {
			if (args.panel === grid.cells) {
				const item = args.getRow().dataItem;
				if (item instanceof CollectionViewGroup$1) formatGroupRow(args, item);
				else if (item) formatItemRow(grid, args, item);
				else formatAddRow(grid, args);
			}
		}
		/**
		* Formats an item row.
		*/
		function formatItemRow(grid, args, item) {
			if (args.col === grid.columns.firstVisibleIndex && props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", item[props.selectionBinding] === true);
			const col = args.getColumn();
			const column = getDatagridColumn(args.getColumn());
			if (column) {
				args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
				const isReadOnly = isReadOnlyColumn(col, item, true);
				args.cell.classList.toggle("read-only", isReadOnly);
				args.cell.querySelector("input[type=\"checkbox\"]")?.toggleAttribute("disabled", isReadOnly);
				if (isEditingCell(grid, args.row, args.col)) args.cell.classList.toggle("wj-state-active", true);
				else emitFormatCell(column, item, args.cell, isReadOnly);
				emitValidateCell(args.cell, item, column);
			} else if (col.name === "$$row-drag") args.cell.setAttribute("draggable", "true");
			else if (col.name === "$$row-indicator") emitValidateCell(args.cell, item);
		}
		/**
		* Formats a group row.
		*/
		function formatGroupRow(args, item) {
			if (item.groupDescription instanceof PropertyGroupDescription$1 && args.cell.hasAttribute("aria-expanded")) {
				const column = columnsMap.value.get(item.groupDescription.propertyName);
				if (column) {
					if (props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
					emitFormatCell(column, item, args.cell, true);
				}
			}
		}
		/**
		* Formats an add row.
		*/
		function formatAddRow(grid, args) {
			if (args.col === grid.columns.firstVisibleIndex && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
			const column = getDatagridColumn(args.getColumn());
			if (column) args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
			setCellValidationMessage(args.cell, void 0);
		}
		/**
		* Emits a formatCell event.
		*/
		function emitFormatCell(column, item, cell, readOnly) {
			emit("formatCell", column, item, cell, readOnly, props.autoRowHeight);
		}
		/**
		* Emits a validateCell event.
		*/
		function emitValidateCell(cell, item, column) {
			emit("validateCell", item, column, (message) => setCellValidationMessage(cell, message));
		}
		/**
		* Toggles whether the mounted edit component persists its value itself.
		*/
		function toggleDelegateEditToComponent(value) {
			if (!_grid.value) return;
			_grid.value.currentEditDelegatesToComponent = value;
		}
		/**
		* Toggles the "stay in edit mode".
		*/
		function toggleStayInEditMode(value) {
			if (!_grid.value) return;
			stayInEditMode = value;
			if (!_grid.value.editRange && !value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the datagrid read only state.
		*/
		function toggleReadOnly(value) {
			if (!_grid.value) return;
			_grid.value.isReadOnly = value;
			if (!value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the context menu.
		*/
		function toggleContextMenu(event) {
			contextMenu.value.toggle(event);
		}
		/**
		* Override the wijmo cell persistence behaviour.
		* Loosing focus on the editable cell component replace the editable cell with the display cell.
		* Some component (eg: Lookup) can persist their value asynchronously, so the model update take place
		* when the component is already unmounted.
		* To ensure that the data is updated, this override will force the update to the wijmo cell instance.
		*/
		function getCellInstanceOverride(cell) {
			const currentValue = shallowRef(cell.value);
			const currentEditingCell = {
				...cell,
				get value() {
					return currentValue.value;
				},
				set value(newValue) {
					currentValue.value = newValue;
					cell.value = newValue;
				}
			};
			if (_grid.value) {
				_grid.value.currentEditingCell = currentEditingCell;
				_grid.value.currentEditDelegatesToComponent = false;
			}
			return currentEditingCell;
		}
		/**
		* Gets the current sort image name.
		*/
		function getCurrentSortImageName(column) {
			if (column.currentSort === null) return "swap";
			return column.currentSort === "+" ? "arrowUp" : "arrowDown";
		}
		useComponentAutomationProperties();
		onBeforeUnmount(() => {
			if (!_grid.value) return;
			_grid.value.finishEditing();
			_grid.value.collectionView?.collectionChanged.removeHandler(updateHeaderSelectorValue);
			_grid.value = void 0;
		});
		function loadRowsIfInfiniteScrollingAndNoScroll(grid) {
			if (props.infiniteScrolling && grid._root.scrollHeight <= grid._root.clientHeight) {
				const pageRowsCount = getPageRowsCount(grid);
				if (grid.rows.length < pageRowsCount) emit("loadRows", pageRowsCount);
			}
		}
		/**
		* Handles the mouse wheel event.
		*/
		async function handleWheel() {
			await commitAddRow();
		}
		/**
		* Handles the scroll position changed event.
		*/
		function handleScrollPositionChanged(grid) {
			if (props.infiniteScrolling && grid.viewRange.bottomRow >= grid.rows.length - 10) {
				let group;
				for (const row of grid.rows) {
					if (isGroupRow(row) && !row.isCollapsed) group = row.dataItem;
					if (row.index === grid.viewRange.bottomRow) break;
				}
				emit("loadRows", getPageRowsCount(grid), group);
			}
		}
		/**
		* Handles the group collapsed change event.
		*/
		function handleGroupCollapsedChanged(grid, args) {
			if (!grid.restoringGroupRowsState) {
				const row = args.getRow();
				emit("toggleGroup", row.dataItem, row.isCollapsed, getPageRowsCount(grid));
			}
		}
		/**
		* Handles the dragging column event.
		*/
		function handleDraggingColumn(grid, args) {
			draggingColumn.value = getDatagridColumn(args.getColumn());
		}
		/**
		* Handles the dragged column event.
		*/
		function handleDraggedColumn(grid) {
			emitColumnsChanged(grid);
		}
		/**
		* Handles the resizing column event.
		*/
		function handleResizingColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).setAttribute("data-resizing", "true");
			grid.columnHeaders.hostElement.setAttribute("data-resizing-column", "true");
		}
		/**
		* Handles the resized column event.
		*/
		function handleResizedColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).removeAttribute("data-resizing");
			grid.columnHeaders.hostElement.removeAttribute("data-resizing-column");
			emitColumnsChanged(grid);
		}
		/**
		* Emits a columns changed event.
		*/
		function emitColumnsChanged(grid) {
			const columns = [];
			for (const col of grid.columns) {
				const column = getDatagridColumn(col);
				if (column && column.tag) columns.push({
					tag: column.tag,
					visible: col.visible,
					position: col.visible ? col.visibleIndex : 0,
					width: col.width?.toString()
				});
			}
			emit("columnsChanged", columns);
		}
		/**
		* Handles the got focus event.
		*/
		async function handleGotFocus(grid) {
			if (grid.selection.row === -1 && grid.rows.length > 0 && !(document.activeElement instanceof HTMLButtonElement)) {
				if (isAddRow(grid.rows[0])) await addRowAdding(grid);
				selectCell(grid, 0, systemColumnCount.value);
			}
		}
		/**
		* Handles the lost focus event.
		*/
		function handleLostFocus(grid) {
			commitAddRow(grid);
		}
		/**
		* Handles the copying event.
		*/
		async function handleCopying(grid, args) {
			const item = args.getRow().dataItem;
			const isGroupRow = item.groupDescription instanceof PropertyGroupDescription$1;
			const columnName = isGroupRow ? item.groupDescription.propertyName : args.getColumn().name;
			const column = columnsMap.value.get(columnName);
			if (column) {
				let text;
				if (!isGroupRow && column.displayTemplate) text = getDisplayTemplateText(grid, args.row, args.col);
				else if (column.displayText) {
					const value = isGroupRow ? item.name : getPropertyByPath(item, columnName);
					text = await column.displayText(value, item);
				}
				if (text != null) {
					args.cancel = true;
					await navigator.clipboard.writeText(text);
				}
			}
		}
		/**
		* Handles the pasting cell event.
		*/
		function handlePastingCell(grid, args) {
			args.cancel = isReadOnlyColumn(args.getColumn(), args.getRow().dataItem, true);
		}
		/**
		* Builds the summary row.
		*/
		function buildSummaryRow(grid) {
			if (props.summaries) {
				if (grid.columnFooters.rows.length === 0) {
					const row = new Row(props.summaries);
					grid.columnFooters.rows.push(row);
				} else grid.columnFooters.rows[0].dataItem = props.summaries;
				grid.invalidate(false);
			} else grid.columnFooters.rows.clear();
		}
		/**
		* Gets the page rows count.
		*/
		function getPageRowsCount(grid) {
			return Math.ceil(grid.hostElement.clientHeight / grid.rows.defaultSize) + 10;
		}
		function getCellValue(path, item) {
			return item ? getPropertyByPath(item, path) : void 0;
		}
		function getDatagridColumn(column) {
			return columnsMap.value.get(column.name);
		}
		async function commitAddRow(grid = _grid.value) {
			if (grid && props.addRow && !stayInEditMode) await addRowCommitting(grid);
		}
		return {
			columnsMap,
			contextMenu,
			convertBooleanToVisibility,
			convertColumnWidth,
			DataType: DataType$1,
			displayColumnSortIndex,
			draggingColumn,
			emitColumnsChanged,
			getCellInstanceOverride,
			getCellValue,
			getCheckboxCellValue,
			getCurrentSortImageName,
			getRowDetailColumnIcon,
			grid: _grid,
			handleBeginningEdit,
			handleCellEditEnding,
			handleClick,
			handleCopying,
			handleDoubleClick,
			handleDragend,
			handleDraggedColumn,
			handleDraggingColumn,
			handleDragover,
			handleDragstart,
			handleDrop,
			handleFormatItem,
			handleGotFocus,
			handleGroupCollapsedChanged,
			handleInitialization,
			handleItemsSourceChanged,
			handleKeydown,
			handleLoadedRows,
			handleLostFocus,
			handleMousedown,
			handlePastingCell,
			handleRefreshed,
			handleRefreshing,
			handleResizedColumn,
			handleResizingColumn,
			handleScrollPositionChanged,
			handleWheel,
			hasColumnHeaderContextMenu,
			headerSelectorValue,
			isEmpty,
			isGroupPanelVisible,
			isIndeterminateCheckboxCell,
			isNoDataOverlayVisible,
			isVisible,
			loadingOverlayMessage,
			refresh,
			resetColumns,
			rowActionsElement,
			rowActionsItem,
			rowDetailComponent,
			rowDragDrop,
			sortColumn,
			systemColumnCount,
			toggleContextMenu,
			toggleDelegateEditToComponent,
			toggleReadOnly,
			toggleStayInEditMode
		};
	}
});
//#endregion
//#region src/components/Datagrid/Datagrid.vue
var _hoisted_1$19 = {
	key: 0,
	class: "row-action"
};
var _hoisted_2$10 = {
	key: 1,
	class: "row-indicator"
};
var _hoisted_3$3 = ["checked"];
var _hoisted_4$2 = ["checked"];
var _hoisted_5$2 = { class: "column-caption" };
var _hoisted_6 = ["data-sort"];
var _hoisted_7 = { key: 0 };
var _hoisted_8 = {
	key: 0,
	class: "switch-content"
};
var _hoisted_9 = ["checked"];
var _hoisted_10 = ["checked", ".indeterminate"];
var _hoisted_11 = {
	key: 1,
	ref: "rowActionsElement",
	class: "datagrid-row-actions"
};
function _sfc_render$20(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DatagridGroupPanel = resolveComponent("DatagridGroupPanel");
	const _component_DatagridContextMenu = resolveComponent("DatagridContextMenu");
	const _component_DatagridNoDataOverlay = resolveComponent("DatagridNoDataOverlay");
	const _component_LoadingOverlay = resolveComponent("LoadingOverlay");
	const _component_Image = resolveComponent("Image");
	const _component_WjFlexGridCellTemplate = resolveComponent("WjFlexGridCellTemplate");
	const _component_WjFlexGridColumn = resolveComponent("WjFlexGridColumn");
	const _component_MarkdownViewer = resolveComponent("MarkdownViewer");
	const _component_InputDocumentationButton = resolveComponent("InputDocumentationButton");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_DatagridSummaryCell = resolveComponent("DatagridSummaryCell");
	const _component_WjFlexGridDetail = resolveComponent("WjFlexGridDetail");
	const _component_WjFlexGrid = resolveComponent("WjFlexGrid");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		class: "datagrid neos-fill-parent-height",
		style: normalizeStyle({ visibility: _ctx.convertBooleanToVisibility(_ctx.isVisible) })
	}, {
		default: withCtx(() => [_ctx.grid ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.groupable ? withDirectives((openBlock(), createBlock(_component_DatagridGroupPanel, {
			key: 0,
			grid: _ctx.grid,
			"dragging-column": _ctx.draggingColumn,
			onSort: _ctx.sortColumn
		}, null, 8, [
			"grid",
			"dragging-column",
			"onSort"
		])), [[vShow, _ctx.isGroupPanelVisible]]) : createCommentVNode("", true), createVNode(_component_DatagridContextMenu, {
			ref: "contextMenu",
			"group-panel-visible": _ctx.isGroupPanelVisible,
			"onUpdate:groupPanelVisible": _cache[0] || (_cache[0] = ($event) => _ctx.isGroupPanelVisible = $event),
			grid: _ctx.grid,
			columns: _ctx.columnsMap,
			"get-row-context-menu-items": _ctx.getRowContextMenuItems,
			"system-column-count": _ctx.systemColumnCount,
			groupable: _ctx.groupable,
			exportable: _ctx.exportable,
			"column-picker": _ctx.columnPicker,
			onColumnsChanged: _ctx.emitColumnsChanged
		}, null, 8, [
			"group-panel-visible",
			"grid",
			"columns",
			"get-row-context-menu-items",
			"system-column-count",
			"groupable",
			"exportable",
			"column-picker",
			"onColumnsChanged"
		])], 64)) : createCommentVNode("", true), createVNode(_component_VerticalLayout, {
			class: "neos-fill-parent-height",
			space: "none"
		}, {
			default: withCtx(() => [
				_ctx.isNoDataOverlayVisible && _ctx.isEmpty && !_ctx.loading ? (openBlock(), createBlock(_component_DatagridNoDataOverlay, { key: 0 }, {
					action: withCtx(() => [renderSlot(_ctx.$slots, "no-data-action")]),
					default: withCtx(() => [renderSlot(_ctx.$slots, "no-data")]),
					_: 3
				})) : createCommentVNode("", true),
				createVNode(_component_LoadingOverlay, { message: _ctx.loadingOverlayMessage }, null, 8, ["message"]),
				createVNode(_component_WjFlexGrid, {
					"items-source": _ctx.source,
					"selection-mode": "Cell",
					"headers-visibility": "Column",
					"key-action-tab": "None",
					"sticky-headers": true,
					"validate-edits": false,
					"defer-resizing": true,
					"clone-frozen-cells": false,
					"virtualization-threshold": [0, 100],
					"preserve-outline-state": false,
					"group-header-format": "{value}",
					"allow-sorting": "None",
					"loaded-rows": _ctx.handleLoadedRows,
					refreshing: _ctx.handleRefreshing,
					refreshed: _ctx.handleRefreshed,
					"items-source-changed": _ctx.handleItemsSourceChanged,
					"beginning-edit": _ctx.handleBeginningEdit,
					"cell-edit-ending": _ctx.handleCellEditEnding,
					"format-item": _ctx.handleFormatItem,
					"scroll-position-changed": _ctx.handleScrollPositionChanged,
					"group-collapsed-changing": _ctx.handleGroupCollapsedChanged,
					"dragging-column": _ctx.handleDraggingColumn,
					"dragged-column": _ctx.handleDraggedColumn,
					"resizing-column": _ctx.handleResizingColumn,
					"resized-column": _ctx.handleResizedColumn,
					"got-focus": _ctx.handleGotFocus,
					"lost-focus": _ctx.handleLostFocus,
					copying: _ctx.handleCopying,
					"pasting-cell": _ctx.handlePastingCell,
					"data-editable": _ctx.editable,
					"data-add-row": _ctx.addRow,
					"data-row-drag-drop": _ctx.rowDragDrop,
					onMousedown: _ctx.handleMousedown,
					onClick: _ctx.handleClick,
					onDblclick: _ctx.handleDoubleClick,
					onKeydown: _ctx.handleKeydown,
					onContextmenu: _ctx.toggleContextMenu,
					onDragstart: _ctx.handleDragstart,
					onDragover: _ctx.handleDragover,
					onDragend: _ctx.handleDragend,
					onDrop: _ctx.handleDrop,
					onWheel: _ctx.handleWheel
				}, {
					default: withCtx(() => [
						_ctx.rowDragDrop ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 0,
							name: "$$row-drag",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-drag-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx(() => [createVNode(_component_Image, { name: "dragVertical" })]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 1,
							name: "$$row-detail",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-detail-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createVNode(_component_Image, {
									name: _ctx.getRowDetailColumnIcon(cell.row),
									size: "small"
								}, null, 8, ["name"])]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-indicator"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 2,
							name: "$$row-indicator",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-indicator-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop && !_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [_ctx.$slots["row-action"] ? (openBlock(), createElementBlock("div", _hoisted_1$19, [renderSlot(_ctx.$slots, "row-action", { item: cell.row.dataItem })])) : createCommentVNode("", true), _ctx.$slots["row-indicator"] ? (openBlock(), createElementBlock("div", _hoisted_2$10, [renderSlot(_ctx.$slots, "row-indicator", { item: cell.item })])) : createCommentVNode("", true)]),
								_: 3
							})]),
							_: 3
						})) : createCommentVNode("", true),
						_ctx.selectionColumn && _ctx.selectionBinding ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 3,
							width: 28,
							name: _ctx.selectionBinding,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col selection-col"
						}, {
							default: withCtx(() => [_ctx.selectionColumnHeader ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
								key: 0,
								"cell-type": "ColumnHeader"
							}, {
								default: withCtx(() => [createElementVNode("input", {
									type: "checkbox",
									class: "header-selector",
									checked: _ctx.headerSelectorValue,
									tabindex: "-1",
									onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_3$3), _cache[5] || (_cache[5] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})) : createCommentVNode("", true), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createElementVNode("input", {
									type: "checkbox",
									class: "row-selector",
									checked: cell.item?.[_ctx.selectionBinding],
									tabindex: "-1",
									onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_4$2), _cache[6] || (_cache[6] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})]),
							_: 1
						}, 8, ["name"])) : createCommentVNode("", true),
						(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (column, i) => {
							return openBlock(), createBlock(_component_WjFlexGridColumn, {
								key: column.name + i,
								name: column.name,
								binding: column.name,
								header: column.caption,
								visible: column.visible,
								"allow-sorting": column.sortable,
								"allow-dragging": column.movable,
								"data-type": column.dataType,
								"is-read-only": !_ctx.editable,
								"is-required": false,
								width: _ctx.convertColumnWidth(column.width),
								"min-width": column.minWidth,
								"max-width": column.maxWidth
							}, {
								default: withCtx(() => [
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
										default: withCtx((cell) => [createVNode(_component_HorizontalLayout, {
											space: "extrasmall",
											"vertical-align": "center",
											wrap: false,
											align: column.align,
											"data-column": column.name,
											"data-sortable": column.sortable,
											title: column.caption
										}, {
											default: withCtx(() => [
												createElementVNode("span", _hoisted_5$2, toDisplayString(column.caption), 1),
												column.documentation ? (openBlock(), createBlock(_component_InputDocumentationButton, { key: 0 }, {
													header: withCtx(() => [createTextVNode(toDisplayString(column.caption), 1)]),
													body: withCtx(() => [createVNode(_component_MarkdownViewer, {
														source: column.documentation,
														sanitize: true
													}, null, 8, ["source"])]),
													_: 2
												}, 1024)) : createCommentVNode("", true),
												column.sortable ? (openBlock(), createElementBlock("div", {
													key: 1,
													class: "sort-info",
													"data-sort": cell.col.currentSort
												}, [createVNode(_component_Image, {
													name: _ctx.getCurrentSortImageName(cell.col),
													size: "small"
												}, null, 8, ["name"]), _ctx.displayColumnSortIndex && cell.col.currentSortIndex > -1 ? (openBlock(), createElementBlock("span", _hoisted_7, toDisplayString(cell.col.currentSortIndex + 1), 1)) : createCommentVNode("", true)], 8, _hoisted_6)) : createCommentVNode("", true)
											]),
											_: 2
										}, 1032, [
											"align",
											"data-column",
											"data-sortable",
											"title"
										])]),
										_: 2
									}, 1024),
									_ctx.$slots[`${column.name}-edit`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 0,
										"cell-type": "CellEdit"
									}, {
										default: withCtx((cell) => [renderSlot(_ctx.$slots, `${column.name}-edit`, {
											column,
											cell: _ctx.getCellInstanceOverride(cell),
											toggleDelegateEditToComponent: _ctx.toggleDelegateEditToComponent,
											toggleStayInEditMode: _ctx.toggleStayInEditMode,
											toggleReadOnly: _ctx.toggleReadOnly
										})]),
										_: 2
									}, 1024)) : column.dataType == _ctx.DataType.Boolean ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 1,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [_ctx.booleanDisplayMode === "switch" ? (openBlock(), createElementBlock("div", _hoisted_8, [createElementVNode("label", null, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											tabindex: "-1",
											onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["prevent"]))
										}, null, 8, _hoisted_9), _cache[7] || (_cache[7] = createElementVNode("span", { class: "checkbox-cell" }, null, -1))])])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											".indeterminate": _ctx.isIndeterminateCheckboxCell(column, _ctx.getCellValue(column.name, cell.item)),
											class: "checkbox-cell",
											tabindex: "-1",
											onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent"]))
										}, null, 40, _hoisted_10), _cache[8] || (_cache[8] = createElementVNode("span", { class: "checkbox-cell-overlay" }, null, -1))], 64))]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									_ctx.$slots[`${column.name}-display`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 2,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [cell.item ? renderSlot(_ctx.$slots, `${column.name}-display`, {
											key: 0,
											column,
											cell: {
												...cell,
												value: _ctx.getCellValue(column.name, cell.item)
											}
										}) : createCommentVNode("", true)]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Group" }, {
										default: withCtx((cell) => [column.groupSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.groupSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnFooter" }, {
										default: withCtx((cell) => [column.totalSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.totalSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024)
								]),
								_: 2
							}, 1032, [
								"name",
								"binding",
								"header",
								"visible",
								"allow-sorting",
								"allow-dragging",
								"data-type",
								"is-read-only",
								"width",
								"min-width",
								"max-width"
							]);
						}), 128)),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridDetail, {
							key: 4,
							ref: "rowDetailComponent"
						}, {
							default: withCtx((cell) => [renderSlot(_ctx.$slots, "row-detail", { item: cell.item })]),
							_: 3
						}, 512)) : createCommentVNode("", true)
					]),
					_: 3
				}, 8, [
					"items-source",
					"loaded-rows",
					"refreshing",
					"refreshed",
					"items-source-changed",
					"beginning-edit",
					"cell-edit-ending",
					"format-item",
					"scroll-position-changed",
					"group-collapsed-changing",
					"dragging-column",
					"dragged-column",
					"resizing-column",
					"resized-column",
					"got-focus",
					"lost-focus",
					"copying",
					"pasting-cell",
					"data-editable",
					"data-add-row",
					"data-row-drag-drop",
					"onMousedown",
					"onClick",
					"onDblclick",
					"onKeydown",
					"onContextmenu",
					"onDragstart",
					"onDragover",
					"onDragend",
					"onDrop",
					"onWheel"
				]),
				_ctx.$slots["row-actions"] ? (openBlock(), createElementBlock("div", _hoisted_11, [renderSlot(_ctx.$slots, "row-actions", { item: _ctx.rowActionsItem })], 512)) : createCommentVNode("", true),
				_ctx.$slots.footer ? (openBlock(), createBlock(_component_VerticalLayout, {
					key: 2,
					class: "datagrid-footer"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
					_: 3
				})) : createCommentVNode("", true)
			]),
			_: 3
		})]),
		_: 3
	}, 8, ["style"]);
}
var Datagrid_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Datagrid_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$20]]);
//#endregion
//#region src/components/Divider/Divider.vue
var Divider_default = /* @__PURE__ */ defineComponent({
	__name: "Divider",
	props: {
		contentAlign: { default: "center" },
		layout: { default: "horizontal" },
		type: { default: "solid" },
		color: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const align = computed(() => convertInvariantTextAlignToOccidentalTextAlign(props.contentAlign));
		const colorValue = computed(() => props.color ? getColorValue(props.color) : void 0);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeDivider), {
				align: align.value,
				layout: __props.layout,
				type: __props.type,
				class: "divider",
				style: normalizeStyle({ "--p-divider-border-color": colorValue.value })
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"align",
				"layout",
				"type",
				"style"
			]);
		};
	}
});
//#endregion
//#region src/components/DocumentationButton/DocumentationButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$18 = ["innerHTML"];
//#endregion
//#region src/components/DocumentationButton/DocumentationButton.vue
var DocumentationButton_default = /* @__PURE__ */ defineComponent({
	__name: "DocumentationButton",
	props: {
		text: {},
		title: {}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(InputDocumentationButton_default, null, {
				header: withCtx(() => [createTextVNode(toDisplayString(__props.title), 1)]),
				body: withCtx(() => [createElementVNode("div", { innerHTML: __props.text }, null, 8, _hoisted_1$18)]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/Dropdown/Dropdown.ts?vue&type=script&src=true&lang.ts
var Dropdown_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Dropdown",
	props: {
		active: {
			type: Boolean,
			default: void 0
		},
		element: {
			type: Object,
			default: void 0
		},
		limitWidthToAnchor: {
			type: String,
			default: "none"
		},
		offset: {
			type: Number,
			default: 0
		},
		customClass: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:active"],
	setup(props, { emit }) {
		const internalActive = ref(false);
		const isActive = computed({
			get: () => props.active ?? internalActive.value,
			set: (value) => {
				internalActive.value = value;
				if (props.active !== void 0) emit("update:active", value);
			}
		});
		const toggler = ref();
		const anchor = computed(() => props.element ?? toggler.value);
		const content = ref();
		const style = shallowRef();
		onMounted(() => {
			window.addEventListener("resize", updateDropdownStyle);
			document.addEventListener("scroll", onScroll, {
				capture: true,
				passive: true
			});
		});
		onUnmounted(() => {
			window.removeEventListener("resize", updateDropdownStyle);
			document.removeEventListener("scroll", onScroll, { capture: true });
		});
		onClickOutside(content, () => isActive.value = false, { ignore: [anchor] });
		function updateDropdownStyle() {
			if (!isActive.value || !anchor.value || !content.value) return;
			const styleValue = {};
			const rectAnchor = anchor.value.getBoundingClientRect();
			const rectContent = content.value.getBoundingClientRect();
			if (rectContent.height + props.offset <= document.documentElement.clientHeight - rectAnchor.y - rectAnchor.height) styleValue.top = `${rectAnchor.y + rectAnchor.height + props.offset}px`;
			else styleValue.top = `${rectAnchor.y - props.offset - rectContent.height}px`;
			let contentWidth;
			switch (props.limitWidthToAnchor) {
				case "absolute":
					styleValue.width = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				case "min":
					styleValue.minWidth = `${rectAnchor.width}px`;
					contentWidth = rectContent.width;
					break;
				case "max":
					styleValue.maxWidth = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				default:
					styleValue.width = "unset";
					contentWidth = rectContent.width;
					break;
			}
			const availableWidthRightToAnchorPosition = document.documentElement.clientWidth - rectAnchor.x;
			if (contentWidth <= availableWidthRightToAnchorPosition) styleValue.left = `${rectAnchor.x}px`;
			else {
				let left = rectAnchor.x + rectAnchor.width - contentWidth;
				if (left + contentWidth > document.documentElement.clientWidth) left = document.documentElement.clientWidth - contentWidth;
				styleValue.left = `${left}px`;
			}
			styleValue.zIndex = findHighestZIndex();
			style.value = styleValue;
		}
		function onScroll(e) {
			if (!isActive.value || !(e.target instanceof HTMLElement)) return;
			if (anchor.value?.contains(e.target) || content.value?.contains(e.target)) return;
			isActive.value = false;
		}
		function findHighestZIndex() {
			const divs = Array.from(document.getElementsByTagName("div"));
			let highest = 0;
			for (const div of divs) {
				const zindex = Number.parseInt(div.style.zIndex, 10);
				if (zindex > highest) highest = zindex;
			}
			return `${highest + 1}`;
		}
		return {
			isActive,
			toggler,
			anchor,
			content,
			style,
			updateDropdownStyle
		};
	}
});
//#endregion
//#region src/components/Dropdown/Dropdown.vue
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock(Fragment, null, [_ctx.$slots.toggler ? (openBlock(), createElementBlock("div", {
		key: 0,
		ref: "toggler",
		class: "dropdown-trigger",
		onClick: _cache[0] || (_cache[0] = ($event) => _ctx.isActive = !_ctx.isActive)
	}, [renderSlot(_ctx.$slots, "toggler", {}, void 0, true)], 512)) : createCommentVNode("", true), (openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(Transition, { name: "dropdown-content" }, {
		default: withCtx(() => [_ctx.isActive ? (openBlock(), createElementBlock("div", {
			key: 0,
			ref: "content",
			class: normalizeClass(["dropdown-content", _ctx.customClass]),
			style: normalizeStyle(_ctx.style),
			onVnodeMounted: _cache[1] || (_cache[1] = (...args) => _ctx.updateDropdownStyle && _ctx.updateDropdownStyle(...args))
		}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 6)) : createCommentVNode("", true)]),
		_: 3
	})]))], 64);
}
var Dropdown_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Dropdown_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$19], ["__scopeId", "data-v-fe7ac470"]]);
//#endregion
//#region src/components/DropdownMenuItem/DropdownMenuItem.vue
var DropdownMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "DropdownMenuItem",
	props: {
		item: {},
		props: {},
		hasSubmenu: {},
		size: {}
	},
	setup(__props) {
		const props = __props;
		const slots = useSlots();
		const hasActions = computed(() => props.hasSubmenu || slots.default);
		const action = computed(() => props.props.action);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, mergeProps({
					"vertical-align": "center",
					wrap: false
				}, action.value), {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "dropdown-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "dropdown-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}, 16), __props.item.sublabel || hasActions.value ? (openBlock(), createBlock(HorizontalLayout_default, {
					key: 0,
					space: "none",
					"vertical-align": "center"
				}, {
					default: withCtx(() => [
						__props.item.sublabel ? (openBlock(), createBlock(Text_default, {
							key: 0,
							size: "extrasmall",
							class: "dropdown-menu-item-sublabel"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.sublabel), 1)]),
							_: 1
						})) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "default"),
						__props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: "chevronRight",
							size: __props.size
						}, null, 8, ["size"])) : createCommentVNode("", true)
					]),
					_: 3
				})) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
});
//#endregion
//#region src/components/DropdownMenu/DropdownMenu.vue
var DropdownMenu_default = /* @__PURE__ */ defineComponent({
	__name: "DropdownMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const menuElement = useTemplateRef("menu");
		const pt = computed(() => ({
			item: (options) => ({
				class: "dropdown-menu-item",
				...options.context.item.attributes
			}),
			transition: { onEnter: handleMenuEnter },
			menu: { transition: { onEnter: handleMenuEnter } }
		}));
		function toggle(event) {
			menuElement.value.toggle(event);
		}
		function hide() {
			menuElement.value.hide();
		}
		function handleBeforeShow() {
			menuElement.value.target = null;
		}
		function handleMenuEnter(el) {
			const { top, bottom } = el.getBoundingClientRect();
			if (top < 0) el.style.transform = `translateY(${Math.abs(top)}px)`;
			else if (bottom > window.innerHeight) el.style.transform = `translateY(${Math.abs(bottom - window.innerHeight)}px)`;
		}
		__expose({
			toggle,
			hide,
			handleMenuEnter
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeMenu), {
				ref: "menu",
				model: __props.items,
				popup: "",
				pt: pt.value,
				class: "dropdown-menu",
				onBeforeShow: handleBeforeShow
			}, {
				item: withCtx(({ item, props, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					props,
					hasSubmenu,
					size: __props.size
				}, () => [createVNode(DropdownMenuItem_default, {
					item,
					props,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"props",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 8, ["model", "pt"]);
		};
	}
});
//#endregion
//#region src/components/RadioGroup/RadioGroup.ts?vue&type=script&src=true&lang.ts
var RadioGroup_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "RadioGroup",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: [
				String,
				Number,
				Boolean,
				Date,
				Object
			],
			default: null
		},
		values: {
			type: Array,
			default: () => []
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		orientation: {
			type: String,
			default: "horizontal"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const localizator = useLocalizator();
		const { id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const containerComponent = computed(() => props.orientation === "horizontal" ? HorizontalLayout_default : VerticalLayout_default);
		function getValue(value) {
			if (value && props.valueProperty) return value[props.valueProperty];
			return value;
		}
		function getDisplayValue(value) {
			if (value && props.displayProperty) return localizator.translate(value[props.displayProperty]);
			return localizator.translate(value);
		}
		function getId(value) {
			return `${id}_${getDisplayValue(value) ?? "null"}`;
		}
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			containerComponent,
			getValue,
			getDisplayValue,
			getId
		};
	}
});
//#endregion
//#region src/components/RadioGroup/RadioGroup.vue
var _hoisted_1$17 = [
	"id",
	"name",
	"disabled",
	"checked",
	"tabindex",
	"onChange"
];
var _hoisted_2$9 = ["for"];
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["radio-group neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		class: "radio-group-label",
		label: _ctx.label,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["neos-input-content", { "neos-input-disabled": _ctx.disabled }]) }, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.containerComponent), null, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value) => {
			return openBlock(), createBlock(_component_HorizontalLayout, {
				key: value,
				class: "radio-group-element"
			}, {
				default: withCtx(() => [createElementVNode("input", {
					id: _ctx.getId(value),
					type: "radio",
					name: _ctx.id,
					disabled: _ctx.disabled || _ctx.readonly,
					checked: _ctx.modelValue === _ctx.getValue(value),
					tabindex: _ctx.tabIndex,
					onChange: ($event) => _ctx.$emit("update:modelValue", _ctx.getValue(value))
				}, null, 40, _hoisted_1$17), createElementVNode("label", { for: _ctx.getId(value) }, toDisplayString(_ctx.getDisplayValue(value)), 9, _hoisted_2$9)]),
				_: 2
			}, 1024);
		}), 128))]),
		_: 1
	})), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 2)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var RadioGroup_default = /* @__PURE__ */ _plugin_vue_export_helper_default(RadioGroup_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$18], ["__scopeId", "data-v-6ec3b2e8"]]);
//#endregion
//#region src/components/Switch/Switch.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$16 = { class: "switch-content neos-input-content" };
var _hoisted_2$8 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
//#endregion
//#region src/components/Switch/Switch.vue
var Switch_default = /* @__PURE__ */ defineComponent({
	__name: "Switch",
	props: {
		...inputProps,
		modelValue: {
			type: Boolean,
			default: false
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		function handleChange(event) {
			emit("update:modelValue", event.target.checked);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["switch neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", _hoisted_1$16, [createElementVNode("label", null, [createElementVNode("input", {
				id: unref(id),
				ref: "input",
				type: "checkbox",
				checked: __props.modelValue,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex),
				onChange: handleChange
			}, null, 40, _hoisted_2$8), _cache[2] || (_cache[2] = createElementVNode("span", null, null, -1))]), renderSlot(_ctx.$slots, "default")])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/DynamicCheckbox/DynamicCheckbox.vue
var DynamicCheckbox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCheckbox",
	props: /* @__PURE__ */ mergeModels({
		...inputProps,
		trueLabel: {
			type: String,
			default: "Yes"
		},
		falseLabel: {
			type: String,
			default: "No"
		},
		nullLabel: {
			type: String,
			default: "Undefined"
		},
		displayMode: {
			type: String,
			default: "switch"
		}
	}, {
		"modelValue": {
			type: Boolean,
			default: null
		},
		"modelModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /* @__PURE__ */ mergeModels([...inputEmits], ["update:modelValue", "update:focused"]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const focused = useModel(__props, "focused");
		const { translate } = useGlobalResourceManager();
		const radioGroupValues = computed(() => {
			const values = [{
				value: true,
				label: translate(props.trueLabel)
			}, {
				value: false,
				label: translate(props.falseLabel)
			}];
			if (!props.required) values.push({
				value: null,
				label: translate(props.nullLabel)
			});
			return values;
		});
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return _ctx.required && __props.displayMode === "switch" ? (openBlock(), createBlock(Switch_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : _ctx.required && __props.displayMode === "checkbox" ? (openBlock(), createBlock(Checkbox_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[5] || (_cache[5] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[9] || (_cache[9] = ($event) => focused.value = $event),
				class: "checkbox",
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				values: radioGroupValues.value,
				"value-property": "value",
				"display-property": "label",
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[10] || (_cache[10] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"values",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
//#endregion
//#region src/components/SelectButton/SelectButton.vue
var SelectButton_default = /* @__PURE__ */ defineComponent({
	__name: "SelectButton",
	props: /* @__PURE__ */ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object
			],
			default: null
		},
		"modelModifiers": {}
	}),
	emits: /* @__PURE__ */ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const localizator = useLocalizator();
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const modelValue = useModel(__props, "modelValue");
		const optionLabel = computed(() => {
			if (!props.displayProperty) return;
			return (option) => {
				const displayPropertyValue = getPropertyByPath(option, props.displayProperty);
				if (displayPropertyValue == null) return "";
				if (typeof displayPropertyValue !== "object" || displayPropertyValue instanceof Date) return displayPropertyValue.toString();
				return localizator.translate(displayPropertyValue) ?? "";
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["select-button neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(PrimeSelectButton), {
				id: unref(id),
				ref: (el) => input.value = el,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => modelValue.value = $event),
				class: "neos-input-content",
				options: __props.values,
				"option-value": __props.valueProperty,
				"option-label": optionLabel.value,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex),
				"allow-empty": !_ctx.required
			}, null, 8, [
				"id",
				"modelValue",
				"options",
				"option-value",
				"option-label",
				"disabled",
				"tabindex",
				"allow-empty"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/DynamicCombobox/DynamicCombobox.vue
var DynamicCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCombobox",
	props: /* @__PURE__ */ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		displayMode: {
			type: String,
			default: "list"
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object
			],
			default: null
		},
		"modelModifiers": {},
		"invalidValue": {
			type: String,
			default: void 0
		},
		"invalidValueModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /* @__PURE__ */ mergeModels([...inputEmits], [
		"update:modelValue",
		"update:invalidValue",
		"update:focused"
	]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const invalidValue = useModel(__props, "invalidValue");
		const focused = useModel(__props, "focused");
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return __props.displayMode === "list" || _ctx.inputDisplayMode === "datagrid" ? (openBlock(), createBlock(Combobox_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				"invalid-value": invalidValue.value,
				"onUpdate:invalidValue": _cache[1] || (_cache[1] = ($event) => invalidValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
			}, createSlots({ _: 2 }, [_ctx.$slots.value ? {
				name: "value",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "value", { option })]),
				key: "0"
			} : void 0, _ctx.$slots.option ? {
				name: "option",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
				key: "1"
			} : void 0]), 1032, [
				"modelValue",
				"invalid-value",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : __props.displayMode === "select-button" ? (openBlock(), createBlock(SelectButton_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[6] || (_cache[6] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[10] || (_cache[10] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[12] || (_cache[12] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
//#endregion
//#region src/components/GridLayout/GridLayout.ts?vue&type=script&src=true&lang.ts
function convertStyleAbstraction(abstractValue) {
	const starRegex = /(?:^| )((\d*)\*)/g;
	let starMatch;
	do {
		starMatch = starRegex.exec(abstractValue);
		if (starMatch != null) {
			const valueToReplace = starMatch[1];
			let value = starMatch[2];
			if (value == null || value === "") value = "1";
			abstractValue = abstractValue.replace(valueToReplace, `minmax(0, ${value}fr)`);
		}
	} while (starMatch != null);
	abstractValue = abstractValue.replaceAll("fit", "max-content").replaceAll(/(\d)(\s|$)/g, "$1px$2");
	return abstractValue;
}
var GridLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GridLayout",
	props: {
		rows: {
			type: String,
			default: ""
		},
		rowsSmall: {
			type: String,
			default: ""
		},
		rowsMedium: {
			type: String,
			default: ""
		},
		rowsLarge: {
			type: String,
			default: ""
		},
		rowsExtralarge: {
			type: String,
			default: ""
		},
		columns: {
			type: String,
			default: ""
		},
		columnsSmall: {
			type: String,
			default: ""
		},
		columnsMedium: {
			type: String,
			default: ""
		},
		columnsLarge: {
			type: String,
			default: ""
		},
		columnsExtralarge: {
			type: String,
			default: ""
		},
		rowsAuto: {
			type: String,
			default: ""
		},
		rowsAutoSmall: {
			type: String,
			default: ""
		},
		rowsAutoMedium: {
			type: String,
			default: ""
		},
		rowsAutoLarge: {
			type: String,
			default: ""
		},
		rowsAutoExtralarge: {
			type: String,
			default: ""
		},
		gap: {
			type: String,
			default: ""
		},
		gapSmall: {
			type: String,
			default: ""
		},
		gapMedium: {
			type: String,
			default: ""
		},
		gapLarge: {
			type: String,
			default: ""
		},
		gapExtralarge: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		const style = {
			"--grid-layout-rows": convertStyleAbstraction(props.rows),
			"--grid-layout-columns": convertStyleAbstraction(props.columns),
			"--grid-layout-rows-auto": convertStyleAbstraction(props.rowsAuto),
			"--grid-layout-gap": SpaceValues[props.gap] || ""
		};
		style["--grid-layout-rows-small"] = convertStyleAbstraction(props.rowsSmall);
		style["--grid-layout-rows-medium"] = convertStyleAbstraction(props.rowsMedium);
		style["--grid-layout-rows-large"] = convertStyleAbstraction(props.rowsLarge);
		style["--grid-layout-rows-extralarge"] = convertStyleAbstraction(props.rowsExtralarge);
		style["--grid-layout-columns-small"] = convertStyleAbstraction(props.columnsSmall);
		style["--grid-layout-columns-medium"] = convertStyleAbstraction(props.columnsMedium);
		style["--grid-layout-columns-large"] = convertStyleAbstraction(props.columnsLarge);
		style["--grid-layout-columns-extralarge"] = convertStyleAbstraction(props.columnsExtralarge);
		style["--grid-layout-rows-auto-small"] = convertStyleAbstraction(props.rowsAutoSmall);
		style["--grid-layout-rows-auto-medium"] = convertStyleAbstraction(props.rowsAutoMedium);
		style["--grid-layout-rows-auto-large"] = convertStyleAbstraction(props.rowsAutoLarge);
		style["--grid-layout-rows-auto-extralarge"] = convertStyleAbstraction(props.rowsAutoExtralarge);
		style["--grid-layout-gap-small"] = SpaceValues[props.gapSmall] || "";
		style["--grid-layout-gap-medium"] = SpaceValues[props.gapMedium] || "";
		style["--grid-layout-gap-large"] = SpaceValues[props.gapLarge] || "";
		style["--grid-layout-gap-extralarge"] = SpaceValues[props.gapExtralarge] || "";
		useComponentAutomationProperties();
		return { style };
	}
});
//#endregion
//#region src/components/GridLayout/GridLayout.vue
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "neos-grid-layout neos-fill-parent-width",
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 4);
}
var GridLayout_default = /* @__PURE__ */ _plugin_vue_export_helper_default(GridLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$17], ["__scopeId", "data-v-c6a1e71e"]]);
//#endregion
//#region src/components/GroupBox/GroupBox.vue
var GroupBox_default = /* @__PURE__ */ defineComponent({
	__name: "GroupBox",
	props: /* @__PURE__ */ mergeModels({
		expandable: { type: Boolean },
		headerPadding: {},
		contentPadding: {}
	}, {
		"expanded": {
			type: Boolean,
			default: true
		},
		"expandedModifiers": {}
	}),
	emits: ["update:expanded"],
	setup(__props) {
		const props = __props;
		const expanded = useModel(__props, "expanded");
		useComponentAutomationProperties();
		const isCollapsed = computed({
			get: () => !expanded.value,
			set: (value) => expanded.value = !value
		});
		const passthroughProps = computed(() => {
			const contentStyles = ["--vertical-space: 0;"];
			if (props.contentPadding) contentStyles.push(` --p-panel-content-padding: ${SpaceValues[props.contentPadding]};`);
			return {
				header: {
					class: "neos-horizontal-content",
					style: props.headerPadding ? `--p-panel-header-padding: ${SpaceValues[props.headerPadding]};` : void 0
				},
				content: {
					class: "neos-vertical-content",
					style: contentStyles.join("")
				}
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimePanel), {
				collapsed: isCollapsed.value,
				"onUpdate:collapsed": _cache[0] || (_cache[0] = ($event) => isCollapsed.value = $event),
				class: "group-box",
				toggleable: __props.expandable,
				pt: passthroughProps.value
			}, createSlots({
				toggleicon: withCtx(({ collapsed }) => [createVNode(Image_default, {
					class: normalizeClass(["group-box-toggle-button-icon", { collapsed }]),
					name: "chevronUp"
				}, null, 8, ["class"])]),
				default: withCtx(() => [renderSlot(_ctx.$slots, "content")]),
				_: 2
			}, [_ctx.$slots.header ? {
				name: "header",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
				key: "0"
			} : void 0]), 1032, [
				"collapsed",
				"toggleable",
				"pt"
			]);
		};
	}
});
//#endregion
//#region src/components/Heading/Heading.vue
var Heading_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Heading",
	props: {
		level: { default: 1 },
		maxLines: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes, styles } = useTextMaxLines(props);
		const tag = computed(() => `h${props.level}`);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(resolveDynamicComponent(tag.value), {
				class: normalizeClass(["heading", unref(classes)]),
				style: normalizeStyle(unref(styles))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["class", "style"]);
		};
	}
}), [["__scopeId", "data-v-dce8b0d5"]]);
//#endregion
//#region src/components/HtmlViewer/HtmlViewer.ts?vue&type=script&src=true&lang.ts
var HtmlViewer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HtmlViewer",
	props: {
		html: {
			type: String,
			required: true
		},
		css: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		let styleElement;
		function _removeStyleElement() {
			if (styleElement) {
				styleElement.remove();
				styleElement = void 0;
			}
		}
		const purifiedHtml = computed(() => DOMPurify.sanitize(`<html><body>${props.html}</body></html>`));
		watch(() => props.css, (css) => {
			if (css) {
				styleElement = document.createElement("style");
				styleElement.innerHTML = css;
				document.head.append(styleElement);
			} else _removeStyleElement();
		}, { immediate: true });
		onUnmounted(() => _removeStyleElement());
		return { purifiedHtml };
	}
});
//#endregion
//#region src/components/HtmlViewer/HtmlViewer.vue
var _hoisted_1$15 = ["innerHTML"];
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "html-viewer",
		innerHTML: _ctx.purifiedHtml
	}, null, 8, _hoisted_1$15);
}
var HtmlViewer_default = /* @__PURE__ */ _plugin_vue_export_helper_default(HtmlViewer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$16]]);
//#endregion
//#region src/components/InputColor/InputColor.vue
var InputColor_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputColor",
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		function handleInitialization(_inputColor) {
			input.value = _inputColor.inputElement;
		}
		function handleValueChanged(_inputColor) {
			const value = _inputColor.value || null;
			if (value !== props.modelValue) emit("update:modelValue", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["input-color neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(WjInputColor), {
				id: unref(id),
				value: __props.modelValue,
				"is-required": false,
				"is-read-only": _ctx.readonly,
				"is-disabled": _ctx.disabled,
				placeholder: _ctx.placeholder,
				"tab-order": unref(tabIndex),
				"click-action": "Toggle",
				initialized: handleInitialization,
				"value-changed": handleValueChanged,
				class: "neos-input-content",
				"data-filled": !!__props.modelValue,
				autocomplete: "nope"
			}, null, 8, [
				"id",
				"value",
				"is-read-only",
				"is-disabled",
				"placeholder",
				"tab-order",
				"data-filled"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-f59680a3"]]);
//#endregion
//#region src/utils/datetime.ts
/**
* Parses and completes a date time value from the specified string value.
* @param value - The value to parse and complete.
* @param dateFormatStrings - The date time format strings.
* @returns A date time value, or null if the value can't be converted.
*/
function parseAndComplete(value, dateFormatStrings) {
	let date = null;
	if (value.includes("/") || !value.startsWith("-") && value.includes("-")) for (const formatString of dateFormatStrings) {
		const parsedDate = Globalize.parseDate(value, formatString);
		if (parsedDate && !Number.isNaN(parsedDate.getDate())) {
			date = parsedDate;
			break;
		}
	}
	else if (value === "0") date = /* @__PURE__ */ new Date();
	else if (value.startsWith("+") || value.startsWith("-")) date = parseRelativeDate(value);
	else date = parseSimplifiedDate(value, getSimplifiedDateFormat(new Intl.DateTimeFormat(navigator.language).resolvedOptions()));
	return date;
}
function parseRelativeDate(value) {
	const amount = Number.parseInt(value, 10);
	return Number.isNaN(amount) ? null : addDays(/* @__PURE__ */ new Date(), amount);
}
//#endregion
//#region src/composables/useInputDate.ts
function useInputDate(props, emit, formatStrings) {
	const root = ref();
	const focused = useVModel(props, "focused", emit);
	const { translate } = useGlobalResourceManager();
	const messageTextInternal = ref();
	const messageSeverityInternal = ref();
	const displayCalendar = computed(() => props.calendar && !props.disabled && !props.readonly);
	const propsInternal = reactiveComputed(() => ({
		...props,
		messageText: props.messageText ?? messageTextInternal.value,
		messageSeverity: props.messageSeverity ?? messageSeverityInternal.value
	}));
	watch(() => props.modelValue, () => checkMinMax());
	useComponentAutomationProperties(root);
	const calendarPopover = ref();
	const key = ref(0);
	const invalidValue = useInputInvalidValue(propsInternal, emit);
	const textboxValue = computed({
		get() {
			if (invalidValue.value) return invalidValue.value;
			return props.modelValue ? Globalize.format(props.modelValue, props.format) : null;
		},
		set(value) {
			if (!value) {
				emitNewValue(null);
				return;
			}
			const newValue = getDateFromText(value);
			if (newValue && !Number.isNaN(newValue.getDate())) {
				const oldValue = props.modelValue;
				emitNewValue(newValue);
				if (shouldUpdateKey(newValue, oldValue)) key.value++;
			} else invalidValue.value = value;
		}
	});
	const calendarValue = computed({
		get: () => props.modelValue,
		set: (date) => {
			if (date && props.modelValue) date = setTimeOfDay(date, props.modelValue);
			emitNewValue(date);
			calendarPopover.value.hide();
			focusInput();
		}
	});
	/**
	* Checks that the value is within the min/max range.
	* When it is not the case, displays an error message.
	*/
	function checkMinMax() {
		if (props.modelValue != null && props.minValue != null && props.modelValue < props.minValue) {
			messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", Globalize.format(props.minValue, props.format));
			messageSeverityInternal.value = "error";
		} else if (props.modelValue != null && props.maxValue != null && props.modelValue > props.maxValue) {
			messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", Globalize.format(props.maxValue, props.format));
			messageSeverityInternal.value = "error";
		} else {
			messageTextInternal.value = void 0;
			messageSeverityInternal.value = void 0;
		}
	}
	function getDateFromText(value) {
		let date = Globalize.parseDate(value, props.format);
		date ??= parseAndComplete(value, formatStrings);
		return date;
	}
	function emitNewValue(value) {
		emit("update:modelValue", value);
		invalidValue.value = null;
	}
	function handlePopoverShow() {
		emit("togglePopover", true);
	}
	function handlePopoverHide() {
		emit("togglePopover", false);
	}
	function focusInput() {
		focusExceptOnTouchDevice(root.value.$el.querySelector("input"));
	}
	function shouldUpdateKey(newValue, oldValue) {
		return props.inputDisplayMode === "form" && oldValue && newValue.getTime() === oldValue.getTime();
	}
	return {
		root,
		focused,
		key,
		displayCalendar,
		calendarPopover,
		calendarValue,
		textboxValue,
		propsInternal,
		handlePopoverShow,
		handlePopoverHide
	};
}
//#endregion
//#region src/components/InputDate/InputDate.ts?vue&type=script&src=true&lang.ts
var formatStrings$1 = ["d", "yyyy-MM-dd"];
var InputDate_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDate",
	components: {
		Button: Button_default,
		Textbox: Textbox_default,
		Popover: Popover_default,
		PrimeDatePicker: PrimeDatePicker$1
	},
	props: {
		...inputProps,
		modelValue: {
			type: Date,
			default: null
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		format: {
			type: String,
			default: "d"
		},
		minValue: {
			type: Date,
			default: void 0
		},
		maxValue: {
			type: Date,
			default: void 0
		},
		calendar: {
			type: Boolean,
			default: true
		}
	},
	emits: [
		...inputEmits,
		"update:invalidValue",
		"togglePopover"
	],
	setup(props, { emit }) {
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide } = useInputDate(props, emit, formatStrings$1);
		function handleOpenCalendarButton() {
			calendarPopover.value.toggle({ currentTarget: root.value.$el });
		}
		return {
			root,
			focused,
			key,
			displayCalendar,
			calendarPopover,
			calendarValue,
			textboxValue,
			propsInternal,
			handleOpenCalendarButton,
			handlePopoverShow,
			handlePopoverHide
		};
	}
});
//#endregion
//#region src/components/InputDate/InputDate.vue
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_PrimeDatePicker = resolveComponent("PrimeDatePicker");
	const _component_Popover = resolveComponent("Popover");
	const _component_Textbox = resolveComponent("Textbox");
	return openBlock(), createBlock(_component_Textbox, {
		key: _ctx.key,
		ref: "root",
		modelValue: _ctx.textboxValue,
		"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.textboxValue = $event),
		focused: _ctx.focused,
		"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => _ctx.focused = $event),
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		placeholder: _ctx.placeholder,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.propsInternal.messageText,
		"message-severity": _ctx.propsInternal.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"ai-suggestion": _ctx.aiSuggestion,
		class: "input-date",
		onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default"),
			_ctx.displayCalendar ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				focused: _ctx.focused,
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => _ctx.focused = $event),
				class: "input-date-open-calendar-button",
				size: "small",
				variant: "ghost",
				icon: "calendar",
				tabindex: "-1",
				onClick: _ctx.handleOpenCalendarButton
			}, null, 8, ["focused", "onClick"])) : createCommentVNode("", true),
			renderSlot(_ctx.$slots, "after"),
			createVNode(_component_Popover, {
				ref: "calendarPopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.calendarValue,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.calendarValue = $event),
					inline: "",
					"min-date": _ctx.minValue,
					"max-date": _ctx.maxValue
				}, null, 8, [
					"modelValue",
					"min-date",
					"max-date"
				])]),
				_: 1
			}, 8, ["onShow", "onHide"])
		]),
		_: 3
	}, 8, [
		"modelValue",
		"focused",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"placeholder",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"ai-suggestion"
	]);
}
var InputDate_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputDate_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$15]]);
//#endregion
//#region src/components/InputDateTime/InputDateTime.ts?vue&type=script&src=true&lang.ts
var formatStrings = [
	"d",
	"g",
	"G",
	"s",
	"o",
	"u"
];
var InputDateTime_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDateTime",
	components: {
		Button: Button_default,
		Textbox: Textbox_default,
		Popover: Popover_default,
		PrimeDatePicker: PrimeDatePicker$1
	},
	props: {
		...inputProps,
		modelValue: {
			type: Date,
			default: null
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		format: {
			type: String,
			default: "g"
		},
		minValue: {
			type: Date,
			default: void 0
		},
		maxValue: {
			type: Date,
			default: void 0
		},
		calendar: {
			type: Boolean,
			default: true
		},
		time: {
			type: Boolean,
			default: true
		}
	},
	emits: [
		...inputEmits,
		"update:invalidValue",
		"togglePopover"
	],
	setup(props, { emit }) {
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide } = useInputDate(props, emit, formatStrings);
		const displayTime = computed(() => props.time && !props.disabled && !props.readonly);
		useComponentAutomationProperties(root);
		const timePopover = ref();
		const invalidValue = useInputInvalidValue(propsInternal, emit);
		const timeValue = computed({
			get: () => props.modelValue,
			set: (date) => emitNewValue(date)
		});
		function emitNewValue(value) {
			emit("update:modelValue", value);
			invalidValue.value = null;
		}
		function handleOpenCalendarButton() {
			timePopover.value.hide();
			calendarPopover.value.toggle({ currentTarget: root.value.$el });
		}
		function handleOpenTimeButton() {
			calendarPopover.value.hide();
			timePopover.value.toggle({ currentTarget: root.value.$el });
		}
		return {
			root,
			focused,
			key,
			displayCalendar,
			displayTime,
			calendarPopover,
			timePopover,
			textboxValue,
			calendarValue,
			timeValue,
			propsInternal,
			handleOpenCalendarButton,
			handleOpenTimeButton,
			handlePopoverShow,
			handlePopoverHide
		};
	}
});
//#endregion
//#region src/components/InputDateTime/InputDateTime.vue
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_PrimeDatePicker = resolveComponent("PrimeDatePicker");
	const _component_Popover = resolveComponent("Popover");
	const _component_Textbox = resolveComponent("Textbox");
	return openBlock(), createBlock(_component_Textbox, {
		key: _ctx.key,
		ref: "root",
		modelValue: _ctx.textboxValue,
		"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.textboxValue = $event),
		focused: _ctx.focused,
		"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => _ctx.focused = $event),
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		placeholder: _ctx.placeholder,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.propsInternal.messageText,
		"message-severity": _ctx.propsInternal.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"ai-suggestion": _ctx.aiSuggestion,
		class: "input-date-time",
		onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default"),
			_ctx.displayTime ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-date-time-open-time-button",
				size: "small",
				variant: "ghost",
				icon: "clock",
				tabindex: "-1",
				onClick: _ctx.handleOpenTimeButton
			}, null, 8, ["onClick"])) : createCommentVNode("", true),
			_ctx.displayCalendar ? (openBlock(), createBlock(_component_Button, {
				key: 1,
				class: "input-date-time-open-calendar-button",
				size: "small",
				variant: "ghost",
				icon: "calendar",
				tabindex: "-1",
				onClick: _ctx.handleOpenCalendarButton
			}, null, 8, ["onClick"])) : createCommentVNode("", true),
			renderSlot(_ctx.$slots, "after"),
			createVNode(_component_Popover, {
				ref: "calendarPopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.calendarValue,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.calendarValue = $event),
					inline: "",
					"min-date": _ctx.minValue,
					"max-date": _ctx.maxValue
				}, null, 8, [
					"modelValue",
					"min-date",
					"max-date"
				])]),
				_: 1
			}, 8, ["onShow", "onHide"]),
			createVNode(_component_Popover, {
				ref: "timePopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.timeValue,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.timeValue = $event),
					inline: "",
					"time-only": ""
				}, null, 8, ["modelValue"])]),
				_: 1
			}, 8, ["onShow", "onHide"])
		]),
		_: 3
	}, 8, [
		"modelValue",
		"focused",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"placeholder",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"ai-suggestion"
	]);
}
var InputDateTime_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputDateTime_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$14]]);
//#endregion
//#region src/components/InputLocalizableString/InputLocalizableString.ts?vue&type=script&src=true&lang.ts
var images = {
	en: "flagGB",
	fr: "flagFR",
	es: "flagES",
	de: "flagDE",
	it: "flagIT"
};
function useInputLocalizableStringInput(props, currentValue, defaultLanguage, applicationCurrentLanguage, emitNewValue) {
	const { normalizeWhiteSpaceInput, normalizeWhiteSpaceToEmit } = useStringInput();
	const inputPlaceholder = computed(() => currentValue.value?.[defaultLanguage] ?? props.placeholder);
	const editedLanguage = ref(applicationCurrentLanguage);
	const inputValue = ref("");
	let hasPendingInput = false;
	watch(() => currentValue.value?.[editedLanguage.value], (currentLanguageValue) => inputValue.value = currentLanguageValue ?? "", { immediate: true });
	function commitInputValue(inputText) {
		if (!hasPendingInput) return;
		inputText = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, inputText);
		emitNewValue({
			...currentValue.value,
			[editedLanguage.value]: inputText
		});
		hasPendingInput = false;
	}
	function handleInputValueInput(event) {
		let inputText = event.target.value;
		inputText = normalizeWhiteSpaceInput(props.whiteSpaceHandling, inputText);
		inputValue.value = inputText;
		hasPendingInput = true;
	}
	function handleInputValueChange(event) {
		commitInputValue(event.target.value);
	}
	function handleInputValueFocusOut() {
		commitInputValue(inputValue.value);
	}
	return {
		editedLanguage,
		handleInputValueChange,
		handleInputValueInput,
		handleInputValueFocusOut,
		inputPlaceholder,
		inputValue
	};
}
function useInputLocalizableStringModal(currentValue, languages, emitToggleModal, emitNewValue) {
	const { isOpen: isModalOpen, open, close } = useModal();
	const modalDraft = ref({});
	function openModal() {
		modalDraft.value = { ...currentValue.value };
		open();
		emitToggleModal(true);
	}
	function closeModal() {
		close();
		emitToggleModal(false);
	}
	function commitModalDraft() {
		const oldValue = currentValue.value ?? {};
		if (languages.some((l) => modalDraft.value[l] !== oldValue[l])) emitNewValue(modalDraft.value);
		closeModal();
	}
	return {
		isModalOpen,
		modalDraft,
		openModal,
		closeModal,
		commitModalDraft
	};
}
function removeUndefinedValues(value) {
	const newValue = {};
	for (const language in value) if (value[language]) newValue[language] = value[language];
	return newValue;
}
var InputLocalizableString_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputLocalizableString",
	components: {
		Button: Button_default,
		Heading: Heading_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		ButtonsLayout: ButtonsLayout_default,
		Text: Text_default,
		Textbox: Textbox_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: Object,
			default: void 0
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		},
		smartTranslate: {
			type: Function,
			default: void 0
		}
	},
	emits: [...inputEmits, "toggleModal"],
	setup(props, { emit }) {
		const localizator = useLocalizator();
		const inputLabel = computed(() => props.inputDisplayMode === "form" ? props.label : void 0);
		const smartTranslateButtonDisabled = computed(() => {
			const definedValues = Object.values(modalDraft.value).filter(Boolean);
			return definedValues.length === 0 || definedValues.length === localizator.localizableStringLanguages.length;
		});
		const currentValue = toRef(props, "modelValue");
		const root = ref();
		const smartTranslateButtonLoading = ref(false);
		const hasMultipleLanguages = localizator.localizableStringLanguages.length > 1;
		const { editedLanguage, inputValue, inputPlaceholder, handleInputValueFocusOut, handleInputValueInput, handleInputValueChange } = useInputLocalizableStringInput(props, currentValue, localizator.localizableStringDefaultLanguage, localizator.localizableStringCurrentLanguage, emitNewValue);
		const aiSuggestion = computed(() => {
			const suggestion = props.aiSuggestion;
			if (!suggestion) return;
			const languageSuggestedValue = suggestion.suggestedValue?.[editedLanguage.value];
			return {
				text: suggestion.text,
				suggestedValue: languageSuggestedValue
			};
		});
		const { isModalOpen, modalDraft, openModal, closeModal, commitModalDraft } = useInputLocalizableStringModal(currentValue, localizator.localizableStringLanguages, emitToggleModal, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		useComponentAutomationProperties(root);
		const canDisplayButtonsInColumn = computed(() => inputHeight.value > (localizator.localizableStringLanguages.length + 1) * openModalButtonHeight.value);
		const buttons = ref();
		const input = ref();
		const openModalButton = ref();
		const { width: buttonsWidth } = useElementBounding(buttons);
		const { height: inputHeight } = useElementBounding(input);
		const { height: openModalButtonHeight } = useElementBounding(openModalButton);
		onMounted(() => {
			input.value = root.value?.$el.querySelector(".textbox-content.neos-input-content");
		});
		function emitNewValue(value) {
			value = removeUndefinedValues(value);
			emit("update:modelValue", Object.keys(value).length === 0 ? null : value);
		}
		function emitToggleModal(value) {
			emit("toggleModal", value);
		}
		async function handleSmartTranslateButtonClick() {
			smartTranslateButtonLoading.value = true;
			try {
				const value = removeUndefinedValues(modalDraft.value);
				modalDraft.value = await props.smartTranslate(value);
			} finally {
				smartTranslateButtonLoading.value = false;
			}
		}
		function isRequiredLanguage(language) {
			return language === localizator.localizableStringRequiredLanguage ? props.required : false;
		}
		return {
			aiSuggestion,
			buttons,
			buttonsWidth,
			canDisplayButtonsInColumn,
			closeModal,
			commitModalDraft,
			editedLanguage,
			focused,
			handleInputValueFocusOut,
			handleInputValueChange,
			handleInputValueInput,
			handleSmartTranslateButtonClick,
			hasMultipleLanguages,
			images,
			input,
			inputLabel,
			inputPlaceholder,
			inputValue,
			isModalOpen,
			isRequiredLanguage,
			languages: localizator.localizableStringLanguages,
			modalDraft,
			openModal,
			openModalButton,
			root,
			smartTranslateButtonDisabled,
			smartTranslateButtonLoading,
			translate
		};
	}
});
//#endregion
//#region src/components/InputLocalizableString/InputLocalizableString.vue
var _hoisted_1$14 = { class: "input-localizable-string-modal-label" };
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Heading = resolveComponent("Heading");
	const _component_Image = resolveComponent("Image");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_ButtonsLayout = resolveComponent("ButtonsLayout");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createBlock(_component_Textbox, {
		ref: "root",
		focused: _ctx.focused,
		"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => _ctx.focused = $event),
		"model-value": _ctx.inputValue,
		label: _ctx.inputLabel,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		tooltip: _ctx.inputValue,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.messageText,
		"message-severity": _ctx.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"max-length": _ctx.maxLength,
		"multi-lines": _ctx.multiLines,
		rows: _ctx.rows,
		placeholder: _ctx.inputPlaceholder,
		"white-space-handling": _ctx.whiteSpaceHandling,
		"ai-suggestion": _ctx.aiSuggestion,
		class: normalizeClass(["input-localizable-string", { "input-localizable-string-textbox-multiline": _ctx.multiLines }]),
		style: normalizeStyle(`--input-localizable-string-textarea-right-padding: calc(${_ctx.buttonsWidth}px + 0.5rem)`),
		onInput: _ctx.handleInputValueInput,
		onChange: _ctx.handleInputValueChange,
		onFocusout: _ctx.handleInputValueFocusOut,
		onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		default: withCtx(() => [_ctx.hasMultipleLanguages ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
			ref: "buttons",
			class: normalizeClass(["input-localizable-string-buttons", { "input-localizable-string-buttons-column": _ctx.multiLines && _ctx.canDisplayButtonsInColumn }])
		}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language) => {
			return openBlock(), createBlock(_component_Button, {
				key: language,
				"data-lang": language,
				disabled: _ctx.disabled,
				icon: _ctx.images[language],
				tooltip: language,
				variant: _ctx.editedLanguage == language ? "ghost-primary" : "ghost",
				class: "input-localizable-string-button input-localizable-string-switch-language-button",
				size: "small",
				tabindex: "-1",
				onClick: ($event) => _ctx.editedLanguage = language
			}, null, 8, [
				"data-lang",
				"disabled",
				"icon",
				"tooltip",
				"variant",
				"onClick"
			]);
		}), 128)), createVNode(_component_Button, {
			ref: "openModalButton",
			disabled: _ctx.disabled,
			class: "input-localizable-string-button input-localizable-string-open-modal-button",
			icon: "translate",
			size: "small",
			tabindex: "-1",
			variant: "ghost",
			onClick: _ctx.openModal
		}, null, 8, ["disabled", "onClick"])], 2), createVNode(_component_Modal, {
			"is-open": _ctx.isModalOpen,
			"onUpdate:isOpen": _cache[0] || (_cache[0] = ($event) => _ctx.isModalOpen = $event),
			dismissible: false,
			maximizable: false,
			class: "input-localizable-string-modal",
			onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggleModal", false))
		}, {
			header: withCtx(() => [createVNode(_component_Heading, { level: 3 }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			})]),
			body: withCtx(() => [createVNode(_component_VerticalLayout, { align: "space-between" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language, i) => {
					return openBlock(), createElementBlock("div", { key: language }, [createElementVNode("div", _hoisted_1$14, [createElementVNode("span", null, toDisplayString(_ctx.translate("InputLocalizableString_TextboxLabel", language)), 1), createVNode(_component_Image, {
						name: _ctx.images[language],
						size: "extrasmall",
						style: { "margin-right": "0.5rem" }
					}, null, 8, ["name"])]), createVNode(_component_Textbox, {
						modelValue: _ctx.modalDraft[language],
						"onUpdate:modelValue": ($event) => _ctx.modalDraft[language] = $event,
						readonly: _ctx.readonly,
						required: _ctx.isRequiredLanguage(language),
						tooltip: _ctx.modalDraft[language],
						"max-length": _ctx.maxLength,
						"multi-lines": _ctx.multiLines,
						rows: _ctx.rows,
						"data-lang": language,
						focused: i === 0,
						"white-space-handling": _ctx.whiteSpaceHandling,
						class: "input-localizable-string-modal-textbox"
					}, null, 8, [
						"modelValue",
						"onUpdate:modelValue",
						"readonly",
						"required",
						"tooltip",
						"max-length",
						"multi-lines",
						"rows",
						"data-lang",
						"focused",
						"white-space-handling"
					])]);
				}), 128))]),
				_: 1
			})]),
			footer: withCtx(() => [createVNode(_component_HorizontalLayout, {
				align: "space-between",
				class: "neos-fill-parent-width"
			}, {
				default: withCtx(() => [_ctx.smartTranslate ? (openBlock(), createBlock(_component_Button, {
					key: 0,
					class: "input-localizable-string-modal-smart-translate-button",
					icon: "translate",
					label: _ctx.translate("Translate"),
					disabled: _ctx.smartTranslateButtonDisabled,
					loading: _ctx.smartTranslateButtonLoading,
					animated: "",
					onClick: _ctx.handleSmartTranslateButtonClick
				}, null, 8, [
					"label",
					"disabled",
					"loading",
					"onClick"
				])) : createCommentVNode("", true), createVNode(_component_ButtonsLayout, { class: "neos-fill-parent-width" }, {
					default: withCtx(() => [createVNode(_component_Button, {
						class: "input-localizable-string-modal-ok-button",
						variant: "primary",
						icon: "validate",
						label: _ctx.translate("Ok"),
						animated: "",
						onClick: _ctx.commitModalDraft
					}, null, 8, ["label", "onClick"]), createVNode(_component_Button, {
						class: "input-localizable-string-modal-close-button",
						icon: "close",
						label: _ctx.translate("Cancel"),
						animated: "",
						onClick: _ctx.closeModal
					}, null, 8, ["label", "onClick"])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["is-open"])], 64)) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"focused",
		"model-value",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"tooltip",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"max-length",
		"multi-lines",
		"rows",
		"placeholder",
		"white-space-handling",
		"ai-suggestion",
		"class",
		"style",
		"onInput",
		"onChange",
		"onFocusout"
	]);
}
var InputLocalizableString_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputLocalizableString_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$13], ["__scopeId", "data-v-ae733fa4"]]);
//#endregion
//#region src/components/InputMask/InputMask.ts?vue&type=script&src=true&lang.ts
var InputMask_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputMask",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		WjInputMask
	},
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		mask: {
			type: String,
			required: true
		},
		valueMode: {
			type: String,
			default: "raw"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const component = ref({});
		const rawValue = computed(() => props.valueMode === "raw" ? props.modelValue : void 0);
		const value = computed(() => props.valueMode === "formatted" ? props.modelValue : void 0);
		function handleInitialization(inputMask) {
			input.value = inputMask.inputElement;
		}
		function handleChange() {
			if (props.updateMode === "default") emitNewValue();
		}
		function handleInput() {
			if (props.updateMode === "immediate") emitNewValue();
		}
		function emitNewValue() {
			let newValue = props.valueMode === "raw" ? component.value.control.rawValue : component.value.control.value;
			newValue = newValue !== "" ? newValue : null;
			if (newValue !== props.modelValue) emit("update:modelValue", newValue);
		}
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			component,
			rawValue,
			value,
			handleInitialization,
			handleChange,
			handleInput
		};
	}
});
//#endregion
//#region src/components/InputMask/InputMask.vue
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_WjInputMask = resolveComponent("WjInputMask");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-mask neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_WjInputMask, {
		id: _ctx.id,
		ref: "component",
		value: _ctx.value,
		"raw-value": _ctx.rawValue,
		"is-required": false,
		"is-read-only": _ctx.readonly,
		"is-disabled": _ctx.disabled,
		mask: _ctx.mask,
		placeholder: _ctx.placeholder,
		"tab-order": _ctx.tabIndex,
		initialized: _ctx.handleInitialization,
		class: "neos-input-content",
		autocomplete: "nope",
		onChange: _ctx.handleChange,
		onInput: _ctx.handleInput
	}, null, 8, [
		"id",
		"value",
		"raw-value",
		"is-read-only",
		"is-disabled",
		"mask",
		"placeholder",
		"tab-order",
		"initialized",
		"onChange",
		"onInput"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputMask_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputMask_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$12]]);
//#endregion
//#region src/components/InputNumber/InputNumber.ts?vue&type=script&src=true&lang.ts
var InputNumber_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputNumber",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		WjInputNumber
	},
	props: {
		...inputProps,
		modelValue: {
			type: Number,
			default: null
		},
		format: {
			type: String,
			default: void 0
		},
		minValue: {
			type: Number,
			default: void 0
		},
		maxValue: {
			type: Number,
			default: void 0
		},
		alignment: {
			type: String,
			default: "right"
		},
		step: {
			type: Number,
			default: void 0
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		let inputNumber;
		const { translate } = useGlobalResourceManager();
		const _messageTextInternal = ref();
		const _messageSeverityInternal = ref();
		const propsInternal = reactiveComputed(() => ({
			...props,
			messageText: props.messageText ?? _messageTextInternal.value,
			messageSeverity: props.messageSeverity ?? _messageSeverityInternal.value
		}));
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(propsInternal, emit);
		watch(() => props.modelValue, () => checkMinMax());
		/**
		* Checks that the value is within the min/max range.
		* When it is not the case, displays an error message.
		*/
		function checkMinMax() {
			const hasValue = props.modelValue != null;
			if (hasValue && props.minValue != null && props.modelValue < props.minValue) {
				_messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", props.minValue);
				_messageSeverityInternal.value = "error";
			} else if (hasValue && props.maxValue != null && props.modelValue > props.maxValue) {
				_messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", props.maxValue);
				_messageSeverityInternal.value = "error";
			} else {
				_messageTextInternal.value = void 0;
				_messageSeverityInternal.value = void 0;
			}
		}
		function handleInitialization(_inputNumber) {
			input.value = _inputNumber.inputElement;
			inputNumber = _inputNumber;
			inputNumber.inputElement.id = id;
			inputNumber.inputElement.style.textAlign = props.alignment;
		}
		function handleValueChanged() {
			if (inputNumber.value === inputNumber._oldValue && inputNumber.text !== inputNumber._oldText) inputNumber._setText(inputNumber.text);
			let value = inputNumber.value;
			if (value != null && !Number.isFinite(value)) value = null;
			emit("update:modelValue", value);
		}
		return {
			classes,
			handleInitialization,
			handleValueChanged,
			id,
			isLabelVisible,
			isMessageVisible,
			propsInternal,
			tabIndex
		};
	}
});
//#endregion
//#region src/components/InputNumber/InputNumber.vue
var _hoisted_1$13 = {
	key: 0,
	class: "input-number-before-content"
};
var _hoisted_2$7 = {
	key: 1,
	class: "input-number-after-content"
};
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_WjInputNumber = resolveComponent("WjInputNumber");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-number neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_WjInputNumber, {
		value: _ctx.modelValue,
		"is-required": false,
		"is-disabled": _ctx.disabled,
		"is-read-only": _ctx.readonly,
		format: _ctx.format,
		placeholder: _ctx.placeholder,
		initialized: _ctx.handleInitialization,
		"tab-order": _ctx.tabIndex,
		step: _ctx.step,
		class: "input-number-content neos-input-content",
		autocomplete: "nope",
		onChange: _ctx.handleValueChanged
	}, {
		default: withCtx(() => [_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_1$13, [renderSlot(_ctx.$slots, "before", {}, void 0, true)])) : createCommentVNode("", true), _ctx.$slots.default ? (openBlock(), createElementBlock("div", _hoisted_2$7, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])) : createCommentVNode("", true)]),
		_: 3
	}, 8, [
		"value",
		"is-disabled",
		"is-read-only",
		"format",
		"placeholder",
		"initialized",
		"tab-order",
		"step",
		"onChange"
	])]), _ctx.isMessageVisible && _ctx.propsInternal.messageText ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.propsInternal.messageText,
		severity: _ctx.propsInternal.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputNumber_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputNumber_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$11], ["__scopeId", "data-v-219cb045"]]);
//#endregion
//#region src/components/InputNumberCalculable/getWijmoConfig.ts
var FormatTextStatus = /* @__PURE__ */ function(FormatTextStatus) {
	FormatTextStatus[FormatTextStatus["TXT"] = 0] = "TXT";
	FormatTextStatus[FormatTextStatus["RAW"] = 1] = "RAW";
	FormatTextStatus[FormatTextStatus["FORMULA"] = 2] = "FORMULA";
	FormatTextStatus[FormatTextStatus["EVALUATED"] = 3] = "EVALUATED";
	return FormatTextStatus;
}({});
var formatEvaluated = (textToSet) => {
	return {
		status: 3,
		res: {
			formattedText: String(textToSet),
			value: textToSet
		}
	};
};
var formatRaw = (textToSet) => {
	return {
		status: 1,
		res: {
			formattedText: textToSet,
			value: null
		}
	};
};
var formatMath = (text) => {
	return {
		status: 2,
		res: {
			formattedText: text,
			value: null
		}
	};
};
var formatEmpty = () => {
	return {
		status: 0,
		res: {
			formattedText: "",
			value: null
		}
	};
};
var isEmpty = (value) => {
	return !value;
};
function getWijmoConfig(format) {
	const formatInfo = Globalize._parseNumericFormat(format);
	const Keys = {
		Enter: "Enter",
		Escape: "Escape",
		Delete: "Delete",
		Back: "Backspace",
		Up: "ArrowUp",
		Down: "ArrowDown",
		DecimalSeparator: Globalize.getNumberDecimalSeparator(),
		StartFormula: "="
	};
	const _chrDecimalSeparator = Keys.DecimalSeparator;
	const _chrNeg = "-";
	const _chrPls = "+";
	const _chrPct = "%";
	const notEmpty = [
		_chrDecimalSeparator,
		formatInfo.curr || culture.Globalize.numberFormat.currency.symbol,
		_chrNeg,
		_chrPls,
		_chrPct
	].filter(Boolean).map((c) => `\\${c}`);
	const _rxSym = new RegExp(String.raw`^[%+\-() ${notEmpty}]*$`);
	const _rxNeg = /(^\s*-)|([^e][-+]|\()/;
	const _tblMath = new Set([
		"+",
		"-",
		"*",
		"/",
		"=",
		"%",
		"^",
		"(",
		")"
	]);
	const isNumericOnly = (text) => {
		return text >= "0" && text <= "9";
	};
	const isNumeric = (text) => {
		if (text == _chrDecimalSeparator || isNumericOnly(text)) return true;
		return [
			_chrPls,
			_chrNeg,
			"(",
			")"
		].includes(text);
	};
	const _getInputRange = (text) => {
		let _minSet = false;
		let _min = 0;
		let _max = 0;
		for (let n = 0; n < text.length; n++) if (isNumeric(text[n])) {
			if (!_minSet) {
				_min = n;
				_minSet = true;
			}
			_max = n + 1;
		}
		return {
			min: _min,
			max: _max
		};
	};
	const _getClampRange = (selectionStart, currentText, nextText) => {
		const decimalPositionInitial = currentText.indexOf(_chrDecimalSeparator);
		const decimalPositionNextText = nextText.indexOf(_chrDecimalSeparator);
		if (selectionStart <= decimalPositionInitial && decimalPositionNextText !== -1 || decimalPositionInitial === -1 && decimalPositionNextText === -1) return selectionStart + nextText.length - currentText.length;
		if (decimalPositionInitial === -1 && decimalPositionNextText !== -1) return decimalPositionNextText;
		return selectionStart;
	};
	const getNextSelectionRange = (status, selectionStart, currentText, nextText) => {
		if (status !== 0) return null;
		if (!nextText) return {
			selectionStart: 0,
			selectionEnd: 0
		};
		const { min: _start, max: _end } = _getInputRange(nextText);
		const range = clamp(_getClampRange(selectionStart, currentText, nextText), _start, _end);
		return {
			selectionStart: range,
			selectionEnd: range
		};
	};
	const isSeparator = (caract) => {
		return [
			_chrDecimalSeparator,
			_chrPct,
			_chrPct,
			")"
		].includes(caract);
	};
	const isMathKey = (key) => {
		return _tblMath.has(key);
	};
	const addAutoFormat = (text) => {
		if (formatInfo.spec == "p" && text.length > 0 && !text.includes(_chrPct)) return text + _chrPct;
		return text;
	};
	const _getDefaultFormatByPrecision = (indexOfDec) => {
		return indexOfDec > -1 ? "n2" : "n0";
	};
	const parseText = (newText, format) => {
		const indexOfDec = newText.indexOf(Keys.DecimalSeparator);
		const formatWijmo = isEmpty(format) ? _getDefaultFormatByPrecision(indexOfDec) : format;
		return {
			indexOfDec,
			value: Globalize.parseFloat(newText, formatWijmo),
			formatWijmo
		};
	};
	const _isPercentageFormatWithPrecision = () => {
		return formatInfo.spec == "g" && formatInfo.prec != 0;
	};
	const _parseInitialText = (textToSet, format) => {
		if (typeof textToSet === "number") return Globalize.format(textToSet, isEmpty(format) ? "n2" : format);
		if (!textToSet) return "";
		if (_rxSym.test(textToSet)) return (_rxNeg.test(textToSet) ? "-0" : "0") + (textToSet.includes(Keys.DecimalSeparator) ? Keys.DecimalSeparator : "");
		return textToSet;
	};
	const formatText = (textToSet, format) => {
		const newText = _parseInitialText(textToSet, format);
		if (!newText) return {
			status: 0,
			res: {
				formattedText: "",
				value: null
			}
		};
		const { indexOfDec, value: newValue, formatWijmo } = parseText(newText, format);
		if (Number.isNaN(newValue)) return {
			status: 0,
			res: {
				formattedText: newText,
				value: null,
				isNaN: true
			}
		};
		if (indexOfDec > -1 && _isPercentageFormatWithPrecision()) return {
			status: 0,
			res: {
				formattedText: newText,
				value: newValue
			}
		};
		const precision = indexOfDec > -1 ? 2 : null;
		return {
			status: 0,
			res: {
				formattedText: Globalize.format(newValue, formatWijmo, false, false, precision ?? void 0),
				value: newValue
			}
		};
	};
	const preventLeadingNumber = (text, inputSelectionStart) => {
		if (!text) return false;
		const selectionStart = inputSelectionStart;
		const { max } = _getInputRange(text);
		if (selectionStart >= max) {
			const decimalPosition = text.indexOf(Keys.DecimalSeparator);
			if (decimalPosition !== -1 && selectionStart - decimalPosition > (formatInfo.prec ?? 2)) return true;
		}
		return false;
	};
	return {
		getNextSelectionRange,
		addAutoFormat,
		formatText,
		parseText,
		formatRaw,
		formatMath,
		formatEmpty,
		formatEvaluated,
		preventLeadingNumber,
		isNumericOnly,
		isSeparator,
		isMathKey,
		Keys,
		precisionNumber: formatInfo.prec
	};
}
//#endregion
//#region src/components/InputNumberCalculable/InputNumberCalculable.ts?vue&type=script&src=true&lang.ts
function evalMath(text) {
	try {
		if (!/^[0-9+\-*/(),.\s^%]*$/.test(text)) throw new Error("Invalid characters");
		const evalResult = new Function(`"use strict"; return (${text.replaceAll("^", "**")});`)();
		if (typeof evalResult !== "number" || Number.isNaN(evalResult) || !Number.isFinite(evalResult)) throw new TypeError("Invalid mathematical expression");
		return {
			err: null,
			res: +evalResult?.toFixed(5)
		};
	} catch (error) {
		return {
			err: error,
			res: null
		};
	}
}
var withCache = (fn) => {
	const cache = /* @__PURE__ */ new Map();
	return ((...args) => {
		const key = JSON.stringify(args);
		if (cache.has(key)) return cache.get(key);
		const result = fn(...args);
		cache.clear();
		cache.set(key, result);
		return result;
	});
};
var evalMathWithCache = withCache(evalMath);
var InputNumberCalculable_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputNumberCalculable",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		Image: Image_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: Number,
			default: null
		},
		format: {
			type: String,
			default: void 0
		},
		minValue: {
			type: Number,
			default: void 0
		},
		maxValue: {
			type: Number,
			default: void 0
		},
		alignment: {
			type: String,
			default: "right"
		},
		step: {
			type: Number,
			default: void 0
		},
		tooltip: {
			type: String,
			default: void 0
		},
		enableMask: {
			type: Boolean,
			default: true
		},
		updateModelAfterEachEval: {
			type: Boolean,
			default: false
		},
		previewModePosition: {
			type: String,
			default: "hidden"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const calculablePreview = ref(null);
		const inputMode = ref(FormatTextStatus.TXT);
		const _isFormulaError = ref(false);
		const _messageTextInternal = ref();
		const _messageSeverityInternal = ref();
		const propsInternal = reactiveComputed(() => ({
			...props,
			messageText: props.messageText ?? (_isFormulaError.value ? translate("ValidationMessage_InvalidFieldValue_ShortText") : _messageTextInternal.value),
			messageSeverity: props.messageSeverity ?? (_isFormulaError.value ? "error" : _messageSeverityInternal.value)
		}));
		const inputFxt = useInput(propsInternal, emit);
		let _value = null;
		let _oldText = "";
		const _wijmoConfig = getWijmoConfig(props.format ?? "");
		const _evalText = (text) => evalMathWithCache(text.replaceAll(",", "."));
		const _getStep = () => props.step;
		const _getFormat = () => props.format ?? "";
		const _setPreviewValue = (newValue) => {
			calculablePreview.value = newValue;
		};
		const _getValue = () => {
			if (inputMode.value === FormatTextStatus.RAW) return _wijmoConfig.parseText(_getText(), _getFormat()).value;
			if (inputMode.value === FormatTextStatus.FORMULA) {
				const evalResult = _evalText(_getText());
				if (evalResult.err) return null;
				return evalResult.res;
			}
			return _value;
		};
		const _showError = (err) => {
			_isFormulaError.value = !!err;
		};
		const _getInputElement = () => inputFxt.input.value;
		const _getText = () => _getInputElement()?.value;
		const selectAll = () => {
			_getInputElement().select();
		};
		const setSelectionRange = (t, i) => {
			_getInputElement().setSelectionRange(t, i ?? t);
		};
		const _isEditable = () => {
			return !props.readonly && !props.disabled;
		};
		const isCalcInput = () => inputMode.value == FormatTextStatus.FORMULA || inputMode.value === FormatTextStatus.EVALUATED;
		const _incrementModel = (e) => {
			_updateModelValue((_getValue() ?? 0) + e);
		};
		const _mathKeyBeforeCursor = (text) => {
			for (let i = 0; i < _getInputElement().selectionStart; i++) if (_wijmoConfig.isMathKey(text[i])) return true;
			return false;
		};
		const _setInternalState = (format) => {
			_oldText = format.res.formattedText;
			inputMode.value = format.status;
			_value = format.res.value;
			debounceFn(format.res.formattedText, format.status);
		};
		const _setInternalStateAndInput = (format) => {
			_setInternalState(format);
			_getInputElement().value = format.res.formattedText;
		};
		const _setText = (textToSet, truncate = false) => {
			_setInternalStateAndInput(truncate ? _wijmoConfig.formatEmpty() : _wijmoConfig.formatText(textToSet, _getFormat()));
		};
		const _setValue = (newValue) => {
			_showError(null);
			if (inputMode.value === FormatTextStatus.TXT && newValue === _getValue()) return;
			const nullableValue = asNumber(newValue, true);
			if (nullableValue == null) _setText("");
			else if (!Number.isNaN(nullableValue)) _setText(newValue);
		};
		const _updateModelValue = (newValue) => {
			_setValue(newValue);
			if (newValue != props.modelValue) emit("update:modelValue", newValue);
		};
		const _getTextOnInput = (currentText) => {
			if (isCalcInput()) return _wijmoConfig.formatMath(currentText);
			if (props.enableMask) return _wijmoConfig.formatText(_wijmoConfig.addAutoFormat(currentText), _getFormat());
			return _wijmoConfig.formatRaw(currentText);
		};
		const onInput = (e) => {
			const target = e.target;
			const currentText = target.value;
			const res = _getTextOnInput(currentText);
			const nextSelection = _wijmoConfig.getNextSelectionRange(res.status, target.selectionStart, currentText, res.res.formattedText);
			target.value = res.res.formattedText;
			if (props.enableMask && nextSelection) target.setSelectionRange(nextSelection.selectionStart, nextSelection.selectionEnd);
			_setInternalState(res);
		};
		const _getDefaultStep = () => {
			if (!_getStep()) return 1;
			return _getStep();
		};
		const onWheel = (e) => {
			if (!e.defaultPrevented && !e.ctrlKey && _isEditable()) {
				e.preventDefault();
				_incrementModel(_getDefaultStep() * clamp(-1 * (e.deltaY ?? -1), -1, 1));
				nextTick(() => {
					selectAll();
				});
			}
		};
		const onGotFocus = (event) => {
			event.target.select();
		};
		const onBlur = () => {
			if (!_isEditable()) return;
			if (inputMode.value === FormatTextStatus.TXT && _getText() === _oldText) return;
			if (inputMode.value === FormatTextStatus.FORMULA) {
				const evalResult = _evalText(_getText());
				_showError(evalResult.err);
				if (!evalResult.err) {
					_setValue(_getValue());
					_updateModelValue(_getValue());
				}
				return;
			}
			if (isCalcInput()) _setValue(_getValue());
			else _setText(_getText());
			_updateModelValue(_getValue());
		};
		const onIncrement = (sens) => {
			_incrementModel(_getStep() * (sens === "+" ? 1 : -1));
		};
		const _manageKeyDownEnterBackspace = (e) => {
			if (isCalcInput()) return;
			const inputElement = _getInputElement();
			if (!_getValue()) {
				_setText("", true);
				e.preventDefault();
				return;
			}
			const selectionStart = inputElement.selectionStart;
			const selectionEnd = inputElement.selectionEnd;
			if (selectionEnd - selectionStart >= 2) return;
			switch (e.key) {
				case _wijmoConfig.Keys.Back:
					if (_wijmoConfig.isSeparator(inputElement.value[selectionEnd - 1])) {
						setSelectionRange(selectionEnd - 1);
						e.preventDefault();
					}
					break;
				case _wijmoConfig.Keys.Delete:
					if (_wijmoConfig.isSeparator(inputElement.value[selectionStart])) {
						setSelectionRange(selectionStart + 1);
						e.preventDefault();
					}
					break;
			}
		};
		const _manageArrowKeys = (e) => {
			if (_getStep()) {
				e.preventDefault();
				_incrementModel(_getStep() * (e.key == _wijmoConfig.Keys.Up ? 1 : -1));
				selectAll();
			}
		};
		const _manageDecimalSeparatorProtection = (inputElement, e) => {
			if (_wijmoConfig.precisionNumber) {
				const decimalPosition = inputElement.value.indexOf(_wijmoConfig.Keys.DecimalSeparator);
				if (decimalPosition !== -1) {
					setSelectionRange(inputElement.selectionStart <= decimalPosition ? decimalPosition + 1 : decimalPosition);
					e.preventDefault();
				} else if (e.key !== _wijmoConfig.Keys.DecimalSeparator) {
					inputElement.value += _wijmoConfig.Keys.DecimalSeparator;
					setSelectionRange(inputElement.value.length);
					e.preventDefault();
				}
			} else e.preventDefault();
		};
		const _manageKeyPressForTxt = (e) => {
			const inputElement = _getInputElement();
			switch (e.key) {
				case ".":
				case _wijmoConfig.Keys.DecimalSeparator:
					_manageDecimalSeparatorProtection(inputElement, e);
					break;
				default: if (_wijmoConfig.isNumericOnly(e.key)) {
					if (_wijmoConfig.preventLeadingNumber(inputElement.value, inputElement.selectionStart)) e.preventDefault();
				} else e.preventDefault();
			}
		};
		const _manageKeyPressForMath = (e) => {
			const inputElement = _getInputElement();
			if (e.key === "(") {
				if (_mathKeyBeforeCursor(inputElement.value)) inputElement.value += "(";
				else inputElement.value = `(${inputElement.value})`;
				inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
				e.preventDefault();
			}
		};
		const _parseValueOnMathKeyPress = (e) => {
			const inputElement = _getInputElement();
			if (isCalcInput()) return true;
			if (_wijmoConfig.isMathKey(e.key)) {
				_setInternalState(_wijmoConfig.formatMath(""));
				const { value: parsedValue } = _wijmoConfig.parseText(inputElement.value, _getFormat());
				inputElement.value = Number.isNaN(parsedValue) ? "" : String(parsedValue);
				return true;
			}
			return !props.enableMask;
		};
		const onKeyPress = (e) => {
			if (e.defaultPrevented || e.ctrlKey || e.metaKey) return;
			if (!_isEditable()) return;
			if (e.key === _wijmoConfig.Keys.Enter) return;
			if (e.key === _wijmoConfig.Keys.StartFormula) {
				e.preventDefault();
				_setInternalStateAndInput(_wijmoConfig.formatMath(""));
				return;
			}
			if (_parseValueOnMathKeyPress(e)) {
				_manageKeyPressForMath(e);
				return;
			}
			_manageKeyPressForTxt(e);
		};
		const _manageEnterFormula = (e) => {
			e.preventDefault();
			e.stopPropagation();
			const evalResult = _evalText(_getText());
			_showError(evalResult.err);
			if (evalResult.err) return;
			const res = evalResult.res;
			if (props.updateModelAfterEachEval || e.shiftKey) _updateModelValue(res);
			else _setInternalStateAndInput(_wijmoConfig.formatEvaluated(res));
			_setPreviewValue(null);
		};
		const _manageEnterKey = (e) => {
			switch (inputMode.value) {
				case FormatTextStatus.FORMULA:
					_manageEnterFormula(e);
					break;
				case FormatTextStatus.EVALUATED:
					_setText(_getValue());
					_updateModelValue(_getValue());
					selectAll();
					break;
				case FormatTextStatus.RAW:
				case FormatTextStatus.TXT:
					_updateModelValue(_getValue());
					selectAll();
					break;
			}
		};
		const _manageEscapeKey = () => {
			_setText(props.modelValue ?? null);
			selectAll();
		};
		const onKeyDown = (e) => {
			if (e.defaultPrevented) return;
			if (!_isEditable()) return;
			switch (e.key) {
				case _wijmoConfig.Keys.Delete:
				case _wijmoConfig.Keys.Back:
					_manageKeyDownEnterBackspace(e);
					break;
				case _wijmoConfig.Keys.Up:
				case _wijmoConfig.Keys.Down:
					_manageArrowKeys(e);
					break;
				case _wijmoConfig.Keys.Escape:
					_manageEscapeKey();
					break;
				case _wijmoConfig.Keys.Enter:
					_manageEnterKey(e);
					break;
			}
		};
		const onChange = () => {
			if (!props.updateModelAfterEachEval && isCalcInput()) return;
			_updateModelValue(_getValue());
		};
		const debounceFn = useDebounceFn((newValue, mode) => {
			if (props.previewModePosition === "hidden") return;
			if (!newValue || mode != FormatTextStatus.FORMULA) _setPreviewValue(null);
			else {
				const result = _evalText(newValue);
				_setPreviewValue(result.err ? "N/A" : String(result.res));
			}
		}, 300);
		onMounted(() => {
			_setValue(props.modelValue ?? null);
		});
		watch(() => props.modelValue, (newValue) => {
			_setValue(newValue ?? null);
		});
		/**
		* Checks that the value is within the min/max range.
		* When it is not the case, displays an error message.
		*/
		function checkMinMax() {
			const hasValue = props.modelValue != null;
			if (hasValue && props.minValue != null && props.modelValue < props.minValue) {
				_messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", props.minValue);
				_messageSeverityInternal.value = "error";
			} else if (hasValue && props.maxValue != null && props.modelValue > props.maxValue) {
				_messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", props.maxValue);
				_messageSeverityInternal.value = "error";
			} else {
				_messageTextInternal.value = void 0;
				_messageSeverityInternal.value = void 0;
			}
		}
		watch(() => props.modelValue, () => checkMinMax());
		return {
			...inputFxt,
			handleKeyDown: onKeyDown,
			handleKeyPress: onKeyPress,
			handleFocus: onGotFocus,
			handleBlur: onBlur,
			handleWheel: onWheel,
			handleInput: onInput,
			handleValueChanged: onChange,
			handleStep: onIncrement,
			calculablePreview,
			inputMode,
			propsInternal
		};
	}
});
//#endregion
//#region src/components/InputNumberCalculable/InputNumberCalculable.vue
var _hoisted_1$12 = ["title"];
var _hoisted_2$6 = {
	key: 1,
	class: "input-number-before-content"
};
var _hoisted_3$2 = {
	key: 2,
	class: "input-number-after-content"
};
var _hoisted_4$1 = {
	key: 3,
	class: "calculable-preview"
};
var _hoisted_5$1 = [
	"id",
	"tabindex",
	"placeholder",
	"disabled",
	"readonly"
];
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Image = resolveComponent("Image");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["input-number neos-input", _ctx.classes]),
		onWheel: _cache[8] || (_cache[8] = (...args) => _ctx.handleWheel && _ctx.handleWheel(...args))
	}, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for"
	])) : createCommentVNode("", true), createElementVNode("div", {
		class: normalizeClass(["input-number-content neos-input-content", {
			"calc-mode": _ctx.inputMode === 2 || _ctx.inputMode == 3,
			"preview-left": _ctx.previewModePosition === "left",
			"preview-top": _ctx.previewModePosition === "top"
		}]),
		title: _ctx.propsInternal.tooltip ?? void 0
	}, [
		!!_ctx.step ? (openBlock(), createElementBlock("button", {
			key: 0,
			class: "btn-step decrement",
			onClick: _cache[0] || (_cache[0] = ($event) => _ctx.handleStep("-"))
		}, "-")) : createCommentVNode("", true),
		_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_2$6, [renderSlot(_ctx.$slots, "before", {}, void 0, true)])) : createCommentVNode("", true),
		_ctx.$slots.default ? (openBlock(), createElementBlock("div", _hoisted_3$2, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])) : createCommentVNode("", true),
		createVNode(_component_Image, {
			class: "image-calc",
			name: "excel",
			size: "small"
		}),
		_ctx.previewModePosition !== "hidden" ? (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString(_ctx.calculablePreview), 1)) : createCommentVNode("", true),
		createElementVNode("input", {
			id: _ctx.id,
			ref: "input",
			type: "text",
			class: "input-number-input",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholder,
			disabled: _ctx.disabled,
			readonly: _ctx.readonly,
			style: normalizeStyle({ textAlign: _ctx.alignment }),
			spellcheck: "false",
			autocomplete: "off",
			onBlurCapture: _cache[1] || (_cache[1] = (...args) => _ctx.handleBlur && _ctx.handleBlur(...args)),
			onChange: _cache[2] || (_cache[2] = (...args) => _ctx.handleValueChanged && _ctx.handleValueChanged(...args)),
			onInput: _cache[3] || (_cache[3] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onKeydown: _cache[4] || (_cache[4] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args)),
			onKeypress: _cache[5] || (_cache[5] = (...args) => _ctx.handleKeyPress && _ctx.handleKeyPress(...args)),
			onFocus: _cache[6] || (_cache[6] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args))
		}, null, 44, _hoisted_5$1),
		!!_ctx.step ? (openBlock(), createElementBlock("button", {
			key: 4,
			class: "btn-step increment",
			onClick: _cache[7] || (_cache[7] = ($event) => _ctx.handleStep("+"))
		}, "+")) : createCommentVNode("", true)
	], 10, _hoisted_1$12)]), _ctx.propsInternal.messageText ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.propsInternal.messageText,
		severity: _ctx.propsInternal.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 34);
}
var InputNumberCalculable_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputNumberCalculable_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$10], ["__scopeId", "data-v-666c9d2d"]]);
//#endregion
//#region src/components/InputPassword/InputPassword.ts?vue&type=script&src=true&lang.ts
var InputPassword_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputPassword",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		PrimePassword
	},
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		revealable: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const passwordComponent = ref();
		watch(() => passwordComponent.value?.$refs.input, (i) => input.value = i, { immediate: true });
		const passThrough = computed(() => ({ pcInputText: { root: {
			readOnly: props.readonly,
			onChange(event) {
				if (props.updateMode === "default") {
					const target = event.target;
					emitNewValue(target.value);
				}
			},
			onInput(event) {
				if (props.updateMode === "immediate") {
					const target = event.target;
					emitNewValue(target.value);
				}
			}
		} } }));
		function emitNewValue(value) {
			const newValue = value !== "" ? value : null;
			if (newValue !== props.modelValue) emit("update:modelValue", newValue);
		}
		return {
			passwordComponent,
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			passThrough
		};
	}
});
//#endregion
//#region src/components/InputPassword/InputPassword.vue
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_PrimePassword = resolveComponent("PrimePassword");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-password neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_PrimePassword, {
		id: _ctx.id,
		ref: "passwordComponent",
		"model-value": _ctx.modelValue,
		feedback: false,
		disabled: _ctx.disabled,
		placeholder: _ctx.placeholder,
		"toggle-mask": _ctx.revealable,
		pt: _ctx.passThrough,
		tabindex: _ctx.tabIndex,
		class: "neos-input-content"
	}, null, 8, [
		"id",
		"model-value",
		"disabled",
		"placeholder",
		"toggle-mask",
		"pt",
		"tabindex"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputPassword_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputPassword_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$9]]);
//#endregion
//#region src/components/InputTime/InputTime.ts?vue&type=script&src=true&lang.ts
var InputTime_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputTime",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		WjInputTime
	},
	props: {
		...inputProps,
		modelValue: {
			type: Date,
			default: null
		},
		format: {
			type: String,
			default: void 0
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		let _inputTime;
		function handleInitialization(inputTime) {
			_inputTime = inputTime;
			input.value = inputTime.inputElement;
			inputTime.inputElement.id = id;
			inputTime.isDroppedDownChanged.addHandler(handleDropdownChanged);
		}
		function handleDropdownChanged(sender) {
			if (sender.isDroppedDown) ZIndex.set("input-time", sender.dropDown);
			else ZIndex.clear(sender.dropDown);
		}
		function handleValueChanged(inputTime) {
			emit("update:modelValue", inputTime.value);
		}
		onBeforeUnmount(() => {
			if (_inputTime) {
				ZIndex.clear(_inputTime.dropDown);
				_inputTime.isDroppedDownChanged.removeHandler(handleDropdownChanged);
				_inputTime = void 0;
			}
		});
		return {
			classes,
			handleInitialization,
			handleValueChanged,
			id,
			isLabelVisible,
			isMessageVisible,
			tabIndex
		};
	}
});
//#endregion
//#region src/components/InputTime/InputTime.vue
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_WjInputTime = resolveComponent("WjInputTime");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-time neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_WjInputTime, {
		value: _ctx.modelValue,
		"is-required": false,
		"is-read-only": _ctx.readonly,
		"is-disabled": _ctx.disabled,
		placeholder: _ctx.placeholder,
		format: _ctx.format,
		"tab-order": _ctx.tabIndex,
		initialized: _ctx.handleInitialization,
		"value-changed": _ctx.handleValueChanged,
		class: "neos-input-content",
		autocomplete: "nope"
	}, null, 8, [
		"value",
		"is-read-only",
		"is-disabled",
		"placeholder",
		"format",
		"tab-order",
		"initialized",
		"value-changed"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputTime_default = /* @__PURE__ */ _plugin_vue_export_helper_default(InputTime_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$8]]);
//#endregion
//#region src/components/ListBox/ListBoxItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = ["type", "checked"];
//#endregion
//#region src/components/ListBox/ListBoxItem.vue
var ListBoxItem_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ListBoxItem",
	props: {
		value: {},
		multiple: { type: Boolean },
		displayProperty: { default: void 0 },
		checked: {
			type: Boolean,
			default: false
		},
		focused: {
			type: Boolean,
			default: false
		}
	},
	emits: ["click", "checked"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const inputType = computed(() => props.multiple ? "checkbox" : "radio");
		const displayValue = computed(() => props.displayProperty ? getPropertyByPath(props.value, props.displayProperty) : props.value);
		function onClick(event) {
			if (event.target instanceof HTMLElement && event.target.tagName === "INPUT") return;
			emit("click", event);
		}
		function onInputChange(event) {
			emit("checked", event);
		}
		function trueOrUndefined(value) {
			return value || void 0;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				class: "list-box-item",
				"data-checked": trueOrUndefined(__props.checked),
				"data-focused": trueOrUndefined(__props.focused),
				"aria-label": displayValue.value,
				onClick
			}, {
				default: withCtx(() => [createElementVNode("input", {
					type: inputType.value,
					checked: __props.checked,
					tabindex: "-1",
					onChange: onInputChange
				}, null, 40, _hoisted_1$11), createElementVNode("span", null, toDisplayString(displayValue.value), 1)]),
				_: 1
			}, 8, [
				"data-checked",
				"data-focused",
				"aria-label"
			]);
		};
	}
}), [["__scopeId", "data-v-547df099"]]);
//#endregion
//#region src/components/ListBox/ListBox.vue
var ListBox_default = /* @__PURE__ */ defineComponent({
	__name: "ListBox",
	props: /* @__PURE__ */ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: () => []
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		multiple: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": {
			type: Array,
			default: () => []
		},
		"modelModifiers": {}
	}),
	emits: /* @__PURE__ */ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, isLabelVisible, tabIndex } = useInput(props, emit);
		const containerTabIndex = computed(() => tabIndex.value ?? 0);
		const focusedIndex = ref(-1);
		function isCheckedItem(item) {
			const key = getKeyProperty(item);
			return modelValue.value.some((i) => getKeyProperty(i) === key);
		}
		function isFocusedItem(index) {
			return focusedIndex.value === index;
		}
		function getKeyProperty(item) {
			return props.keyProperty ? getPropertyByPath(item, props.keyProperty) : item;
		}
		function onItemClick(event, item, index) {
			focusedIndex.value = index;
			if (props.multiple && event.ctrlKey) modelValue.value = [...modelValue.value, item];
			else modelValue.value = [item];
		}
		function onItemChecked(event, item, index) {
			focusedIndex.value = index;
			toggleItemCheck(item, event.target.checked);
		}
		function onFocus() {
			focusedIndex.value = Math.max(props.values.findIndex(isCheckedItem), 0);
		}
		function onBlur() {
			focusedIndex.value = -1;
		}
		function onKeyDown(event) {
			if (event.key === "ArrowDown") {
				if (setFocusedIndex(focusedIndex.value + 1)) event.preventDefault();
			} else if (event.key === "ArrowUp") {
				if (setFocusedIndex(focusedIndex.value - 1)) event.preventDefault();
			} else if (event.key === "Home") {
				event.preventDefault();
				focusedIndex.value = 0;
			} else if (event.key === "End") {
				event.preventDefault();
				focusedIndex.value = props.values.length - 1;
			} else if (event.key === " ") {
				event.preventDefault();
				toggleItemCheck(props.values[focusedIndex.value]);
			}
		}
		function toggleItemCheck(item, checked = !isCheckedItem(item)) {
			if (props.multiple) if (checked) modelValue.value = [...modelValue.value, item];
			else {
				const key = getKeyProperty(item);
				modelValue.value = modelValue.value.filter((item) => getKeyProperty(item) !== key);
			}
			else modelValue.value = [item];
		}
		function setFocusedIndex(index) {
			if (index >= 0 && index < props.values.length) {
				focusedIndex.value = index;
				return true;
			}
			return false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["list-box neos-input", unref(classes)]) }, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id)
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for"
			])) : createCommentVNode("", true), createVNode(VerticalLayout_default, {
				id: unref(id),
				ref: (el) => input.value = el,
				space: "extrasmall",
				tabindex: containerTabIndex.value,
				class: "list-box-container",
				onKeydown: onKeyDown,
				onFocus,
				onBlur
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.values, (item, index) => {
					return openBlock(), createBlock(ListBoxItem_default, {
						key: getKeyProperty(item),
						value: item,
						multiple: __props.multiple,
						"display-property": __props.displayProperty,
						checked: isCheckedItem(item),
						focused: isFocusedItem(index),
						onClick: ($event) => onItemClick($event, item, index),
						onChecked: ($event) => onItemChecked($event, item, index)
					}, null, 8, [
						"value",
						"multiple",
						"display-property",
						"checked",
						"focused",
						"onClick",
						"onChecked"
					]);
				}), 128))]),
				_: 1
			}, 8, ["id", "tabindex"])], 2);
		};
	}
});
//#endregion
//#region src/composables/useParentElement.ts
function useParentElement() {
	const parentElement = ref(null);
	const vm = getCurrentInstance();
	onMounted(() => {
		parentElement.value = vm.proxy.$el.parentElement;
	});
	onUnmounted(() => {
		parentElement.value = null;
	});
	return parentElement;
}
//#endregion
//#region src/components/Spinner/Spinner.ts?vue&type=script&src=true&lang.ts
var Spinner_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Spinner",
	props: { size: {
		type: String,
		default: "medium"
	} },
	setup(props) {
		return { spinnerClasses: computed(() => [`spinner-${props.size}`]) };
	}
});
//#endregion
//#region src/components/Spinner/Spinner.vue
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", { class: normalizeClass(["spinner-container", _ctx.spinnerClasses]) }, [..._cache[0] || (_cache[0] = [createElementVNode("svg", {
		class: "spinner",
		fill: "none",
		viewBox: "0 0 24 24"
	}, [createElementVNode("circle", {
		cx: "12",
		cy: "12",
		r: "10",
		stroke: "currentColor",
		"stroke-width": "4",
		style: { "opacity": "0.25" }
	}), createElementVNode("path", {
		fill: "currentColor",
		d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
	})], -1)])], 2);
}
var Spinner_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Spinner_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$7], ["__scopeId", "data-v-8740c195"]]);
//#endregion
//#region src/components/LoadDataOnScroll/LoadDataOnScroll.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$10 = {
	key: 0,
	class: "load-data-on-scroll-spinner"
};
//#endregion
//#region src/components/LoadDataOnScroll/LoadDataOnScroll.vue
var LoadDataOnScroll_default = /* @__PURE__ */ defineComponent({
	__name: "LoadDataOnScroll",
	props: {
		direction: { default: "vertical" },
		onLoad: {
			type: Function,
			default: void 0
		},
		hasMoreData: { type: Boolean },
		spinnerSize: { default: "extralarge" }
	},
	setup(__props) {
		const props = __props;
		const loading = ref(false);
		const enabled = computed(() => props.onLoad && props.hasMoreData && !loading.value);
		const parentElement = useParentElement();
		const containerElement = computed(() => {
			const childElement = parentElement.value?.firstElementChild;
			return childElement?.hasAttribute("data-virtual-repeat") ? childElement : parentElement.value;
		});
		watch([enabled, containerElement], async () => {
			while (enabled.value && containerElement.value && !hasScrollbar(containerElement.value, props.direction)) await load();
		});
		useEventListener(containerElement, "scroll", onScroll);
		async function onScroll(event) {
			if (enabled.value && isAtScrollEnd(event.target, props.direction)) await load();
		}
		function hasScrollbar(element, direction) {
			if (direction === "horizontal") return element.scrollWidth > element.clientWidth;
			return element.scrollHeight > element.clientHeight;
		}
		function isAtScrollEnd(element, direction) {
			if (direction === "horizontal") {
				const threshold = (element.scrollWidth - element.clientWidth) * .1;
				return element.scrollLeft + element.clientWidth >= element.scrollWidth - threshold;
			}
			const threshold = (element.scrollHeight - element.clientHeight) * .1;
			return element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;
		}
		async function load() {
			loading.value = true;
			try {
				await props.onLoad();
			} finally {
				loading.value = false;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [renderSlot(_ctx.$slots, "default"), loading.value ? (openBlock(), createElementBlock("div", _hoisted_1$10, [createVNode(Spinner_default, { size: __props.spinnerSize }, null, 8, ["size"])])) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
//#region src/components/Message/Message.ts?vue&type=script&src=true&lang.ts
var Message_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Message",
	components: {
		Button: Button_default,
		Image: Image_default,
		Text: Text_default,
		HorizontalLayout: HorizontalLayout_default
	},
	props: {
		visible: {
			type: Boolean,
			default: void 0
		},
		showIcon: {
			type: Boolean,
			default: true
		},
		severity: {
			type: String,
			default: "info"
		},
		closable: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:visible"],
	setup(props, { emit }) {
		const internalVisible = ref(true);
		const isVisible = computed({
			get() {
				return props.visible ?? internalVisible.value;
			},
			set(value) {
				if (props.visible !== void 0) {
					emit("update:visible", value);
					return;
				}
				internalVisible.value = value;
			}
		});
		const severityClass = computed(() => `message-${props.severity}`);
		function close() {
			isVisible.value = false;
		}
		useComponentAutomationProperties();
		return {
			isVisible,
			severityClass,
			close
		};
	}
});
//#endregion
//#region src/components/Message/Message.vue
var _hoisted_1$9 = { class: "message-content neos-vertical-content neos-fill-parent-width" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(Transition, { name: "message" }, {
		default: withCtx(() => [_ctx.isVisible ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["message", `message-${_ctx.severity}`])
		}, [createVNode(_component_HorizontalLayout, {
			class: "message-wrapper neos-fill-parent-width",
			wrap: false
		}, {
			default: withCtx(() => [
				_ctx.showIcon ? (openBlock(), createBlock(_component_Image, {
					key: 0,
					name: _ctx.severity,
					size: "large",
					class: "message-icon"
				}, null, 8, ["name"])) : createCommentVNode("", true),
				createElementVNode("div", _hoisted_1$9, [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_ctx.closable ? (openBlock(), createBlock(_component_Button, {
					key: 1,
					class: "message-close-button",
					variant: "link",
					size: "small",
					onClick: _cache[0] || (_cache[0] = ($event) => _ctx.close())
				}, {
					default: withCtx(() => [createVNode(_component_Image, { name: "close" })]),
					_: 1
				})) : createCommentVNode("", true)
			]),
			_: 3
		})], 2)) : createCommentVNode("", true)]),
		_: 3
	});
}
var Message_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Message_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$6], ["__scopeId", "data-v-2238c6f5"]]);
//#endregion
//#region src/components/MultiSelect/MultiSelect.ts?vue&type=script&src=true&lang.ts
var MultiSelect_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "MultiSelect",
	components: {
		Button: Button_default,
		InputLabel: InputLabel_default,
		Image: Image_default,
		PrimeMultiSelect
	},
	props: {
		...inputProps,
		modelValue: {
			type: Array,
			default: () => []
		},
		values: {
			type: Array,
			default: () => []
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		showSelectAllCheckbox: {
			type: Boolean,
			default: false
		},
		showFilterInput: {
			type: Boolean,
			default: false
		},
		sortByCheckedValues: {
			type: Boolean,
			default: false
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const items = computed(() => {
			if (props.sortByCheckedValues) return [...props.values].sort((a, b) => {
				const aChecked = checkedItems.value.find((m) => JSON.stringify(m) === JSON.stringify(a));
				const bChecked = checkedItems.value.find((m) => JSON.stringify(m) === JSON.stringify(b));
				return aChecked && !bChecked ? -1 : 1;
			});
			return props.values;
		});
		const checkedItems = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			}
		});
		const showClearButton = computed(() => !props.disabled && !props.readonly && checkedItems.value.length > 0);
		const multiSelect = ref();
		watch(multiSelect, () => {
			const originalOnContainerClick = multiSelect.value.onContainerClick;
			multiSelect.value.onContainerClick = (event) => {
				if (!isBeforeAndAfterContent(event)) originalOnContainerClick.call(multiSelect.value, event);
			};
			const originalIsOutsideClicked = multiSelect.value.isOutsideClicked;
			multiSelect.value.isOutsideClicked = (event) => isBeforeAndAfterContent(event) || originalIsOutsideClicked.call(multiSelect.value, event);
		});
		function isBeforeAndAfterContent(event) {
			return event.target instanceof HTMLElement && (event.target.closest(".multi-select-before-content") || event.target.closest(".multi-select-after-content"));
		}
		function handleClearButtonClick() {
			checkedItems.value = [];
		}
		function formatValue(values) {
			return values?.map((v) => v.caption).join(", ") ?? "";
		}
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			items,
			checkedItems,
			showClearButton,
			multiSelect,
			handleClearButtonClick,
			formatValue
		};
	}
});
//#endregion
//#region src/components/MultiSelect/MultiSelect.vue
var _hoisted_1$8 = {
	key: 0,
	class: "multi-select-before-content"
};
var _hoisted_2$5 = { class: "multi-select-value" };
var _hoisted_3$1 = { class: "multi-select-after-content" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Button = resolveComponent("Button");
	const _component_PrimeMultiSelect = resolveComponent("PrimeMultiSelect");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["multi-select neos-input", _ctx.classes]) }, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for"
	])) : createCommentVNode("", true), createVNode(_component_PrimeMultiSelect, {
		id: _ctx.id,
		ref: "multiSelect",
		modelValue: _ctx.checkedItems,
		"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.checkedItems = $event),
		disabled: _ctx.disabled || _ctx.readonly,
		options: _ctx.items,
		"option-label": _ctx.displayProperty,
		"show-toggle-all": _ctx.showSelectAllCheckbox,
		filter: _ctx.showFilterInput,
		class: "neos-input-content",
		pt: { pcOptionCheckbox: { input: { tabIndex: void 0 } } },
		tabindex: _ctx.tabIndex
	}, {
		value: withCtx(({ value }) => [
			_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_1$8, [renderSlot(_ctx.$slots, "before")])) : createCommentVNode("", true),
			createElementVNode("span", _hoisted_2$5, toDisplayString(_ctx.formatValue(value)), 1),
			createElementVNode("div", _hoisted_3$1, [renderSlot(_ctx.$slots, "default"), _ctx.showClearButton ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-clear-button",
				size: "small",
				variant: "ghost",
				icon: "erase",
				tabindex: "-1",
				onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.handleClearButtonClick(), ["stop"]))
			})) : createCommentVNode("", true)])
		]),
		_: 3
	}, 8, [
		"id",
		"modelValue",
		"disabled",
		"options",
		"option-label",
		"show-toggle-all",
		"filter",
		"tabindex"
	])], 2);
}
var MultiSelect_default = /* @__PURE__ */ _plugin_vue_export_helper_default(MultiSelect_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$5]]);
//#endregion
//#region src/components/PaginationBar/PaginationBar.ts?vue&type=script&src=true&lang.ts
var PaginationBar_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "PaginationBar",
	components: {
		Button: Button_default,
		Combobox: Combobox_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Text: Text_default
	},
	props: {
		pageNumber: {
			type: Number,
			required: true
		},
		canMoveToNextPage: {
			type: Boolean,
			required: true
		},
		recordsByPage: {
			type: Number,
			required: true
		},
		recordsByPageList: {
			type: Array,
			default: () => [
				5,
				10,
				20,
				50
			]
		},
		totalRecordCount: {
			type: Number,
			default: void 0
		}
	},
	emits: ["update:pageNumber", "update:recordsByPage"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const internalPageNumber = computed({
			get: () => props.pageNumber,
			set: (value) => emit("update:pageNumber", value)
		});
		const internalRecordsByPage = computed({
			get: () => props.recordsByPage,
			set: (value) => emit("update:recordsByPage", value)
		});
		const internalRecordsByPageList = computed(() => props.recordsByPageList.includes(internalRecordsByPage.value) ? props.recordsByPageList : [...props.recordsByPageList, internalRecordsByPage.value].sort((a, b) => a - b));
		const canMoveToPreviousPage = computed(() => internalPageNumber.value > 1);
		const totalRecordCountCaption = computed(() => {
			if (props.totalRecordCount === void 0) return;
			return `/ ${props.totalRecordCount} ${translate(props.totalRecordCount > 1 ? "Items" : "Item").toLowerCase()}`;
		});
		function moveToFirstPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value = 1;
		}
		function moveToPreviousPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value -= 1;
		}
		function moveToNextPage() {
			if (props.canMoveToNextPage) internalPageNumber.value += 1;
		}
		return {
			internalPageNumber,
			internalRecordsByPage,
			internalRecordsByPageList,
			canMoveToPreviousPage,
			moveToFirstPage,
			moveToPreviousPage,
			moveToNextPage,
			totalRecordCountCaption
		};
	}
});
//#endregion
//#region src/components/PaginationBar/PaginationBar.vue
var _hoisted_1$7 = { class: "pagination-page-number" };
var _hoisted_2$4 = {
	key: 0,
	class: "pagination-total-record-count"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Text = resolveComponent("Text");
	const _component_Combobox = resolveComponent("Combobox");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		class: "pagination-bar",
		"vertical-align": "center"
	}, {
		default: withCtx(() => [
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-first",
				icon: "doubleChevronLeft",
				onClick: _ctx.moveToFirstPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-previous",
				icon: "chevronLeft",
				onClick: _ctx.moveToPreviousPage
			}, null, 8, ["disabled", "onClick"]),
			createElementVNode("div", _hoisted_1$7, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.internalPageNumber), 1)]),
				_: 1
			})]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToNextPage,
				class: "pagination-button-move-next",
				icon: "chevronRight",
				onClick: _ctx.moveToNextPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Combobox, {
				modelValue: _ctx.internalRecordsByPage,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.internalRecordsByPage = $event),
				values: _ctx.internalRecordsByPageList,
				required: "",
				class: "pagination-records-by-page"
			}, null, 8, ["modelValue", "values"]),
			_ctx.totalRecordCountCaption ? (openBlock(), createElementBlock("div", _hoisted_2$4, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.totalRecordCountCaption), 1)]),
				_: 1
			})])) : createCommentVNode("", true)
		]),
		_: 1
	});
}
var PaginationBar_default = /* @__PURE__ */ _plugin_vue_export_helper_default(PaginationBar_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$4], ["__scopeId", "data-v-748292b0"]]);
//#endregion
//#region src/components/ProgressBar/ProgressBar.vue
var ProgressBar_default = /* @__PURE__ */ defineComponent({
	__name: "ProgressBar",
	props: {
		value: { default: void 0 },
		showValue: {
			type: Boolean,
			default: true
		},
		mode: { default: "determinate" }
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeProgressBar), {
				class: "progress-bar",
				value: __props.value,
				"show-value": __props.showValue,
				mode: __props.mode
			}, null, 8, [
				"value",
				"show-value",
				"mode"
			]);
		};
	}
});
//#endregion
//#region src/components/ProgressIndicator/ProgressIndicator.vue
var ProgressIndicator_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ProgressIndicator",
	props: { text: {} },
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const displayText = computed(() => props.text ?? translate("Loading"));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, {
				align: "center",
				class: "progress-indicator"
			}, {
				default: withCtx(() => [createVNode(DotLoader_default, { size: "extralarge" }), createVNode(Text_default, { size: "extralarge" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(displayText.value), 1)]),
					_: 1
				})]),
				_: 1
			});
		};
	}
}), [["__scopeId", "data-v-90d9e393"]]);
//#endregion
//#region src/components/ResponsiveDatagridWrapper/ResponsiveDatagridWrapper.vue
var ResponsiveDatagridWrapper_default = /* @__PURE__ */ defineComponent({
	__name: "ResponsiveDatagridWrapper",
	props: {
		cardMode: {
			type: Boolean,
			default: void 0
		},
		cardModeScope: { default: "window" },
		cardModeBreakpoint: { default: BreakpointValues.medium }
	},
	setup(__props) {
		const props = __props;
		const containerElement = useTemplateRef("container");
		const datagridMode = useDatagridMode();
		function useDatagridMode() {
			if (props.cardMode !== void 0) return computed(() => !props.cardMode);
			const datagridMode = ref(false);
			const cardModeScopeWidth = props.cardModeScope === "container" ? useElementSize(containerElement).width : useWindowSize().width;
			const cardModeBreakpoint = computed(() => {
				if (typeof props.cardModeBreakpoint === "number") return props.cardModeBreakpoint;
				return BreakpointValues[props.cardModeBreakpoint];
			});
			watch(cardModeScopeWidth, () => {
				datagridMode.value = cardModeScopeWidth.value >= cardModeBreakpoint.value;
			}, { immediate: true });
			return datagridMode;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { ref: "container" }, {
				default: withCtx(() => [unref(datagridMode) ? renderSlot(_ctx.$slots, "datagrid", { key: 0 }) : renderSlot(_ctx.$slots, "data-cards", { key: 1 })]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/Splitter/Splitter.ts?vue&type=script&src=true&lang.ts
var splitterResizedEventName$1 = "neos-splitter:resized";
var Splitter_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Splitter",
	components: { Splitpanes },
	props: {
		horizontal: {
			type: Boolean,
			default: false
		},
		barColor: {
			type: String,
			default: ""
		},
		barHoverColor: {
			type: String,
			default: ""
		},
		barCornerRadius: {
			type: String,
			validator: (value) => multiSpaceValueValidatorExpression.test(value),
			default: "none"
		}
	},
	setup(props) {
		const splitpanesElement = ref(null);
		const style = computed(() => {
			const ret = { "--splitter-bar-corner-radius": getMultiSpaceValue(props.barCornerRadius) };
			if (props.barColor) ret["--splitter-bar-color"] = `var(--${props.barColor})`;
			if (props.barHoverColor) ret["--splitter-bar-hover-color"] = `var(--${props.barHoverColor})`;
			return ret;
		});
		function handleResized(args) {
			(splitpanesElement.value?.$el)?.dispatchEvent(new CustomEvent(splitterResizedEventName$1, { detail: args }));
		}
		useComponentAutomationProperties();
		return {
			style,
			handleResized,
			splitpanesElement
		};
	}
});
//#endregion
//#region src/components/Splitter/Splitter.vue
var _hoisted_1$6 = { class: "neos-vertical-content splitter" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Splitpanes = resolveComponent("Splitpanes");
	return openBlock(), createElementBlock("div", _hoisted_1$6, [createVNode(_component_Splitpanes, {
		ref: "splitpanesElement",
		class: "splitter",
		style: normalizeStyle(_ctx.style),
		horizontal: _ctx.horizontal,
		onResized: _ctx.handleResized
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 8, [
		"style",
		"horizontal",
		"onResized"
	])]);
}
var Splitter_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Splitter_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$3], ["__scopeId", "data-v-3673092d"]]);
//#endregion
//#region src/components/Splitter/Splitter.ts
var splitterResizedEventName = "neos-splitter:resized";
defineComponent({
	name: "Splitter",
	components: { Splitpanes },
	props: {
		horizontal: {
			type: Boolean,
			default: false
		},
		barColor: {
			type: String,
			default: ""
		},
		barHoverColor: {
			type: String,
			default: ""
		},
		barCornerRadius: {
			type: String,
			validator: (value) => multiSpaceValueValidatorExpression.test(value),
			default: "none"
		}
	},
	setup(props) {
		const splitpanesElement = ref(null);
		const style = computed(() => {
			const ret = { "--splitter-bar-corner-radius": getMultiSpaceValue(props.barCornerRadius) };
			if (props.barColor) ret["--splitter-bar-color"] = `var(--${props.barColor})`;
			if (props.barHoverColor) ret["--splitter-bar-hover-color"] = `var(--${props.barHoverColor})`;
			return ret;
		});
		function handleResized(args) {
			(splitpanesElement.value?.$el)?.dispatchEvent(new CustomEvent(splitterResizedEventName, { detail: args }));
		}
		useComponentAutomationProperties();
		return {
			style,
			handleResized,
			splitpanesElement
		};
	}
});
//#endregion
//#region src/components/SplitterPanel/SplitterPanel.ts?vue&type=script&src=true&lang.ts
function getClosestSplitterElement(paneElement) {
	return (paneElement?.$el)?.closest(".splitpanes") ?? null;
}
function getSplitterPaneIndex(paneElement, splitterElement) {
	const pane = paneElement?.$el;
	if (pane == null || splitterElement == null) return null;
	const paneIndex = Array.from(splitterElement.children).filter((element) => element instanceof HTMLElement && element.classList.contains("splitpanes__pane")).findIndex((element) => element.isSameNode(pane));
	return paneIndex === -1 ? null : paneIndex;
}
function emitResizedPaneSize(emit, paneElement, splitterElement, panes) {
	const paneIndex = getSplitterPaneIndex(paneElement, splitterElement);
	if (paneIndex == null) return;
	emit("update:size", panes[paneIndex]?.size);
}
var SplitterPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "SplitterPanel",
	components: { Pane },
	emits: ["update:size"],
	props: {
		size: {
			type: [Number, String],
			default: void 0
		},
		minSize: {
			type: [Number, String],
			default: 0
		},
		maxSize: {
			type: [Number, String],
			default: 100
		}
	},
	setup(_, { emit }) {
		const paneElement = ref(null);
		let splitterElement = null;
		const handleSplitterResized = (event) => {
			const resizedEvent = event;
			emitResizedPaneSize(emit, paneElement.value, splitterElement, resizedEvent.detail.panes);
		};
		onMounted(() => {
			splitterElement = getClosestSplitterElement(paneElement.value);
			splitterElement?.addEventListener(splitterResizedEventName, handleSplitterResized);
		});
		onUnmounted(() => {
			splitterElement?.removeEventListener(splitterResizedEventName, handleSplitterResized);
		});
		return { paneElement };
	}
});
//#endregion
//#region src/components/SplitterPanel/SplitterPanel.vue
var _hoisted_1$5 = { class: "splitter-panel-content neos-vertical-content" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Pane = resolveComponent("Pane");
	return openBlock(), createBlock(_component_Pane, {
		ref: "paneElement",
		class: "splitter-panel",
		"min-size": _ctx.minSize,
		"max-size": _ctx.maxSize,
		size: _ctx.size
	}, {
		default: withCtx(() => [createElementVNode("div", _hoisted_1$5, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
		_: 3
	}, 8, [
		"min-size",
		"max-size",
		"size"
	]);
}
var SplitterPanel_default = /* @__PURE__ */ _plugin_vue_export_helper_default(SplitterPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$2], ["__scopeId", "data-v-bd033c55"]]);
//#endregion
//#region src/components/Tabs/Tabs.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = [
	"data-tab-index",
	"label",
	"onClick"
];
var _hoisted_2$3 = { class: "tab-details neos-fill-parent-height" };
var tabManagerKey = "tabManager";
//#endregion
//#region src/components/Tabs/Tabs.vue
var Tabs_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Tabs",
	props: {
		"selectedIndex": {
			required: false,
			default: -1
		},
		"selectedIndexModifiers": {}
	},
	emits: ["update:selectedIndex"],
	setup(__props) {
		const selectedIndex = useModel(__props, "selectedIndex");
		const tabs = ref([]);
		function registerTab(caption, visible, icon) {
			const tab = reactive({
				caption,
				visible,
				icon,
				get index() {
					return tabs.value.indexOf(tab);
				},
				get active() {
					return selectedIndex.value === this.index;
				}
			});
			tabs.value.push(tab);
			if (selectedIndex.value === -1 && visible.value) selectedIndex.value = tab.index;
			return tab;
		}
		function selectNextVisibleTab(fromIndex) {
			for (let i = fromIndex; i < tabs.value.length; i++) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			for (let i = fromIndex - 1; i >= 0; i--) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			selectedIndex.value = -1;
		}
		function unregisterTab(tab) {
			const index = tab.index;
			const wasSelected = selectedIndex.value === index;
			tabs.value.splice(index, 1);
			if (wasSelected) selectNextVisibleTab(index);
			else if (selectedIndex.value > index) selectedIndex.value--;
		}
		function onTabVisibilityChanged(tab) {
			const index = tab.index;
			if (selectedIndex.value === -1 && tab.visible) selectedIndex.value = index;
			else if (index === selectedIndex.value && !tab.visible) selectNextVisibleTab(index + 1);
		}
		function handleTabClick(index) {
			selectedIndex.value = index;
		}
		provide(tabManagerKey, {
			registerTab,
			unregisterTab,
			onTabVisibilityChanged
		});
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { class: "tabs-container neos-fill-parent-height" }, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, {
					class: "tabs-headers-container",
					space: "none",
					wrap: false
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(tabs.value, (tab, index) => {
						return openBlock(), createElementBlock(Fragment, { key: index }, [tab.visible ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: normalizeClass(["tab", { "tab-active": tab.active }]),
							"data-tab-index": index,
							label: tab.caption,
							onClick: ($event) => handleTabClick(index)
						}, [createVNode(Image_default, { name: tab.icon }, null, 8, ["name"]), createVNode(Text_default, {
							class: "tab-text",
							style: normalizeStyle(`--tab-text: '${tab.caption}'`)
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(tab.caption), 1)]),
							_: 2
						}, 1032, ["style"])], 10, _hoisted_1$4)) : createCommentVNode("", true)], 64);
					}), 128))]),
					_: 1
				}), createElementVNode("div", _hoisted_2$3, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-2b898449"]]);
//#endregion
//#region src/components/TabItem/TabItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = ["data-tab-index"];
//#endregion
//#region src/components/TabItem/TabItem.vue
var TabItem_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TabItem",
	props: {
		caption: { default: "" },
		visible: {
			type: [
				Boolean,
				Object,
				null
			],
			default: void 0
		},
		icon: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const tabManager = inject(tabManagerKey);
		const visible = computed(() => {
			if (props.visible === void 0) return true;
			if (typeof props.visible === "boolean") return props.visible;
			return props.visible != null;
		});
		const root = ref();
		const tab = shallowRef(null);
		const isSlotMounted = ref(false);
		useComponentAutomationProperties(root);
		useIntersectionObserver(root, ([{ isIntersecting }], o) => {
			if (isIntersecting) {
				isSlotMounted.value = true;
				o.disconnect();
			}
		});
		onMounted(() => {
			tab.value = tabManager.registerTab(toRef(props, "caption"), visible, toRef(props, "icon"));
			isSlotMounted.value = tab.value.active;
		});
		watch(() => props.visible, () => tabManager.onTabVisibilityChanged(tab.value));
		onUnmounted(() => {
			tabManager.unregisterTab(tab.value);
		});
		return (_ctx, _cache) => {
			return tab.value && (tab.value.active || isSlotMounted.value) ? withDirectives((openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "root",
				ref: root,
				"data-tab-index": tab.value?.index,
				class: "tab-item neos-vertical-content"
			}, [isSlotMounted.value ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : (openBlock(), createBlock(ProgressIndicator_default, { key: 1 }))], 8, _hoisted_1$3)), [[vShow, tab.value?.active]]) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-075b08b1"]]);
//#endregion
//#region src/components/Timeline/Timeline.vue
var Timeline_default = /* @__PURE__ */ defineComponent({
	__name: "Timeline",
	props: {
		source: { default: () => [] },
		orientation: { default: "vertical" },
		align: { default: "left" }
	},
	setup(__props) {
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeTimeline), {
				value: __props.source,
				layout: __props.orientation,
				align: __props.align
			}, createSlots({ _: 2 }, [
				_ctx.$slots.content ? {
					name: "content",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "content", { context: item })]),
					key: "0"
				} : void 0,
				_ctx.$slots.marker ? {
					name: "marker",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "marker", { context: item })]),
					key: "1"
				} : void 0,
				_ctx.$slots.opposite ? {
					name: "opposite",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "opposite", { context: item })]),
					key: "2"
				} : void 0
			]), 1032, [
				"value",
				"layout",
				"align"
			]);
		};
	}
});
//#endregion
//#region src/components/Toast/Toast.ts?vue&type=script&src=true&lang.ts
var Toast_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Toast",
	components: {
		Button: Button_default,
		Divider: Divider_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		PrimeToast
	},
	props: {
		position: {
			type: String,
			default: "bottom-right"
		},
		group: {
			type: String,
			default: void 0
		}
	},
	setup() {
		const buttonContainerSpace = useButtonContainerSpace(useThemeManager(false));
		const pt = computed(() => ({
			message: (options) => ({
				onMouseover: () => {
					const message = options.props.message;
					clearInterval(message.intervalId);
				},
				onMouseleave: () => {
					options.props.message.start?.();
				}
			}),
			closeButton: { class: "neos-close-button button-extrasmall" }
		}));
		function getImageName(severity) {
			switch (severity) {
				case "info": return "info";
				case "error": return "danger";
				case "warn": return "warning";
				case "success": return "positive";
			}
		}
		/* istanbul ignore next -- @preserve */
		function getBackgroundColorValue(severity) {
			switch (severity) {
				case "info": return "var(--toast-info-icon)";
				case "warn": return "var(--toast-warning-icon)";
				case "error": return "var(--toast-danger-icon)";
				case "success": return "var(--toast-positive-icon)";
			}
		}
		function getButtonClass(index, severity) {
			const mainClass = index === 0 ? `toast-primary-button` : `toast-secondary-button`;
			switch (severity) {
				case "error": return `${mainClass}-danger`;
				case "info": return `${mainClass}-info`;
				case "success": return `${mainClass}-positive`;
				case "warn": return `${mainClass}-warning`;
			}
		}
		return {
			buttonContainerSpace,
			getBackgroundColorValue,
			getButtonClasses: getButtonClass,
			getImageName,
			pt
		};
	}
});
//#endregion
//#region src/components/Toast/Toast.vue
var _hoisted_1$2 = { class: "p-toast-content" };
var _hoisted_2$2 = { class: "p-toast-header" };
var _hoisted_3 = { class: "p-toast-summary" };
var _hoisted_4 = { class: "p-toast-detail" };
var _hoisted_5 = { class: "toast-buttons" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Divider = resolveComponent("Divider");
	const _component_Button = resolveComponent("Button");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_PrimeToast = resolveComponent("PrimeToast");
	return openBlock(), createBlock(_component_PrimeToast, {
		position: _ctx.position,
		group: _ctx.group,
		pt: _ctx.pt
	}, {
		message: withCtx((slotProps) => [createElementVNode("div", _hoisted_1$2, [
			createElementVNode("div", _hoisted_2$2, [createVNode(_component_Image, {
				class: "p-toast-message-icon",
				style: normalizeStyle({ backgroundColor: _ctx.getBackgroundColorValue(slotProps.message.severity) }),
				name: _ctx.getImageName(slotProps.message.severity)
			}, null, 8, ["style", "name"]), createElementVNode("span", _hoisted_3, toDisplayString(slotProps.message.summary), 1)]),
			createElementVNode("div", _hoisted_4, [renderSlot(_ctx.$slots, "message", { message: slotProps.message }, () => [createTextVNode(toDisplayString(slotProps.message.detail), 1)], true)]),
			slotProps.message.buttons.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_Divider, { class: "toast-divider" }), createElementVNode("div", _hoisted_5, [createVNode(_component_HorizontalLayout, {
				wrap: false,
				align: "right",
				space: _ctx.buttonContainerSpace
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(slotProps.message.buttons, (button, index) => {
					return openBlock(), createBlock(_component_Button, {
						key: index,
						class: normalizeClass(["toast-button", _ctx.getButtonClasses(index, slotProps.message.severity)]),
						icon: button.icon,
						label: button.text,
						animated: "",
						onClick: button.action
					}, null, 8, [
						"class",
						"icon",
						"label",
						"onClick"
					]);
				}), 128))]),
				_: 2
			}, 1032, ["space"])])], 64)) : createCommentVNode("", true),
			slotProps.message.progressBarValue ? (openBlock(), createElementBlock("div", {
				key: 1,
				class: "p-toast-progress-bar",
				style: normalizeStyle({ backgroundColor: _ctx.getBackgroundColorValue(slotProps.message.severity) })
			}, [createElementVNode("div", {
				class: "p-toast-progress-bar-value",
				style: normalizeStyle({ width: slotProps.message.progressBarValue + "%" })
			}, null, 4)], 4)) : createCommentVNode("", true)
		])]),
		_: 3
	}, 8, [
		"position",
		"group",
		"pt"
	]);
}
var Toast_default = /* @__PURE__ */ _plugin_vue_export_helper_default(Toast_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$1], ["__scopeId", "data-v-24ce5cf2"]]);
//#endregion
//#region src/components/TreeView/TreeViewConfig.ts
var TreeViewConfigKey = Symbol("TreeViewConfig");
function useTreeViewConfig() {
	const config = inject(TreeViewConfigKey);
	if (!config) throw new Error("Tree view configuration not provided.");
	return config;
}
//#endregion
//#region src/components/TreeViewNode/TreeViewNode.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = ["draggable"];
var _hoisted_2$1 = {
	key: 0,
	class: "tree-view-child-nodes"
};
//#endregion
//#region src/components/TreeView/TreeView.ts?vue&type=script&src=true&lang.ts
var TreeView_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "TreeView",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		TreeViewNode: /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
			__name: "TreeViewNode",
			props: {
				level: {},
				node: {},
				nodeClick: {},
				nodeCollapse: {},
				nodeDragover: {},
				nodeDragstart: {},
				nodeDrop: {},
				nodeExpand: {},
				parentNode: { default: void 0 }
			},
			setup(__props) {
				const props = __props;
				const config = useTreeViewConfig();
				const caption = computed(() => getPropertyByPath(props.node, config.captionProperty));
				const childNodesLineStyle = computed(() => ({ left: `${padding.value + 5}px` }));
				const children = computed(() => getPropertyByPath(props.node, config.childrenProperty));
				const dropInstruction = computed(() => config.currentDragContext.value?.dropNode === props.node ? config.currentDragContext.value.instruction : void 0);
				const expanded = computed(() => getPropertyByPath(props.node, config.expandedProperty));
				const draggable = computed(() => getPropertyByPath(props.node, config.draggableProperty));
				const dropIndicatorStyle = computed(() => ({
					left: `${6 * (props.level + 1)}px`,
					top: dropInstruction.value === "before" ? "-1px" : void 0,
					bottom: dropInstruction.value === "after" ? "-1px" : void 0
				}));
				const hasBeenExpanded = ref(expanded.value);
				const icon = computed(() => getPropertyByPath(props.node, config.iconProperty));
				const nodeClass = computed(() => ({
					"tree-view-node-selected": getPropertyByPath(props.node, config.selectedProperty),
					"tree-view-node-drag": config.currentDragContext.value?.draggedNode === props.node,
					"tree-view-node-drop": dropInstruction.value === "make-child",
					"tree-view-node-drop-parent-hint": dropInstruction.value === void 0 && config.currentDragContext.value?.newParentNode === props.node
				}));
				const nodeStyle = computed(() => ({ paddingLeft: `${padding.value}px` }));
				const padding = computed(() => 16 * props.level + (!getPropertyByPath(props.node, config.childrenProperty) ? 18 : 0));
				const showDropIndicator = computed(() => dropInstruction.value === "before" || dropInstruction.value === "after");
				const loading = computed(() => getPropertyByPath(props.node, config.loadingProperty));
				const toggleIcon = computed(() => {
					return getPropertyByPath(props.node, config.expandedProperty) ? "chevronDown" : "chevronRight";
				});
				const visible = computed(() => getPropertyByPath(props.node, config.visibleProperty) !== false);
				watch(expanded, (value) => {
					if (value) hasBeenExpanded.value = true;
				});
				function handleDragend() {
					config.currentDragContext.value = void 0;
				}
				function handleDragover(event) {
					props.nodeDragover(event, props.node, props.parentNode);
				}
				function handleDrop() {
					props.nodeDrop(props.node);
				}
				function handleToggle() {
					if (getPropertyByPath(props.node, config.expandedProperty)) props.nodeCollapse(props.node);
					else props.nodeExpand(props.node);
				}
				return (_ctx, _cache) => {
					const _component_TreeViewNode = resolveComponent("TreeViewNode", true);
					return visible.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("button", {
						class: normalizeClass(["tree-view-node neos-horizontal-content", nodeClass.value]),
						draggable: draggable.value,
						style: normalizeStyle(nodeStyle.value),
						onClick: _cache[1] || (_cache[1] = ($event) => __props.nodeClick(__props.node)),
						onDragstart: _cache[2] || (_cache[2] = ($event) => __props.nodeDragstart(__props.node, __props.parentNode)),
						onDragover: handleDragover,
						onDragend: handleDragend,
						onDrop: handleDrop
					}, [
						children.value ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: "tree-view-node-toggle-button",
							onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleToggle(), ["stop"]))
						}, [loading.value ? (openBlock(), createBlock(Spinner_default, {
							key: 0,
							size: "extrasmall"
						})) : (openBlock(), createBlock(Image_default, {
							key: 1,
							name: toggleIcon.value,
							size: "extrasmall"
						}, null, 8, ["name"]))])) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "node", { context: __props.node }, () => [createVNode(HorizontalLayout_default, null, {
							default: withCtx(() => [createVNode(Image_default, {
								name: icon.value,
								class: "tree-view-node-icon"
							}, null, 8, ["name"]), createVNode(Text_default, { class: "tree-view-node-caption" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(caption.value), 1)]),
								_: 1
							})]),
							_: 1
						})], true),
						showDropIndicator.value ? (openBlock(), createElementBlock("div", {
							key: 1,
							class: "tree-view-node-drop-indicator",
							style: normalizeStyle(dropIndicatorStyle.value)
						}, null, 4)) : createCommentVNode("", true)
					], 46, _hoisted_1$1), children.value && hasBeenExpanded.value ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$1, [createElementVNode("div", {
						class: "tree-view-child-nodes-line",
						style: normalizeStyle(childNodesLineStyle.value)
					}, null, 4), (openBlock(true), createElementBlock(Fragment, null, renderList(children.value, (childNode) => {
						return openBlock(), createBlock(_component_TreeViewNode, {
							level: __props.level + 1,
							node: childNode,
							"parent-node": __props.node,
							"node-expand": __props.nodeExpand,
							"node-collapse": __props.nodeCollapse,
							"node-click": __props.nodeClick,
							"node-dragstart": __props.nodeDragstart,
							"node-dragover": __props.nodeDragover,
							"node-drop": __props.nodeDrop
						}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
							name: "node",
							fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
							key: "0"
						} : void 0]), 1032, [
							"level",
							"node",
							"parent-node",
							"node-expand",
							"node-collapse",
							"node-click",
							"node-dragstart",
							"node-dragover",
							"node-drop"
						]);
					}), 256))], 512)), [[vShow, expanded.value]]) : createCommentVNode("", true)], 64)) : createCommentVNode("", true);
				};
			}
		}), [["__scopeId", "data-v-ee231c4f"]])
	},
	props: {
		source: {
			type: Array,
			default: () => []
		},
		captionProperty: {
			type: String,
			default: ""
		},
		iconProperty: {
			type: String,
			default: ""
		},
		childrenProperty: {
			type: String,
			default: ""
		},
		loadingProperty: {
			type: String,
			default: "$loading"
		},
		loadedProperty: {
			type: String,
			default: "$loaded"
		},
		selectedProperty: {
			type: String,
			default: "$selected"
		},
		expandedProperty: {
			type: String,
			default: "$expanded"
		},
		visibleProperty: {
			type: String,
			default: "$visible"
		},
		draggableProperty: {
			type: String,
			default: "$draggable"
		},
		nodeColor: {
			type: String,
			default: void 0
		},
		nodeBackground: {
			type: String,
			default: void 0
		},
		nodeHoverColor: {
			type: String,
			default: void 0
		},
		nodeHoverBackground: {
			type: String,
			default: void 0
		},
		activeNodeColor: {
			type: String,
			default: void 0
		},
		activeNodeHoverColor: {
			type: String,
			default: void 0
		},
		activeNodeBackground: {
			type: String,
			default: void 0
		},
		activeNodeHoverBackground: {
			type: String,
			default: void 0
		},
		nodeLoad: {
			type: Function,
			default: void 0
		},
		nodeExpand: {
			type: Function,
			default: void 0
		},
		nodeCollapse: {
			type: Function,
			default: void 0
		},
		nodeClick: {
			type: Function,
			default: void 0
		},
		nodeDragover: {
			type: Function,
			default: void 0
		},
		nodeDrop: {
			type: Function,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		const currentDragContext = ref();
		provide(TreeViewConfigKey, {
			captionProperty: props.captionProperty,
			iconProperty: props.iconProperty,
			childrenProperty: props.childrenProperty,
			loadingProperty: props.loadingProperty,
			loadedProperty: props.loadedProperty,
			selectedProperty: props.selectedProperty,
			expandedProperty: props.expandedProperty,
			visibleProperty: props.visibleProperty,
			draggableProperty: props.draggableProperty,
			currentDragContext
		});
		const setStyleValue = (styleObj, key, value) => {
			if (value) styleObj[`--${key}`] = `var(--${value})`;
		};
		const style = computed(() => {
			const styleValue = {};
			setStyleValue(styleValue, "vertical-space", "0");
			setStyleValue(styleValue, "tree-view-node-foreground", props.nodeColor);
			setStyleValue(styleValue, "tree-view-node-background", props.nodeBackground);
			setStyleValue(styleValue, "tree-view-node-hover-foreground", props.nodeHoverColor);
			setStyleValue(styleValue, "tree-view-node-hover-background", props.nodeHoverBackground);
			setStyleValue(styleValue, "tree-view-node-active-foreground", props.activeNodeColor);
			setStyleValue(styleValue, "tree-view-node-active-background", props.activeNodeBackground);
			setStyleValue(styleValue, "tree-view-node-active-hover-foreground", props.activeNodeHoverColor);
			setStyleValue(styleValue, "tree-view-node-active-hover-background", props.activeNodeHoverBackground);
			return styleValue;
		});
		async function handleNodeExpand(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			if (!getPropertyByPath(node, props.loadedProperty)) {
				if (props.nodeLoad) try {
					setPropertyByPath(node, props.loadingProperty, true);
					await props.nodeLoad(node);
				} finally {
					setPropertyByPath(node, props.loadingProperty, false);
				}
				setPropertyByPath(node, props.loadedProperty, true);
			}
			expandNode(node);
		}
		function handleNodeCollapse(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			collapseNode(node);
		}
		function handleNodeClick(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			props.nodeClick?.(node);
		}
		function handleNodeDragstart(node, parentNode) {
			currentDragContext.value = {
				draggedNode: node,
				parentNode,
				expandedBeforeDrag: !!node[props.expandedProperty]
			};
			if (currentDragContext.value.expandedBeforeDrag) collapseNode(node);
		}
		function handleNodeDragover(event, node, parentNode) {
			if (!currentDragContext.value || node === currentDragContext.value.draggedNode) return;
			const newInstruction = getDropInstruction(event);
			if (currentDragContext.value.dropNode === node && currentDragContext.value.instruction === newInstruction) {
				event.preventDefault();
				return;
			}
			currentDragContext.value.instruction = newInstruction;
			if (currentDragContext.value.instruction === "make-child") {
				currentDragContext.value.newIndex = getChildren(node)?.length ?? 0;
				currentDragContext.value.newParentNode = node;
			} else {
				currentDragContext.value.newParentNode = parentNode;
				currentDragContext.value.newIndex = getDropNewIndex(currentDragContext.value, node);
			}
			if (!props.nodeDragover || props.nodeDragover(currentDragContext.value)) {
				currentDragContext.value.dropNode = node;
				event.preventDefault();
			}
		}
		function handleNodeDrop() {
			if (!currentDragContext.value || !props.nodeDrop) {
				currentDragContext.value = void 0;
				return;
			}
			props.nodeDrop(currentDragContext.value);
			if (currentDragContext.value.newParentNode && !currentDragContext.value.newParentNode[props.expandedProperty]) expandNode(currentDragContext.value.newParentNode);
			if (currentDragContext.value.expandedBeforeDrag) expandNode(currentDragContext.value.draggedNode);
		}
		function collapseNode(node) {
			setPropertyByPath(node, props.expandedProperty, false);
			props.nodeCollapse?.(node);
		}
		function expandNode(node) {
			setPropertyByPath(node, props.expandedProperty, true);
			props.nodeExpand?.(node);
		}
		function getDropInstruction(event) {
			const borderBox = event.currentTarget.getBoundingClientRect();
			const quarterOfHeight = borderBox.height / 4;
			if (event.clientY <= borderBox.top + quarterOfHeight) return "before";
			if (event.clientY >= borderBox.bottom - quarterOfHeight) return "after";
			return "make-child";
		}
		function getDropNewIndex(dragContext, node) {
			const list = dragContext.newParentNode ? getChildren(dragContext.newParentNode) : props.source;
			let newIndex = list.indexOf(node);
			if (dragContext.newParentNode === dragContext.parentNode) {
				const oldIndex = list.indexOf(dragContext.draggedNode);
				if (oldIndex !== -1 && oldIndex < newIndex) newIndex--;
			}
			if (dragContext.instruction === "after") newIndex++;
			return newIndex;
		}
		function getChildren(node) {
			return getPropertyByPath(node, props.childrenProperty);
		}
		function unselectAllNodes(nodes) {
			for (const node of nodes) {
				if (getPropertyByPath(node, props.selectedProperty)) setPropertyByPath(node, props.selectedProperty, false);
				const children = getChildren(node);
				if (children) unselectAllNodes(children);
			}
		}
		return {
			style,
			handleNodeExpand,
			handleNodeCollapse,
			handleNodeClick,
			handleNodeDragstart,
			handleNodeDragover,
			handleNodeDrop
		};
	}
});
//#endregion
//#region src/components/TreeView/TreeView.vue
var _hoisted_1 = { class: "neos-fill-parent-height" };
var _hoisted_2 = { class: "tree-view-nodes" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_TreeViewNode = resolveComponent("TreeViewNode");
	return openBlock(), createElementBlock("div", {
		class: "neos-vertical-content tree-view",
		style: normalizeStyle(_ctx.style)
	}, [_ctx.$slots.header ? (openBlock(), createBlock(_component_HorizontalLayout, {
		key: 0,
		space: "extrasmall",
		class: "tree-view-header"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
		_: 3
	})) : createCommentVNode("", true), createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.source, (node, __, ___, _cached) => {
		const _memo = [node, _ctx.$slots.node];
		if (_cached && _cached.el && isMemoSame(_cached, _memo)) return _cached;
		const _item = (openBlock(), createBlock(_component_TreeViewNode, {
			level: 0,
			node,
			"node-expand": _ctx.handleNodeExpand,
			"node-collapse": _ctx.handleNodeCollapse,
			"node-click": _ctx.handleNodeClick,
			"node-dragstart": _ctx.handleNodeDragstart,
			"node-dragover": _ctx.handleNodeDragover,
			"node-drop": _ctx.handleNodeDrop
		}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
			name: "node",
			fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
			key: "0"
		} : void 0]), 1032, [
			"node",
			"node-expand",
			"node-collapse",
			"node-click",
			"node-dragstart",
			"node-dragover",
			"node-drop"
		]));
		_item.memo = _memo;
		return _item;
	}, _cache, 0), 256))])])], 4);
}
var TreeView_default = /* @__PURE__ */ _plugin_vue_export_helper_default(TreeView_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render], ["__scopeId", "data-v-d10fe5cb"]]);
//#endregion
//#region src/composables/usePressEvents.ts
var LONG_PRESS_DELAY = 500;
function usePressEvents(handlers) {
	let pressTimer = null;
	let longPressTriggered = false;
	function onPressStart() {
		longPressTriggered = false;
		pressTimer = setTimeout(() => {
			longPressTriggered = true;
			handlers.onLongPress?.();
		}, LONG_PRESS_DELAY);
	}
	function onPressEnd() {
		clearPressTimer();
		if (longPressTriggered) return;
		handlers.onPress?.();
	}
	function onPressCancel() {
		clearPressTimer();
		longPressTriggered = false;
	}
	function clearPressTimer() {
		if (pressTimer) {
			clearTimeout(pressTimer);
			pressTimer = null;
		}
	}
	onScopeDispose(clearPressTimer);
	return {
		onPressStart,
		onPressEnd,
		onPressCancel
	};
}
//#endregion
//#region src/composables/usePreventPopoverHide.ts
function usePreventPopoverHide() {
	const preventPopoverHide = shallowRef(false);
	function setPreventPopoverHide(value) {
		preventPopoverHide.value = value;
	}
	return {
		preventPopoverHide,
		setPreventPopoverHide
	};
}
//#endregion
//#region src/composables/useToast.ts
function useToast() {
	const toast = useToast$1();
	function add(definition) {
		const message = ref({
			buttons: definition.buttons,
			closable: definition.dismissible,
			detail: definition.text,
			group: definition.group,
			severity: definition.severity,
			summary: definition.title
		});
		if (definition.duration) {
			let currentStep = 0;
			const interval = 50;
			const totalSteps = definition.duration / interval;
			function start() {
				message.value.intervalId = window.setInterval(() => {
					currentStep++;
					message.value.progressBarValue = currentStep / totalSteps * 100;
					if (currentStep >= totalSteps) {
						clearInterval(message.value.intervalId);
						toast.remove(message.value);
					}
				}, interval);
			}
			message.value.start = start;
			start();
		}
		toast.add(message.value);
		return message.value;
	}
	function remove(instance) {
		toast.remove(instance);
	}
	return {
		add,
		remove
	};
}
//#endregion
//#region src/directives/automation.ts
/**
* v-neos-automation directive.
* Used to set node specific automation properties.
*/
var NeosAutomation = { beforeMount(el, binding) {
	if (binding.value) el.dataset[AutomationDirectivePropertyValues[binding.arg]] = binding.value;
} };
//#endregion
//#region src/directives/grid.ts
/**
* If the grid directive is used on a grid layout node, it set associated responsive CSS variable value (see global.css).
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateCellStyle(el, binding) {
	const property = binding.arg;
	const variable = `--grid-${property.startsWith("colspan") ? "column" : "row"}-span${/^[a-z]+(?<responsivePart>-[a-z]*)$/.exec(property)?.groups?.responsivePart ?? ""}`;
	const value = binding.value;
	el.style.setProperty(variable, value);
}
/**
* v-neos-grid directive.
* Used to set columns and rows span on grid layout nodes.
*/
var neosGrid = (el, binding) => updateCellStyle(el, binding);
//#endregion
//#region src/directives/layout.ts
/**
* Fix for elements overflowing outside horizontal and vertical layouts.
* Disabled by default to avoid breaking changes in existing UIs.
* Will be enabled by default in a future major release.
* At some point, this option should be removed and the fix should be always applied.
*/
var layoutOverflowFixOption = false;
/**
* Sets the value indicating whether the fix for elements overflowing outside horizontal and vertical layouts is enabled.
* @param value - Value.
*/
function setLayoutOverflowFixOption(value) {
	layoutOverflowFixOption = value;
}
var sizeValueRegex = /^(?:auto|(?<value>\d+))$/;
var sizeLimitValueRegex = /^(?<value>\d+)$/;
function setSizePropertiesAndClasses(el, property, value) {
	if (value === "fill") {
		if (layoutOverflowFixOption) el.classList.add(`neos-overflow-parent-${property}`);
		el.classList.add(`neos-fill-parent-${property}`);
		el.classList.remove(`neos-fixed-${property}`);
		el.style.setProperty(property, null);
		return;
	}
	const match = sizeValueRegex.exec(value.toString());
	if (match !== null && match.groups) {
		let propertyValue;
		el.classList.remove(`neos-fill-parent-${property}`);
		if (match.groups.value) {
			if (layoutOverflowFixOption) el.classList.add(`neos-overflow-parent-${property}`);
			el.classList.add(`neos-fixed-${property}`);
			propertyValue = `${match.groups.value}px`;
		} else {
			el.classList.remove(`neos-overflow-parent-${property}`);
			propertyValue = "auto";
		}
		el.style.setProperty(property, propertyValue);
	}
}
function setMinMaxSizeProperties(el, property, value) {
	const match = sizeLimitValueRegex.exec(value.toString());
	if (match !== null && match.groups) el.style.setProperty(property, `${match.groups.value}px`);
	else el.style.removeProperty(property);
}
function setSpaceProperties(el, property, value) {
	const values = getMultiSpaceValue(value);
	if (values.length > 0) el.style.setProperty(property, values);
	else el.style.removeProperty(property);
}
function setAlignementClass(el, property, value) {
	const validValues = property === LayoutDirectiveProperty.alignSelfHorizontal ? [
		"left",
		"right",
		"center",
		"stretch"
	] : [
		"top",
		"bottom",
		"center",
		"stretch"
	];
	if (validValues.includes(value)) {
		el.classList.add(`neos-${property}-${value}`);
		validValues.filter((v) => v !== value).forEach((v) => el.classList.remove(`neos-${property}-${v}`));
	}
}
function setVisibilityStyle(el, value) {
	el.style.setProperty("visibility", value === "hidden" ? "hidden" : "");
	el.style.setProperty("display", value === "collapsed" ? "none" : "");
}
function updateElementStylesAndClasses(el, property, value) {
	if (isSizeProperty(property)) setSizePropertiesAndClasses(el, property, value);
	else if (isMinMaxSizeProperty(property)) setMinMaxSizeProperties(el, property, value);
	else if (isSpaceProperty(property)) {
		if (property === LayoutDirectiveProperty.margin && el.classList.contains("button-animated")) value = value.toString().replaceAll("none", "extrasmall");
		setSpaceProperties(el, property, value.toString());
	} else if (isAlignementProperty(property)) setAlignementClass(el, property, value.toString());
	else if (property === LayoutDirectiveProperty.visibility) setVisibilityStyle(el, value.toString());
}
function isSizeProperty(property) {
	return property === LayoutDirectiveProperty.height || property === LayoutDirectiveProperty.width;
}
function isMinMaxSizeProperty(property) {
	return property === LayoutDirectiveProperty.minWidth || property === LayoutDirectiveProperty.maxWidth || property === LayoutDirectiveProperty.minHeight || property === LayoutDirectiveProperty.maxHeight;
}
function isSpaceProperty(property) {
	return property === LayoutDirectiveProperty.padding || property === LayoutDirectiveProperty.margin;
}
function isAlignementProperty(property) {
	return property === LayoutDirectiveProperty.alignSelfHorizontal || property === LayoutDirectiveProperty.alignSelfVertical;
}
function updateLayoutStyle(el, binding) {
	updateElementStylesAndClasses(el, binding.arg, binding.value);
}
/**
* v-neos-layout directive.
* Used to apply specific styles on nodes.
*/
var neosLayout = (el, binding) => {
	if (!isAlignementProperty(binding.arg) && (el.classList.contains("action-button") || el.classList.contains("menu-button"))) {
		for (const child of el.children) updateLayoutStyle(child, binding);
		return;
	}
	updateLayoutStyle(el, binding);
};
//#endregion
//#region src/directives/style.ts
/**
* If the style directive is used node, it set associated CSS property value.
*
* REMARK: Deals with with some properties separately from the default case when there isn't
* a simple one-to-one mapping between our abstraction and the name of the CSS property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateNodeStyle(el, binding) {
	const property = binding.arg;
	switch (property) {
		case "border-color":
			if (isBindingValueDefined(binding.value)) {
				el.style.setProperty("border", `1px solid`);
				el.style.setProperty("border-color", getColorValue(binding.value));
			} else {
				el.style.removeProperty("border");
				el.style.removeProperty("border-color");
			}
			break;
		case "corner-radius": {
			const cssProperty = el.classList.contains("button-animated") ? "--p-button-border-radius" : "border-radius";
			if (isBindingValueDefined(binding.value)) setMultiRadiusValue(el, cssProperty, binding.value);
			else el.style.removeProperty(cssProperty);
			break;
		}
		default: {
			const cssProperty = StyleDirectivePropertyValues[property];
			updateSimplyMappedNodeStyle(el, cssProperty, binding);
			break;
		}
	}
}
/**
* If the style directive is used node, it set associated CSS property value.
*
* REMARK: Deals only with the case when there is a simple one-to-one mapping between our abstraction and the name of the CSS property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateSimplyMappedNodeStyle(el, cssProperty, binding) {
	const property = binding.arg;
	switch (property) {
		case "hover-color":
		case "hover-background":
		case "hover-border-color":
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, getColorValue(binding.value));
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		case "hover-font-style":
		case "hover-text-decoration":
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, binding.value);
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		case "hover-font-weight": {
			const weight = WeightValues[binding.value];
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, weight);
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		}
		case "shadow-color":
			if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, `0 0 0.5rem 0.25rem ${getColorValue(binding.value)}`);
			else el.style.removeProperty(cssProperty);
			break;
		case "font-style":
		case "overflow-wrap":
		case "text-align":
		case "text-decoration":
			if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, binding.value);
			else el.style.removeProperty(cssProperty);
			break;
		case "font-weight": {
			const weight = WeightValues[binding.value];
			if (weight != null) el.style.setProperty(cssProperty, weight);
			else el.style.removeProperty(cssProperty);
			break;
		}
		default:
			if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, getColorValue(binding.value));
			else el.style.removeProperty(cssProperty);
			break;
	}
}
function isBindingValueDefined(x) {
	return x != null && x.length > 0;
}
/**
* Sets the HTML node style property with cssPropertyValue if it is a correct multi space attribute value
* (ex: "full", "small medium small large")
*
* @param el - The HTML node.
* @param cssProperty - The CSS property key.
* @param input - The multi space attribute value.
*/
function setMultiRadiusValue(el, cssProperty, input) {
	const values = getMultiRadiusValue(input);
	if (values.length > 0) el.style.setProperty(cssProperty, values);
}
/**
* v-neos-style directive.
* Used to set node specific style.
*/
var neosStyle = (el, binding) => {
	if (el.classList.contains("neos-input")) {
		const nodes = el.querySelectorAll(".neos-input-content, textarea");
		for (const node of nodes) updateNodeStyle(node, binding);
		return;
	}
	if (el.classList.contains("action-button") || el.classList.contains("menu-button")) {
		for (const child of el.children) updateNodeStyle(child, binding);
		return;
	}
	updateNodeStyle(el, binding);
};
//#endregion
//#region src/directives/tooltip.ts
/**
* If the tooltip directive is used node, we set the associated tooltip property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateNodeTooltip(el, binding) {
	if (binding.value != null) el.setAttribute("title", binding.value);
	else el.removeAttribute("title");
}
/**
* v-neos-tooltip directive.
* Used to set node specific tooltip.
*/
var neosTooltip = (el, binding) => {
	updateNodeTooltip(el, binding);
};
//#endregion
//#region src/utils/DatagridCollectionChangedEventArgs.ts
var DatagridCollectionChangedEventArgs = class extends NotifyCollectionChangedEventArgs {
	constructor(action, item, index, col, value, isSuggestionChange) {
		super(action, item, index);
		this.col = col;
		this.value = value;
		this.isSuggestionChange = isSuggestionChange;
	}
};
//#endregion
//#region src/utils/plugin.ts
var wijmoCultures = /* @__PURE__ */ Object.assign({
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.de.js": () => import("./wijmo.culture.de-dkD7RDbd.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-CA.js": () => import("./wijmo.culture.en-CA-DuKe1lS6.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-GB.js": () => import("./wijmo.culture.en-GB-b6sClWIu.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en.js": () => import("./wijmo.culture.en-DkWOZOub.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.es.js": () => import("./wijmo.culture.es-B01OaNy6.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr-CA.js": () => import("./wijmo.culture.fr-CA-BiHp5rCe.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr.js": () => import("./wijmo.culture.fr-BVwefPxB.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.it.js": () => import("./wijmo.culture.it-Dp4iRPU9.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.pt.js": () => import("./wijmo.culture.pt-BoKJlwE8.js")
});
var primeVueLocales = /* @__PURE__ */ Object.assign({
	"./locales/de.json": () => import("./de-BgsYPGRG.js"),
	"./locales/en-GB.json": () => import("./en-GB-HIi0VzOw.js"),
	"./locales/en.json": () => import("./en-Cifc685s.js"),
	"./locales/es.json": () => import("./es-7OZr5EOy.js"),
	"./locales/fr.json": () => import("./fr-C6z5hl7S.js"),
	"./locales/it.json": () => import("./it-DMdHiGAz.js"),
	"./locales/pt.json": () => import("./pt-CWFbkN53.js")
});
var plugin = { async install(app) {
	app.config.globalProperties.$neos = {};
	app.use(PrimeVue);
	app.use(ToastService);
	app.directive("tooltip", Tooltip$1);
} };
var wijmoConfigured = false;
function configureWijmo(key) {
	if (wijmoConfigured) return;
	setLicenseKey(key);
	overrideDatagridCellTemplate();
	overrideDatagridRowDetailTemplate();
	wijmoConfigured = true;
}
function useUILocale(localizator) {
	const primevue = usePrimeVue();
	async function updateUILocale() {
		await Promise.all([importWijmoLocale(localizator), updatePrimeVueLocale(localizator, primevue)]);
	}
	return { updateUILocale };
}
async function importWijmoLocale(localizator) {
	await importLocale(localizator, wijmoCultures, (lang) => `../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.${lang}.js`);
	culture.Globalize.calendar.twoDigitYearMax = twoDigitYearMax;
}
async function updatePrimeVueLocale(localizator, primevue) {
	const locale = (await importPrimeVueLocale(localizator))?.default;
	if (locale) primevue.config.locale = locale?.[Object.keys(locale)[0]];
}
function importPrimeVueLocale(localizator) {
	return importLocale(localizator, primeVueLocales, (lang) => `./locales/${lang}.json`);
}
async function importLocale(localizator, obj, getPath) {
	let fn = obj[getPath(localizator.currentCulture)];
	fn ??= obj[getPath(ResourceManager.getTwoLetterLanguage(localizator.currentCulture))];
	fn ??= obj[getPath(localizator.currentLanguage)];
	fn ??= obj[getPath(localizator.defaultLanguage)];
	return fn?.();
}
/**
* The Wijmo template overrides below rely on private integration points and browser layout
* primitives such as `ResizeObserver`, `requestAnimationFrame`, and live DOM measurements.
* Those interactions are not reproduced reliably in our unit test environment, so this block
* is documented and covered through manual verification instead of automated unit tests.
*/
/**
* Overrides the datagrid cell template definition to propagate the application context
* and the objects provided by the parent components.
*
* The following code comes from the Wijmo source code.
*
* The `$forceUpdate` method has been modified to update the component instead of remounting it.
*/
/* istanbul ignore next -- @preserve */
function overrideDatagridCellTemplate() {
	class V3CellTemplateCmp {
		constructor(props) {
			this.props = props;
			this._host = document.createElement("div");
		}
		$mount() {
			const { parent, ...props } = this.props;
			const vnode = h({
				parent,
				render: () => h("div", props, this.slotFn?.(this.context)),
				setup: () => propagateComponentContext(parent)
			});
			this.$el.innerHTML = "";
			render(vnode, this.$el);
		}
		get $el() {
			return this._host;
		}
		$destroy() {
			render(null, this.$el);
			this._host = null;
		}
		$forceUpdate() {
			if (this._host) {
				const element = this._host.firstChild;
				if (element && element.__vueParentComponent) element.__vueParentComponent.update();
			}
		}
	}
	WjFlexGridCellTemplateDefinition.methods._instantiateTemplate = function(parent, dataContext) {
		const ret = new V3CellTemplateCmp({ parent: this });
		ret.context = dataContext;
		ret.slotFn = this.$slots.default;
		ret.$mount();
		if (parent) parent.append(ret.$el);
		return ret;
	};
}
/**
* Overrides the datagrid detail template definition to propagate the application context
* and the objects provided by the parent components.
*
* This wraps Wijmo's original detail provider creation, replaces the detail cell factory
* to keep row detail height in sync with dynamic content by observing the rendered detail element.
*/
/* istanbul ignore next -- @preserve */
function overrideDatagridRowDetailTemplate() {
	const original = WjFlexGridDetail._wjBehCl.prototype._createControl;
	WjFlexGridDetail._wjBehCl.prototype._createControl = function() {
		const ctrl = original.call(this);
		ctrl.createDetailCell = (row) => {
			const parent = this.parent.component;
			const slotFn = this.component.$slots.default;
			const context = {
				row,
				item: row.dataItem,
				provider: this.control
			};
			const vnode = h({
				parent: this.component,
				render: () => h("div", slotFn?.(context)),
				setup: () => propagateComponentContext(parent)
			});
			const detail = document.createElement("div");
			render(vnode, detail);
			const content = vnode.el;
			const cleanup = watchDynamicDetailHeight(ctrl, row, detail, content ?? detail);
			this._openedComponents.push({
				$el: detail,
				$destroy() {
					cleanup();
					render(null, detail);
				}
			});
			return detail;
		};
		return ctrl;
	};
}
/**
* Observes the rendered detail content and keeps at most one pending height refresh.
*
* The first refresh request is issued immediately, but it only runs once the detail
* element is attached to the DOM. Later content resizes are coalesced through the same path.
*/
/* istanbul ignore next -- @preserve */
function watchDynamicDetailHeight(detailProvider, row, detail, content) {
	detail._neosResizeObserver = new ResizeObserver(() => {
		scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	});
	detail._neosResizeObserver.observe(content);
	scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	return () => {
		const refreshFrame = detail._neosRefreshFrame;
		if (refreshFrame) {
			cancelAnimationFrame(refreshFrame);
			detail._neosRefreshFrame = void 0;
		}
		detail._neosResizeObserver?.disconnect();
		detail._neosResizeObserver = void 0;
	};
}
/**
* Recomputes the detail row height on the next animation frame after Vue and Wijmo have
* both had a chance to flush their DOM updates.
*
* The extra retries cover cases where the detail is mounted before layout produces a
* measurable height, such as deferred child rendering.
*/
/* istanbul ignore next -- @preserve */
function scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount = 0) {
	if (detail._neosRefreshFrame || !detail.isConnected) return;
	detail._neosRefreshFrame = requestAnimationFrame(() => {
		detail._neosRefreshFrame = void 0;
		if (!detail.isConnected) return;
		const detailRow = detailProvider.getDetailRow(row);
		if (!detailRow || detailRow.detail !== detail) return;
		Control.refreshAll(detail);
		const grid = detailProvider.grid;
		const measuredHeight = Math.max(content.scrollHeight, content.getBoundingClientRect().height);
		detailRow.height = measuredHeight + grid._cellPadVert * 2;
		if (measuredHeight === 0 && retryCount < 2) scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount + 1);
	});
}
/**
* It is through the following code that the context is propagated.
*/
/* istanbul ignore next -- @preserve */
function propagateComponentContext(parent) {
	const currentInstance = getCurrentInstance();
	const parentInstance = parent;
	currentInstance.appContext = parentInstance.$.appContext;
	currentInstance.provides = parentInstance.$.provides;
}
//#endregion
export { Aggregate, AiSuggestionIndicator_default as AiSuggestionIndicator, AlignValues, AutomationDirectivePropertyValues, Avatar_default as Avatar, Badge_default as Badge, BooleanCombobox_default as BooleanCombobox, BreakpointValues, Button_default as Button, ButtonsLayout_default as ButtonsLayout, Card_default as Card, Carousel_default as Carousel, Chart_default as Chart, Checkbox_default as Checkbox, Chip_default as Chip, CollectionViewGroup, Combobox_default as Combobox, CornerRadiusValues, DataType, Datagrid_default as Datagrid, DatagridCollectionChangedEventArgs, DatagridCollectionView, DatagridInstance, Divider_default as Divider, DocumentationButton_default as DocumentationButton, Dropdown_default as Dropdown, DropdownMenu_default as DropdownMenu, DropdownMenuItem_default as DropdownMenuItem, DynamicCheckbox_default as DynamicCheckbox, DynamicCombobox_default as DynamicCombobox, GridLayout_default as GridLayout, GroupBox_default as GroupBox, GroupDescription, Heading_default as Heading, HorizontalLayout_default as HorizontalLayout, HtmlViewer_default as HtmlViewer, Image_default as Image, InputColor_default as InputColor, InputDate_default as InputDate, InputDateTime_default as InputDateTime, InputLabel_default as InputLabel, InputLocalizableString_default as InputLocalizableString, InputMask_default as InputMask, InputMessage_default as InputMessage, InputNumber_default as InputNumber, InputNumberCalculable_default as InputNumberCalculable, InputPassword_default as InputPassword, InputTime_default as InputTime, LayoutDirectiveProperty, ListBox_default as ListBox, LoadDataOnScroll_default as LoadDataOnScroll, LoadingOverlay_default as LoadingOverlay, LottieImage_default as LottieImage, MarkdownViewer_default as MarkdownViewer, Message_default as Message, Modal_default as Modal, MultiSelect_default as MultiSelect, NeosAutomation, neosGrid as NeosGrid, neosLayout as NeosLayout, neosStyle as NeosStyle, neosTooltip as NeosTooltip, NotifyCollectionChangedAction, ObservableArray, PaginationBar_default as PaginationBar, Popover_default as Popover, PopoverWithTarget_default as PopoverWithTarget, PrimeDatePicker, ProgressBar_default as ProgressBar, ProgressIndicator_default as ProgressIndicator, PropertyGroupDescription, RadioGroup_default as RadioGroup, ResponsiveDatagridWrapper_default as ResponsiveDatagridWrapper, SortDescription, SpaceValues, Spinner_default as Spinner, Splitter_default as Splitter, SplitterPanel_default as SplitterPanel, StyleDirectivePropertyValues, Switch_default as Switch, TabItem_default as TabItem, Tabs_default as Tabs, Text_default as Text, Textbox_default as Textbox, Timeline_default as Timeline, Toast_default as Toast, TreeView_default as TreeView, VerticalAlignValues, VerticalLayout_default as VerticalLayout, VirtualRepeat, WeightValues, configureWijmo, convertTextAlignToAlignItems, focusExceptOnTouchDevice, focusableElementEmits, focusableElementProps, hideAllPopovers, importLocale, inputEmits, inputProps, isAutomationMode, isDropdownActive, isInDropdown, isSpeechSupported, isTouchDevice, multiSpaceValueValidatorExpression, plugin, provideGlobalResourceManager, provideImages, provideLocalizator, provideThemeManager, setAutomationMode, setLayoutOverflowFixOption, smallTextPropsDefaults, textPropsDefaults, triggerChangeOnActiveInput, useButtonContainerSpace, useComponentAutomationProperties, useFocusableElement, useGlobalResourceManager, useImages, useInput, useLocalizator, useModal, usePressEvents, usePreventPopoverHide, useSpeech, useText, useThemeManager, useToast, useUILocale, validationMessageSeverities };

//# sourceMappingURL=design-system.js.map